//  This file was automatically generated and should not be edited.

export type UpdateArtInput = {
  id: string,
  userId?: string | null,
  createdAt?: string | null,
  title?: string | null,
  inputImage?: string | null,
  s3Image?: S3ObjectInput | null,
  prompt?: string | null,
  revisedPrompt?: string | null,
  subject?: string | null,
  subjectText?: string | null,
  subOption?: string | null,
  styles?: string | null,
  stylesText?: string | null,
  color?: string | null,
  colorText?: string | null,
  medium?: string | null,
  mediumText?: string | null,
  model?: string | null,
  feeling?: string | null,
  feelingText?: string | null,
  like?: boolean | null,
  approve?: boolean | null,
  deleted?: boolean | null,
};

export type S3ObjectInput = {
  bucket: string,
  region: string,
  key: string,
};

export type ModelArtConditionInput = {
  userId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  title?: ModelStringInput | null,
  inputImage?: ModelStringInput | null,
  prompt?: ModelStringInput | null,
  revisedPrompt?: ModelStringInput | null,
  subject?: ModelStringInput | null,
  subjectText?: ModelStringInput | null,
  subOption?: ModelStringInput | null,
  styles?: ModelStringInput | null,
  stylesText?: ModelStringInput | null,
  color?: ModelStringInput | null,
  colorText?: ModelStringInput | null,
  medium?: ModelStringInput | null,
  mediumText?: ModelStringInput | null,
  model?: ModelStringInput | null,
  feeling?: ModelStringInput | null,
  feelingText?: ModelStringInput | null,
  like?: ModelBooleanInput | null,
  approve?: ModelBooleanInput | null,
  deleted?: ModelBooleanInput | null,
  and?: Array< ModelArtConditionInput | null > | null,
  or?: Array< ModelArtConditionInput | null > | null,
  not?: ModelArtConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type Art = {
  __typename: "Art",
  id: string,
  userId: string,
  createdAt: string,
  user?: User | null,
  title?: string | null,
  inputImage?: string | null,
  s3Image?: S3Object | null,
  prompt?: string | null,
  revisedPrompt?: string | null,
  subject?: string | null,
  subjectText?: string | null,
  subOption?: string | null,
  styles?: string | null,
  stylesText?: string | null,
  color?: string | null,
  colorText?: string | null,
  medium?: string | null,
  mediumText?: string | null,
  model?: string | null,
  feeling?: string | null,
  feelingText?: string | null,
  like?: boolean | null,
  approve?: boolean | null,
  deleted?: boolean | null,
  updatedAt: string,
};

export type User = {
  __typename: "User",
  id: string,
  email: string,
  username?: string | null,
  emailVerified?: boolean | null,
  identityId?: string | null,
  credits?: number | null,
  boughtCredits?: number | null,
  creditPurchases?: ModelCreditPurchaseConnection | null,
  orders?: ModelOrderConnection | null,
  stripeCustomerId?: string | null,
  owner?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelCreditPurchaseConnection = {
  __typename: "ModelCreditPurchaseConnection",
  items:  Array<CreditPurchase | null >,
  nextToken?: string | null,
};

export type CreditPurchase = {
  __typename: "CreditPurchase",
  id: string,
  createdAt: string,
  user?: User | null,
  creditAmount?: number | null,
  checkoutSessionId: string,
  paymentIntentId?: string | null,
  owner?: string | null,
  updatedAt: string,
  userCreditPurchasesId?: string | null,
};

export type ModelOrderConnection = {
  __typename: "ModelOrderConnection",
  items:  Array<Order | null >,
  nextToken?: string | null,
};

export type Order = {
  __typename: "Order",
  id: string,
  createdAt: string,
  user?: User | null,
  stripeCustomerId?: string | null,
  invoiceNumber?: string | null,
  invoiceId?: string | null,
  receiptNumber?: string | null,
  cart?: Cart | null,
  email: string,
  status?: string | null,
  cost_total?: number | null,
  cost_taxes?: number | null,
  cost_shipping?: number | null,
  couponId?: string | null,
  coupon_amount_off?: number | null,
  coupon_name?: string | null,
  discountId?: string | null,
  discount_amount?: number | null,
  promotionID?: string | null,
  promotion_code?: string | null,
  fulfillment_tracking_id?: string | null,
  fulfillment_method?: string | null,
  fulfillment_status?: string | null,
  fulfillment_createdAt?: string | null,
  fulfillment_updatedAt?: string | null,
  fulfillment_completedAt?: string | null,
  billing_name?: string | null,
  billing_address?: string | null,
  billing_address2?: string | null,
  billing_city?: string | null,
  billing_state?: string | null,
  billing_zip?: string | null,
  billing_country?: string | null,
  shipping_name?: string | null,
  shipping_address?: string | null,
  shipping_address2?: string | null,
  shipping_city?: string | null,
  shipping_state?: string | null,
  shipping_zip?: string | null,
  shipping_country?: string | null,
  shipping_phone?: string | null,
  notes?: string | null,
  vendor?: string | null,
  order_source?: string | null,
  currency?: string | null,
  cancel?: boolean | null,
  updatedAt: string,
  userOrdersId?: string | null,
  orderCartId?: string | null,
};

export type Cart = {
  __typename: "Cart",
  id: string,
  createdAt: string,
  order?: Order | null,
  artOrders?: ModelartOrderConnection | null,
  email: string,
  status?: string | null,
  cost_total?: number | null,
  updatedAt: string,
  cartOrderId?: string | null,
};

export type ModelartOrderConnection = {
  __typename: "ModelartOrderConnection",
  items:  Array<artOrder | null >,
  nextToken?: string | null,
};

export type artOrder = {
  __typename: "artOrder",
  id: string,
  createdAt: string,
  cart?: Cart | null,
  orderID?: string | null,
  art?: Art | null,
  email: string,
  file?: S3Object | null,
  dpi?: number | null,
  length?: number | null,
  width?: number | null,
  resolution_length?: number | null,
  resolution_width?: number | null,
  paper?: string | null,
  frame?: boolean | null,
  moulding?: string | null,
  moulding_finish?: string | null,
  mount?: string | null,
  total?: number | null,
  tax?: number | null,
  updatedAt: string,
  cartArtOrdersId?: string | null,
  artOrderArtId?: string | null,
};

export type S3Object = {
  __typename: "S3Object",
  bucket: string,
  region: string,
  key: string,
};

export type ModelArtFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  title?: ModelStringInput | null,
  inputImage?: ModelStringInput | null,
  prompt?: ModelStringInput | null,
  revisedPrompt?: ModelStringInput | null,
  subject?: ModelStringInput | null,
  subjectText?: ModelStringInput | null,
  subOption?: ModelStringInput | null,
  styles?: ModelStringInput | null,
  stylesText?: ModelStringInput | null,
  color?: ModelStringInput | null,
  colorText?: ModelStringInput | null,
  medium?: ModelStringInput | null,
  mediumText?: ModelStringInput | null,
  model?: ModelStringInput | null,
  feeling?: ModelStringInput | null,
  feelingText?: ModelStringInput | null,
  like?: ModelBooleanInput | null,
  approve?: ModelBooleanInput | null,
  deleted?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelArtFilterInput | null > | null,
  or?: Array< ModelArtFilterInput | null > | null,
  not?: ModelArtFilterInput | null,
};

export type ModelArtConnection = {
  __typename: "ModelArtConnection",
  items:  Array<Art | null >,
  nextToken?: string | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelOrderFilterInput = {
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  stripeCustomerId?: ModelStringInput | null,
  invoiceNumber?: ModelStringInput | null,
  invoiceId?: ModelStringInput | null,
  receiptNumber?: ModelStringInput | null,
  email?: ModelStringInput | null,
  status?: ModelStringInput | null,
  cost_total?: ModelFloatInput | null,
  cost_taxes?: ModelFloatInput | null,
  cost_shipping?: ModelFloatInput | null,
  couponId?: ModelStringInput | null,
  coupon_amount_off?: ModelFloatInput | null,
  coupon_name?: ModelStringInput | null,
  discountId?: ModelStringInput | null,
  discount_amount?: ModelFloatInput | null,
  promotionID?: ModelStringInput | null,
  promotion_code?: ModelStringInput | null,
  fulfillment_tracking_id?: ModelStringInput | null,
  fulfillment_method?: ModelStringInput | null,
  fulfillment_status?: ModelStringInput | null,
  fulfillment_createdAt?: ModelStringInput | null,
  fulfillment_updatedAt?: ModelStringInput | null,
  fulfillment_completedAt?: ModelStringInput | null,
  billing_name?: ModelStringInput | null,
  billing_address?: ModelStringInput | null,
  billing_address2?: ModelStringInput | null,
  billing_city?: ModelStringInput | null,
  billing_state?: ModelStringInput | null,
  billing_zip?: ModelStringInput | null,
  billing_country?: ModelStringInput | null,
  shipping_name?: ModelStringInput | null,
  shipping_address?: ModelStringInput | null,
  shipping_address2?: ModelStringInput | null,
  shipping_city?: ModelStringInput | null,
  shipping_state?: ModelStringInput | null,
  shipping_zip?: ModelStringInput | null,
  shipping_country?: ModelStringInput | null,
  shipping_phone?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  vendor?: ModelStringInput | null,
  order_source?: ModelStringInput | null,
  currency?: ModelStringInput | null,
  cancel?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelOrderFilterInput | null > | null,
  or?: Array< ModelOrderFilterInput | null > | null,
  not?: ModelOrderFilterInput | null,
  userOrdersId?: ModelIDInput | null,
  orderCartId?: ModelIDInput | null,
};

export type ModelFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelUserFilterInput = {
  id?: ModelIDInput | null,
  email?: ModelStringInput | null,
  username?: ModelStringInput | null,
  emailVerified?: ModelBooleanInput | null,
  identityId?: ModelStringInput | null,
  credits?: ModelIntInput | null,
  boughtCredits?: ModelIntInput | null,
  stripeCustomerId?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUserFilterInput | null > | null,
  or?: Array< ModelUserFilterInput | null > | null,
  not?: ModelUserFilterInput | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelUserConnection = {
  __typename: "ModelUserConnection",
  items:  Array<User | null >,
  nextToken?: string | null,
};

export type ModelStringKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type CreateOrderInput = {
  id?: string | null,
  createdAt?: string | null,
  stripeCustomerId?: string | null,
  invoiceNumber?: string | null,
  invoiceId?: string | null,
  receiptNumber?: string | null,
  email: string,
  status?: string | null,
  cost_total?: number | null,
  cost_taxes?: number | null,
  cost_shipping?: number | null,
  couponId?: string | null,
  coupon_amount_off?: number | null,
  coupon_name?: string | null,
  discountId?: string | null,
  discount_amount?: number | null,
  promotionID?: string | null,
  promotion_code?: string | null,
  fulfillment_tracking_id?: string | null,
  fulfillment_method?: string | null,
  fulfillment_status?: string | null,
  fulfillment_createdAt?: string | null,
  fulfillment_updatedAt?: string | null,
  fulfillment_completedAt?: string | null,
  billing_name?: string | null,
  billing_address?: string | null,
  billing_address2?: string | null,
  billing_city?: string | null,
  billing_state?: string | null,
  billing_zip?: string | null,
  billing_country?: string | null,
  shipping_name?: string | null,
  shipping_address?: string | null,
  shipping_address2?: string | null,
  shipping_city?: string | null,
  shipping_state?: string | null,
  shipping_zip?: string | null,
  shipping_country?: string | null,
  shipping_phone?: string | null,
  notes?: string | null,
  vendor?: string | null,
  order_source?: string | null,
  currency?: string | null,
  cancel?: boolean | null,
  userOrdersId?: string | null,
  orderCartId?: string | null,
};

export type ModelOrderConditionInput = {
  createdAt?: ModelStringInput | null,
  stripeCustomerId?: ModelStringInput | null,
  invoiceNumber?: ModelStringInput | null,
  invoiceId?: ModelStringInput | null,
  receiptNumber?: ModelStringInput | null,
  email?: ModelStringInput | null,
  status?: ModelStringInput | null,
  cost_total?: ModelFloatInput | null,
  cost_taxes?: ModelFloatInput | null,
  cost_shipping?: ModelFloatInput | null,
  couponId?: ModelStringInput | null,
  coupon_amount_off?: ModelFloatInput | null,
  coupon_name?: ModelStringInput | null,
  discountId?: ModelStringInput | null,
  discount_amount?: ModelFloatInput | null,
  promotionID?: ModelStringInput | null,
  promotion_code?: ModelStringInput | null,
  fulfillment_tracking_id?: ModelStringInput | null,
  fulfillment_method?: ModelStringInput | null,
  fulfillment_status?: ModelStringInput | null,
  fulfillment_createdAt?: ModelStringInput | null,
  fulfillment_updatedAt?: ModelStringInput | null,
  fulfillment_completedAt?: ModelStringInput | null,
  billing_name?: ModelStringInput | null,
  billing_address?: ModelStringInput | null,
  billing_address2?: ModelStringInput | null,
  billing_city?: ModelStringInput | null,
  billing_state?: ModelStringInput | null,
  billing_zip?: ModelStringInput | null,
  billing_country?: ModelStringInput | null,
  shipping_name?: ModelStringInput | null,
  shipping_address?: ModelStringInput | null,
  shipping_address2?: ModelStringInput | null,
  shipping_city?: ModelStringInput | null,
  shipping_state?: ModelStringInput | null,
  shipping_zip?: ModelStringInput | null,
  shipping_country?: ModelStringInput | null,
  shipping_phone?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  vendor?: ModelStringInput | null,
  order_source?: ModelStringInput | null,
  currency?: ModelStringInput | null,
  cancel?: ModelBooleanInput | null,
  and?: Array< ModelOrderConditionInput | null > | null,
  or?: Array< ModelOrderConditionInput | null > | null,
  not?: ModelOrderConditionInput | null,
  updatedAt?: ModelStringInput | null,
  userOrdersId?: ModelIDInput | null,
  orderCartId?: ModelIDInput | null,
};

export type UpdateOrderInput = {
  id: string,
  createdAt?: string | null,
  stripeCustomerId?: string | null,
  invoiceNumber?: string | null,
  invoiceId?: string | null,
  receiptNumber?: string | null,
  email?: string | null,
  status?: string | null,
  cost_total?: number | null,
  cost_taxes?: number | null,
  cost_shipping?: number | null,
  couponId?: string | null,
  coupon_amount_off?: number | null,
  coupon_name?: string | null,
  discountId?: string | null,
  discount_amount?: number | null,
  promotionID?: string | null,
  promotion_code?: string | null,
  fulfillment_tracking_id?: string | null,
  fulfillment_method?: string | null,
  fulfillment_status?: string | null,
  fulfillment_createdAt?: string | null,
  fulfillment_updatedAt?: string | null,
  fulfillment_completedAt?: string | null,
  billing_name?: string | null,
  billing_address?: string | null,
  billing_address2?: string | null,
  billing_city?: string | null,
  billing_state?: string | null,
  billing_zip?: string | null,
  billing_country?: string | null,
  shipping_name?: string | null,
  shipping_address?: string | null,
  shipping_address2?: string | null,
  shipping_city?: string | null,
  shipping_state?: string | null,
  shipping_zip?: string | null,
  shipping_country?: string | null,
  shipping_phone?: string | null,
  notes?: string | null,
  vendor?: string | null,
  order_source?: string | null,
  currency?: string | null,
  cancel?: boolean | null,
  userOrdersId?: string | null,
  orderCartId?: string | null,
};

export type DeleteOrderInput = {
  id: string,
};

export type CreateCartInput = {
  id?: string | null,
  createdAt?: string | null,
  email: string,
  status?: string | null,
  cost_total?: number | null,
  cartOrderId?: string | null,
};

export type ModelCartConditionInput = {
  createdAt?: ModelStringInput | null,
  email?: ModelStringInput | null,
  status?: ModelStringInput | null,
  cost_total?: ModelFloatInput | null,
  and?: Array< ModelCartConditionInput | null > | null,
  or?: Array< ModelCartConditionInput | null > | null,
  not?: ModelCartConditionInput | null,
  updatedAt?: ModelStringInput | null,
  cartOrderId?: ModelIDInput | null,
};

export type UpdateCartInput = {
  id: string,
  createdAt?: string | null,
  email?: string | null,
  status?: string | null,
  cost_total?: number | null,
  cartOrderId?: string | null,
};

export type DeleteCartInput = {
  id: string,
};

export type CreateArtOrderInput = {
  id?: string | null,
  createdAt?: string | null,
  orderID?: string | null,
  email: string,
  file?: S3ObjectInput | null,
  dpi?: number | null,
  length?: number | null,
  width?: number | null,
  resolution_length?: number | null,
  resolution_width?: number | null,
  paper?: string | null,
  frame?: boolean | null,
  moulding?: string | null,
  moulding_finish?: string | null,
  mount?: string | null,
  total?: number | null,
  tax?: number | null,
  cartArtOrdersId?: string | null,
  artOrderArtId?: string | null,
};

export type ModelArtOrderConditionInput = {
  createdAt?: ModelStringInput | null,
  orderID?: ModelIDInput | null,
  email?: ModelStringInput | null,
  dpi?: ModelIntInput | null,
  length?: ModelIntInput | null,
  width?: ModelIntInput | null,
  resolution_length?: ModelIntInput | null,
  resolution_width?: ModelIntInput | null,
  paper?: ModelStringInput | null,
  frame?: ModelBooleanInput | null,
  moulding?: ModelStringInput | null,
  moulding_finish?: ModelStringInput | null,
  mount?: ModelStringInput | null,
  total?: ModelFloatInput | null,
  tax?: ModelFloatInput | null,
  and?: Array< ModelArtOrderConditionInput | null > | null,
  or?: Array< ModelArtOrderConditionInput | null > | null,
  not?: ModelArtOrderConditionInput | null,
  updatedAt?: ModelStringInput | null,
  cartArtOrdersId?: ModelIDInput | null,
  artOrderArtId?: ModelIDInput | null,
};

export type UpdateArtOrderInput = {
  id: string,
  createdAt?: string | null,
  orderID?: string | null,
  email?: string | null,
  file?: S3ObjectInput | null,
  dpi?: number | null,
  length?: number | null,
  width?: number | null,
  resolution_length?: number | null,
  resolution_width?: number | null,
  paper?: string | null,
  frame?: boolean | null,
  moulding?: string | null,
  moulding_finish?: string | null,
  mount?: string | null,
  total?: number | null,
  tax?: number | null,
  cartArtOrdersId?: string | null,
  artOrderArtId?: string | null,
};

export type DeleteArtOrderInput = {
  id: string,
};

export type CreateArtInput = {
  id?: string | null,
  userId: string,
  createdAt?: string | null,
  title?: string | null,
  inputImage?: string | null,
  s3Image?: S3ObjectInput | null,
  prompt?: string | null,
  revisedPrompt?: string | null,
  subject?: string | null,
  subjectText?: string | null,
  subOption?: string | null,
  styles?: string | null,
  stylesText?: string | null,
  color?: string | null,
  colorText?: string | null,
  medium?: string | null,
  mediumText?: string | null,
  model?: string | null,
  feeling?: string | null,
  feelingText?: string | null,
  like?: boolean | null,
  approve?: boolean | null,
  deleted?: boolean | null,
};

export type DeleteArtInput = {
  id: string,
};

export type CreateUserInput = {
  id?: string | null,
  email: string,
  username?: string | null,
  emailVerified?: boolean | null,
  identityId?: string | null,
  credits?: number | null,
  boughtCredits?: number | null,
  stripeCustomerId?: string | null,
  owner?: string | null,
};

export type ModelUserConditionInput = {
  email?: ModelStringInput | null,
  username?: ModelStringInput | null,
  emailVerified?: ModelBooleanInput | null,
  identityId?: ModelStringInput | null,
  credits?: ModelIntInput | null,
  boughtCredits?: ModelIntInput | null,
  stripeCustomerId?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  and?: Array< ModelUserConditionInput | null > | null,
  or?: Array< ModelUserConditionInput | null > | null,
  not?: ModelUserConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateUserInput = {
  id: string,
  email?: string | null,
  username?: string | null,
  emailVerified?: boolean | null,
  identityId?: string | null,
  credits?: number | null,
  boughtCredits?: number | null,
  stripeCustomerId?: string | null,
  owner?: string | null,
};

export type DeleteUserInput = {
  id: string,
};

export type CreateSessionInput = {
  id?: string | null,
  createdAt?: string | null,
  credentials?: CognitoCredentialsInput | null,
  owner?: string | null,
  sessionUserId?: string | null,
};

export type CognitoCredentialsInput = {
  AccessKeyId?: string | null,
  Expiration?: string | null,
  SecretKey?: string | null,
};

export type ModelSessionConditionInput = {
  createdAt?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  and?: Array< ModelSessionConditionInput | null > | null,
  or?: Array< ModelSessionConditionInput | null > | null,
  not?: ModelSessionConditionInput | null,
  updatedAt?: ModelStringInput | null,
  sessionUserId?: ModelIDInput | null,
};

export type Session = {
  __typename: "Session",
  id: string,
  createdAt: string,
  user?: User | null,
  credentials?: CognitoCredentials | null,
  owner?: string | null,
  updatedAt: string,
  sessionUserId?: string | null,
};

export type CognitoCredentials = {
  __typename: "CognitoCredentials",
  AccessKeyId?: string | null,
  Expiration?: string | null,
  SecretKey?: string | null,
};

export type UpdateSessionInput = {
  id: string,
  createdAt?: string | null,
  credentials?: CognitoCredentialsInput | null,
  owner?: string | null,
  sessionUserId?: string | null,
};

export type DeleteSessionInput = {
  id: string,
};

export type CreateCreditPurchaseInput = {
  id?: string | null,
  createdAt?: string | null,
  creditAmount?: number | null,
  checkoutSessionId: string,
  paymentIntentId?: string | null,
  owner?: string | null,
  userCreditPurchasesId?: string | null,
};

export type ModelCreditPurchaseConditionInput = {
  createdAt?: ModelStringInput | null,
  creditAmount?: ModelIntInput | null,
  checkoutSessionId?: ModelStringInput | null,
  paymentIntentId?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  and?: Array< ModelCreditPurchaseConditionInput | null > | null,
  or?: Array< ModelCreditPurchaseConditionInput | null > | null,
  not?: ModelCreditPurchaseConditionInput | null,
  updatedAt?: ModelStringInput | null,
  userCreditPurchasesId?: ModelIDInput | null,
};

export type UpdateCreditPurchaseInput = {
  id: string,
  createdAt?: string | null,
  creditAmount?: number | null,
  checkoutSessionId?: string | null,
  paymentIntentId?: string | null,
  owner?: string | null,
  userCreditPurchasesId?: string | null,
};

export type DeleteCreditPurchaseInput = {
  id: string,
};

export type CreateGiftCardPurchaseInput = {
  id?: string | null,
  createdAt?: string | null,
  originalBalance?: number | null,
  couponId?: string | null,
  couponAmountOff?: number | null,
  couponCurrency?: string | null,
  couponName?: string | null,
  couponDuration?: string | null,
  couponMaxRedemptions?: number | null,
  promotionCode?: string | null,
  promotionID?: string | null,
  checkoutSessionId: string,
  paymentIntentId?: string | null,
  recipientEmail: string,
  customMessage?: string | null,
};

export type ModelGiftCardPurchaseConditionInput = {
  createdAt?: ModelStringInput | null,
  originalBalance?: ModelIntInput | null,
  couponId?: ModelStringInput | null,
  couponAmountOff?: ModelIntInput | null,
  couponCurrency?: ModelStringInput | null,
  couponName?: ModelStringInput | null,
  couponDuration?: ModelStringInput | null,
  couponMaxRedemptions?: ModelIntInput | null,
  promotionCode?: ModelStringInput | null,
  promotionID?: ModelStringInput | null,
  checkoutSessionId?: ModelStringInput | null,
  paymentIntentId?: ModelStringInput | null,
  recipientEmail?: ModelStringInput | null,
  customMessage?: ModelStringInput | null,
  and?: Array< ModelGiftCardPurchaseConditionInput | null > | null,
  or?: Array< ModelGiftCardPurchaseConditionInput | null > | null,
  not?: ModelGiftCardPurchaseConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type GiftCardPurchase = {
  __typename: "GiftCardPurchase",
  id: string,
  createdAt: string,
  originalBalance?: number | null,
  couponId?: string | null,
  couponAmountOff?: number | null,
  couponCurrency?: string | null,
  couponName?: string | null,
  couponDuration?: string | null,
  couponMaxRedemptions?: number | null,
  promotionCode?: string | null,
  promotionID?: string | null,
  checkoutSessionId: string,
  paymentIntentId?: string | null,
  recipientEmail: string,
  customMessage?: string | null,
  updatedAt: string,
};

export type UpdateGiftCardPurchaseInput = {
  id: string,
  createdAt?: string | null,
  originalBalance?: number | null,
  couponId?: string | null,
  couponAmountOff?: number | null,
  couponCurrency?: string | null,
  couponName?: string | null,
  couponDuration?: string | null,
  couponMaxRedemptions?: number | null,
  promotionCode?: string | null,
  promotionID?: string | null,
  checkoutSessionId?: string | null,
  paymentIntentId?: string | null,
  recipientEmail?: string | null,
  customMessage?: string | null,
};

export type DeleteGiftCardPurchaseInput = {
  id: string,
};

export type ModelCartFilterInput = {
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  email?: ModelStringInput | null,
  status?: ModelStringInput | null,
  cost_total?: ModelFloatInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCartFilterInput | null > | null,
  or?: Array< ModelCartFilterInput | null > | null,
  not?: ModelCartFilterInput | null,
  cartOrderId?: ModelIDInput | null,
};

export type ModelCartConnection = {
  __typename: "ModelCartConnection",
  items:  Array<Cart | null >,
  nextToken?: string | null,
};

export type ModelArtOrderFilterInput = {
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  orderID?: ModelIDInput | null,
  email?: ModelStringInput | null,
  dpi?: ModelIntInput | null,
  length?: ModelIntInput | null,
  width?: ModelIntInput | null,
  resolution_length?: ModelIntInput | null,
  resolution_width?: ModelIntInput | null,
  paper?: ModelStringInput | null,
  frame?: ModelBooleanInput | null,
  moulding?: ModelStringInput | null,
  moulding_finish?: ModelStringInput | null,
  mount?: ModelStringInput | null,
  total?: ModelFloatInput | null,
  tax?: ModelFloatInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelArtOrderFilterInput | null > | null,
  or?: Array< ModelArtOrderFilterInput | null > | null,
  not?: ModelArtOrderFilterInput | null,
  cartArtOrdersId?: ModelIDInput | null,
  artOrderArtId?: ModelIDInput | null,
};

export type ModelArtOrderConnection = {
  __typename: "ModelArtOrderConnection",
  items:  Array<artOrder | null >,
  nextToken?: string | null,
};

export type ModelartOrderFilterInput = {
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  orderID?: ModelIDInput | null,
  email?: ModelStringInput | null,
  dpi?: ModelIntInput | null,
  length?: ModelIntInput | null,
  width?: ModelIntInput | null,
  resolution_length?: ModelIntInput | null,
  resolution_width?: ModelIntInput | null,
  paper?: ModelStringInput | null,
  frame?: ModelBooleanInput | null,
  moulding?: ModelStringInput | null,
  moulding_finish?: ModelStringInput | null,
  mount?: ModelStringInput | null,
  total?: ModelFloatInput | null,
  tax?: ModelFloatInput | null,
  and?: Array< ModelartOrderFilterInput | null > | null,
  or?: Array< ModelartOrderFilterInput | null > | null,
  not?: ModelartOrderFilterInput | null,
};

export type ModelSessionFilterInput = {
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelSessionFilterInput | null > | null,
  or?: Array< ModelSessionFilterInput | null > | null,
  not?: ModelSessionFilterInput | null,
  sessionUserId?: ModelIDInput | null,
};

export type ModelSessionConnection = {
  __typename: "ModelSessionConnection",
  items:  Array<Session | null >,
  nextToken?: string | null,
};

export type ModelCreditPurchaseFilterInput = {
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  creditAmount?: ModelIntInput | null,
  checkoutSessionId?: ModelStringInput | null,
  paymentIntentId?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCreditPurchaseFilterInput | null > | null,
  or?: Array< ModelCreditPurchaseFilterInput | null > | null,
  not?: ModelCreditPurchaseFilterInput | null,
  userCreditPurchasesId?: ModelIDInput | null,
};

export type ModelGiftCardPurchaseFilterInput = {
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  originalBalance?: ModelIntInput | null,
  couponId?: ModelStringInput | null,
  couponAmountOff?: ModelIntInput | null,
  couponCurrency?: ModelStringInput | null,
  couponName?: ModelStringInput | null,
  couponDuration?: ModelStringInput | null,
  couponMaxRedemptions?: ModelIntInput | null,
  promotionCode?: ModelStringInput | null,
  promotionID?: ModelStringInput | null,
  checkoutSessionId?: ModelStringInput | null,
  paymentIntentId?: ModelStringInput | null,
  recipientEmail?: ModelStringInput | null,
  customMessage?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelGiftCardPurchaseFilterInput | null > | null,
  or?: Array< ModelGiftCardPurchaseFilterInput | null > | null,
  not?: ModelGiftCardPurchaseFilterInput | null,
};

export type ModelGiftCardPurchaseConnection = {
  __typename: "ModelGiftCardPurchaseConnection",
  items:  Array<GiftCardPurchase | null >,
  nextToken?: string | null,
};

export type ModelSubscriptionOrderFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  stripeCustomerId?: ModelSubscriptionStringInput | null,
  invoiceNumber?: ModelSubscriptionStringInput | null,
  invoiceId?: ModelSubscriptionStringInput | null,
  receiptNumber?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  cost_total?: ModelSubscriptionFloatInput | null,
  cost_taxes?: ModelSubscriptionFloatInput | null,
  cost_shipping?: ModelSubscriptionFloatInput | null,
  couponId?: ModelSubscriptionStringInput | null,
  coupon_amount_off?: ModelSubscriptionFloatInput | null,
  coupon_name?: ModelSubscriptionStringInput | null,
  discountId?: ModelSubscriptionStringInput | null,
  discount_amount?: ModelSubscriptionFloatInput | null,
  promotionID?: ModelSubscriptionStringInput | null,
  promotion_code?: ModelSubscriptionStringInput | null,
  fulfillment_tracking_id?: ModelSubscriptionStringInput | null,
  fulfillment_method?: ModelSubscriptionStringInput | null,
  fulfillment_status?: ModelSubscriptionStringInput | null,
  fulfillment_createdAt?: ModelSubscriptionStringInput | null,
  fulfillment_updatedAt?: ModelSubscriptionStringInput | null,
  fulfillment_completedAt?: ModelSubscriptionStringInput | null,
  billing_name?: ModelSubscriptionStringInput | null,
  billing_address?: ModelSubscriptionStringInput | null,
  billing_address2?: ModelSubscriptionStringInput | null,
  billing_city?: ModelSubscriptionStringInput | null,
  billing_state?: ModelSubscriptionStringInput | null,
  billing_zip?: ModelSubscriptionStringInput | null,
  billing_country?: ModelSubscriptionStringInput | null,
  shipping_name?: ModelSubscriptionStringInput | null,
  shipping_address?: ModelSubscriptionStringInput | null,
  shipping_address2?: ModelSubscriptionStringInput | null,
  shipping_city?: ModelSubscriptionStringInput | null,
  shipping_state?: ModelSubscriptionStringInput | null,
  shipping_zip?: ModelSubscriptionStringInput | null,
  shipping_country?: ModelSubscriptionStringInput | null,
  shipping_phone?: ModelSubscriptionStringInput | null,
  notes?: ModelSubscriptionStringInput | null,
  vendor?: ModelSubscriptionStringInput | null,
  order_source?: ModelSubscriptionStringInput | null,
  currency?: ModelSubscriptionStringInput | null,
  cancel?: ModelSubscriptionBooleanInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionOrderFilterInput | null > | null,
  or?: Array< ModelSubscriptionOrderFilterInput | null > | null,
  orderCartId?: ModelSubscriptionIDInput | null,
};

export type ModelSubscriptionIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
};

export type ModelSubscriptionCartFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  cost_total?: ModelSubscriptionFloatInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionCartFilterInput | null > | null,
  or?: Array< ModelSubscriptionCartFilterInput | null > | null,
  cartArtOrdersId?: ModelSubscriptionIDInput | null,
  cartOrderId?: ModelSubscriptionIDInput | null,
};

export type ModelSubscriptionArtOrderFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  orderID?: ModelSubscriptionIDInput | null,
  email?: ModelSubscriptionStringInput | null,
  dpi?: ModelSubscriptionIntInput | null,
  length?: ModelSubscriptionIntInput | null,
  width?: ModelSubscriptionIntInput | null,
  resolution_length?: ModelSubscriptionIntInput | null,
  resolution_width?: ModelSubscriptionIntInput | null,
  paper?: ModelSubscriptionStringInput | null,
  frame?: ModelSubscriptionBooleanInput | null,
  moulding?: ModelSubscriptionStringInput | null,
  moulding_finish?: ModelSubscriptionStringInput | null,
  mount?: ModelSubscriptionStringInput | null,
  total?: ModelSubscriptionFloatInput | null,
  tax?: ModelSubscriptionFloatInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionArtOrderFilterInput | null > | null,
  or?: Array< ModelSubscriptionArtOrderFilterInput | null > | null,
  artOrderArtId?: ModelSubscriptionIDInput | null,
};

export type ModelSubscriptionIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionArtFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  title?: ModelSubscriptionStringInput | null,
  inputImage?: ModelSubscriptionStringInput | null,
  prompt?: ModelSubscriptionStringInput | null,
  revisedPrompt?: ModelSubscriptionStringInput | null,
  subject?: ModelSubscriptionStringInput | null,
  subjectText?: ModelSubscriptionStringInput | null,
  subOption?: ModelSubscriptionStringInput | null,
  styles?: ModelSubscriptionStringInput | null,
  stylesText?: ModelSubscriptionStringInput | null,
  color?: ModelSubscriptionStringInput | null,
  colorText?: ModelSubscriptionStringInput | null,
  medium?: ModelSubscriptionStringInput | null,
  mediumText?: ModelSubscriptionStringInput | null,
  model?: ModelSubscriptionStringInput | null,
  feeling?: ModelSubscriptionStringInput | null,
  feelingText?: ModelSubscriptionStringInput | null,
  like?: ModelSubscriptionBooleanInput | null,
  approve?: ModelSubscriptionBooleanInput | null,
  deleted?: ModelSubscriptionBooleanInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionArtFilterInput | null > | null,
  or?: Array< ModelSubscriptionArtFilterInput | null > | null,
};

export type ModelSubscriptionGiftCardPurchaseFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  originalBalance?: ModelSubscriptionIntInput | null,
  couponId?: ModelSubscriptionStringInput | null,
  couponAmountOff?: ModelSubscriptionIntInput | null,
  couponCurrency?: ModelSubscriptionStringInput | null,
  couponName?: ModelSubscriptionStringInput | null,
  couponDuration?: ModelSubscriptionStringInput | null,
  couponMaxRedemptions?: ModelSubscriptionIntInput | null,
  promotionCode?: ModelSubscriptionStringInput | null,
  promotionID?: ModelSubscriptionStringInput | null,
  checkoutSessionId?: ModelSubscriptionStringInput | null,
  paymentIntentId?: ModelSubscriptionStringInput | null,
  recipientEmail?: ModelSubscriptionStringInput | null,
  customMessage?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionGiftCardPurchaseFilterInput | null > | null,
  or?: Array< ModelSubscriptionGiftCardPurchaseFilterInput | null > | null,
};

export type UpdateArtCustomMutationVariables = {
  input: UpdateArtInput,
  condition?: ModelArtConditionInput | null,
};

export type UpdateArtCustomMutation = {
  updateArt?:  {
    __typename: "Art",
    id: string,
    feeling?: string | null,
    subject?: string | null,
    subOption?: string | null,
    medium?: string | null,
    styles?: string | null,
    color?: string | null,
    like?: boolean | null,
    approve?: boolean | null,
    deleted?: boolean | null,
    createdAt: string,
    updatedAt: string,
    s3Image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
  } | null,
};

export type ListArtsCustomQueryVariables = {
  filter?: ModelArtFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListArtsCustomQuery = {
  listArts?:  {
    __typename: "ModelArtConnection",
    items:  Array< {
      __typename: "Art",
      id: string,
      user?:  {
        __typename: "User",
        email: string,
      } | null,
      createdAt: string,
      like?: boolean | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type listArtsCustom2QueryVariables = {
  filter?: ModelArtFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type listArtsCustom2Query = {
  listArts?:  {
    __typename: "ModelArtConnection",
    items:  Array< {
      __typename: "Art",
      id: string,
      s3Image?:  {
        __typename: "S3Object",
        key: string,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type getArtCustomQueryVariables = {
  id: string,
};

export type getArtCustomQuery = {
  getArt?:  {
    __typename: "Art",
    id: string,
    user?:  {
      __typename: "User",
      email: string,
    } | null,
    like?: boolean | null,
  } | null,
};

export type getArtCustom2QueryVariables = {
  id: string,
};

export type getArtCustom2Query = {
  getArt?:  {
    __typename: "Art",
    id: string,
    user?:  {
      __typename: "User",
      username?: string | null,
      email: string,
    } | null,
    createdAt: string,
    subject?: string | null,
    subOption?: string | null,
    feeling?: string | null,
    medium?: string | null,
    styles?: string | null,
    color?: string | null,
    s3Image?:  {
      __typename: "S3Object",
      key: string,
    } | null,
    like?: boolean | null,
    approve?: boolean | null,
    deleted?: boolean | null,
  } | null,
};

export type getArtCustom3QueryVariables = {
  id: string,
};

export type getArtCustom3Query = {
  getArt?:  {
    __typename: "Art",
    user?:  {
      __typename: "User",
      username?: string | null,
    } | null,
    createdAt: string,
    subject?: string | null,
    subOption?: string | null,
    feeling?: string | null,
    medium?: string | null,
    styles?: string | null,
    color?: string | null,
    s3Image?:  {
      __typename: "S3Object",
      key: string,
    } | null,
  } | null,
};

export type artsByUserIdAndCreatedAtCustomQueryVariables = {
  userId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelArtFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type artsByUserIdAndCreatedAtCustomQuery = {
  artsByUserIdAndCreatedAt?:  {
    __typename: "ModelArtConnection",
    items:  Array< {
      __typename: "Art",
      id: string,
      userId: string,
      createdAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        username?: string | null,
        identityId?: string | null,
      } | null,
      title?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ordersByInvoiceNumberCustomQueryVariables = {
  invoiceNumber: string,
  filter?: ModelOrderFilterInput | null,
};

export type ordersByInvoiceNumberCustomQuery = {
  ordersByInvoiceNumber?:  {
    __typename: "ModelOrderConnection",
    items:  Array< {
      __typename: "Order",
      id: string,
      createdAt: string,
      invoiceNumber?: string | null,
      invoiceId?: string | null,
      receiptNumber?: string | null,
      email: string,
      status?: string | null,
      fulfillment_tracking_id?: string | null,
      fulfillment_method?: string | null,
      fulfillment_status?: string | null,
      fulfillment_createdAt?: string | null,
      fulfillment_updatedAt?: string | null,
      fulfillment_completedAt?: string | null,
    } | null >,
  } | null,
};

export type UsersByEmailCustomQueryVariables = {
  email: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UsersByEmailCustomQuery = {
  usersByEmail?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      createdAt: string,
      email: string,
      emailVerified?: boolean | null,
      identityId?: string | null,
      credits?: number | null,
      boughtCredits?: number | null,
      creditPurchases?:  {
        __typename: "ModelCreditPurchaseConnection",
        items:  Array< {
          __typename: "CreditPurchase",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            createdAt: string,
            email: string,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            updatedAt: string,
          } | null,
          creditAmount?: number | null,
          checkoutSessionId: string,
          paymentIntentId?: string | null,
          updatedAt: string,
          userCreditPurchasesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      orders?:  {
        __typename: "ModelOrderConnection",
        items:  Array< {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            createdAt: string,
            email: string,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OrdersByEmailAndCreatedAtCustomQueryVariables = {
  email: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOrderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type OrdersByEmailAndCreatedAtCustomQuery = {
  ordersByEmailAndCreatedAt?:  {
    __typename: "ModelOrderConnection",
    items:  Array< {
      __typename: "Order",
      id: string,
      invoiceNumber?: string | null,
      receiptNumber?: string | null,
      email: string,
      cost_total?: number | null,
      discount_amount?: number | null,
      currency?: string | null,
      userOrdersId?: string | null,
      orderCartId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserCustomQueryVariables = {
  id: string,
};

export type GetUserCustomQuery = {
  getUser?:  {
    __typename: "User",
    email: string,
    identityId?: string | null,
    credits?: number | null,
    stripeCustomerId?: string | null,
  } | null,
};

export type CreateOrderMutationVariables = {
  input: CreateOrderInput,
  condition?: ModelOrderConditionInput | null,
};

export type CreateOrderMutation = {
  createOrder?:  {
    __typename: "Order",
    id: string,
    createdAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      username?: string | null,
      emailVerified?: boolean | null,
      identityId?: string | null,
      credits?: number | null,
      boughtCredits?: number | null,
      creditPurchases?:  {
        __typename: "ModelCreditPurchaseConnection",
        items:  Array< {
          __typename: "CreditPurchase",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          creditAmount?: number | null,
          checkoutSessionId: string,
          paymentIntentId?: string | null,
          owner?: string | null,
          updatedAt: string,
          userCreditPurchasesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      orders?:  {
        __typename: "ModelOrderConnection",
        items:  Array< {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    stripeCustomerId?: string | null,
    invoiceNumber?: string | null,
    invoiceId?: string | null,
    receiptNumber?: string | null,
    cart?:  {
      __typename: "Cart",
      id: string,
      createdAt: string,
      order?:  {
        __typename: "Order",
        id: string,
        createdAt: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          username?: string | null,
          emailVerified?: boolean | null,
          identityId?: string | null,
          credits?: number | null,
          boughtCredits?: number | null,
          creditPurchases?:  {
            __typename: "ModelCreditPurchaseConnection",
            nextToken?: string | null,
          } | null,
          orders?:  {
            __typename: "ModelOrderConnection",
            nextToken?: string | null,
          } | null,
          stripeCustomerId?: string | null,
          owner?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        stripeCustomerId?: string | null,
        invoiceNumber?: string | null,
        invoiceId?: string | null,
        receiptNumber?: string | null,
        cart?:  {
          __typename: "Cart",
          id: string,
          createdAt: string,
          order?:  {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null,
          artOrders?:  {
            __typename: "ModelartOrderConnection",
            nextToken?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          updatedAt: string,
          cartOrderId?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        cost_taxes?: number | null,
        cost_shipping?: number | null,
        couponId?: string | null,
        coupon_amount_off?: number | null,
        coupon_name?: string | null,
        discountId?: string | null,
        discount_amount?: number | null,
        promotionID?: string | null,
        promotion_code?: string | null,
        fulfillment_tracking_id?: string | null,
        fulfillment_method?: string | null,
        fulfillment_status?: string | null,
        fulfillment_createdAt?: string | null,
        fulfillment_updatedAt?: string | null,
        fulfillment_completedAt?: string | null,
        billing_name?: string | null,
        billing_address?: string | null,
        billing_address2?: string | null,
        billing_city?: string | null,
        billing_state?: string | null,
        billing_zip?: string | null,
        billing_country?: string | null,
        shipping_name?: string | null,
        shipping_address?: string | null,
        shipping_address2?: string | null,
        shipping_city?: string | null,
        shipping_state?: string | null,
        shipping_zip?: string | null,
        shipping_country?: string | null,
        shipping_phone?: string | null,
        notes?: string | null,
        vendor?: string | null,
        order_source?: string | null,
        currency?: string | null,
        cancel?: boolean | null,
        updatedAt: string,
        userOrdersId?: string | null,
        orderCartId?: string | null,
      } | null,
      artOrders?:  {
        __typename: "ModelartOrderConnection",
        items:  Array< {
          __typename: "artOrder",
          id: string,
          createdAt: string,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          orderID?: string | null,
          art?:  {
            __typename: "Art",
            id: string,
            userId: string,
            createdAt: string,
            title?: string | null,
            inputImage?: string | null,
            prompt?: string | null,
            revisedPrompt?: string | null,
            subject?: string | null,
            subjectText?: string | null,
            subOption?: string | null,
            styles?: string | null,
            stylesText?: string | null,
            color?: string | null,
            colorText?: string | null,
            medium?: string | null,
            mediumText?: string | null,
            model?: string | null,
            feeling?: string | null,
            feelingText?: string | null,
            like?: boolean | null,
            approve?: boolean | null,
            deleted?: boolean | null,
            updatedAt: string,
          } | null,
          email: string,
          file?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          dpi?: number | null,
          length?: number | null,
          width?: number | null,
          resolution_length?: number | null,
          resolution_width?: number | null,
          paper?: string | null,
          frame?: boolean | null,
          moulding?: string | null,
          moulding_finish?: string | null,
          mount?: string | null,
          total?: number | null,
          tax?: number | null,
          updatedAt: string,
          cartArtOrdersId?: string | null,
          artOrderArtId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      email: string,
      status?: string | null,
      cost_total?: number | null,
      updatedAt: string,
      cartOrderId?: string | null,
    } | null,
    email: string,
    status?: string | null,
    cost_total?: number | null,
    cost_taxes?: number | null,
    cost_shipping?: number | null,
    couponId?: string | null,
    coupon_amount_off?: number | null,
    coupon_name?: string | null,
    discountId?: string | null,
    discount_amount?: number | null,
    promotionID?: string | null,
    promotion_code?: string | null,
    fulfillment_tracking_id?: string | null,
    fulfillment_method?: string | null,
    fulfillment_status?: string | null,
    fulfillment_createdAt?: string | null,
    fulfillment_updatedAt?: string | null,
    fulfillment_completedAt?: string | null,
    billing_name?: string | null,
    billing_address?: string | null,
    billing_address2?: string | null,
    billing_city?: string | null,
    billing_state?: string | null,
    billing_zip?: string | null,
    billing_country?: string | null,
    shipping_name?: string | null,
    shipping_address?: string | null,
    shipping_address2?: string | null,
    shipping_city?: string | null,
    shipping_state?: string | null,
    shipping_zip?: string | null,
    shipping_country?: string | null,
    shipping_phone?: string | null,
    notes?: string | null,
    vendor?: string | null,
    order_source?: string | null,
    currency?: string | null,
    cancel?: boolean | null,
    updatedAt: string,
    userOrdersId?: string | null,
    orderCartId?: string | null,
  } | null,
};

export type UpdateOrderMutationVariables = {
  input: UpdateOrderInput,
  condition?: ModelOrderConditionInput | null,
};

export type UpdateOrderMutation = {
  updateOrder?:  {
    __typename: "Order",
    id: string,
    createdAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      username?: string | null,
      emailVerified?: boolean | null,
      identityId?: string | null,
      credits?: number | null,
      boughtCredits?: number | null,
      creditPurchases?:  {
        __typename: "ModelCreditPurchaseConnection",
        items:  Array< {
          __typename: "CreditPurchase",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          creditAmount?: number | null,
          checkoutSessionId: string,
          paymentIntentId?: string | null,
          owner?: string | null,
          updatedAt: string,
          userCreditPurchasesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      orders?:  {
        __typename: "ModelOrderConnection",
        items:  Array< {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    stripeCustomerId?: string | null,
    invoiceNumber?: string | null,
    invoiceId?: string | null,
    receiptNumber?: string | null,
    cart?:  {
      __typename: "Cart",
      id: string,
      createdAt: string,
      order?:  {
        __typename: "Order",
        id: string,
        createdAt: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          username?: string | null,
          emailVerified?: boolean | null,
          identityId?: string | null,
          credits?: number | null,
          boughtCredits?: number | null,
          creditPurchases?:  {
            __typename: "ModelCreditPurchaseConnection",
            nextToken?: string | null,
          } | null,
          orders?:  {
            __typename: "ModelOrderConnection",
            nextToken?: string | null,
          } | null,
          stripeCustomerId?: string | null,
          owner?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        stripeCustomerId?: string | null,
        invoiceNumber?: string | null,
        invoiceId?: string | null,
        receiptNumber?: string | null,
        cart?:  {
          __typename: "Cart",
          id: string,
          createdAt: string,
          order?:  {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null,
          artOrders?:  {
            __typename: "ModelartOrderConnection",
            nextToken?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          updatedAt: string,
          cartOrderId?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        cost_taxes?: number | null,
        cost_shipping?: number | null,
        couponId?: string | null,
        coupon_amount_off?: number | null,
        coupon_name?: string | null,
        discountId?: string | null,
        discount_amount?: number | null,
        promotionID?: string | null,
        promotion_code?: string | null,
        fulfillment_tracking_id?: string | null,
        fulfillment_method?: string | null,
        fulfillment_status?: string | null,
        fulfillment_createdAt?: string | null,
        fulfillment_updatedAt?: string | null,
        fulfillment_completedAt?: string | null,
        billing_name?: string | null,
        billing_address?: string | null,
        billing_address2?: string | null,
        billing_city?: string | null,
        billing_state?: string | null,
        billing_zip?: string | null,
        billing_country?: string | null,
        shipping_name?: string | null,
        shipping_address?: string | null,
        shipping_address2?: string | null,
        shipping_city?: string | null,
        shipping_state?: string | null,
        shipping_zip?: string | null,
        shipping_country?: string | null,
        shipping_phone?: string | null,
        notes?: string | null,
        vendor?: string | null,
        order_source?: string | null,
        currency?: string | null,
        cancel?: boolean | null,
        updatedAt: string,
        userOrdersId?: string | null,
        orderCartId?: string | null,
      } | null,
      artOrders?:  {
        __typename: "ModelartOrderConnection",
        items:  Array< {
          __typename: "artOrder",
          id: string,
          createdAt: string,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          orderID?: string | null,
          art?:  {
            __typename: "Art",
            id: string,
            userId: string,
            createdAt: string,
            title?: string | null,
            inputImage?: string | null,
            prompt?: string | null,
            revisedPrompt?: string | null,
            subject?: string | null,
            subjectText?: string | null,
            subOption?: string | null,
            styles?: string | null,
            stylesText?: string | null,
            color?: string | null,
            colorText?: string | null,
            medium?: string | null,
            mediumText?: string | null,
            model?: string | null,
            feeling?: string | null,
            feelingText?: string | null,
            like?: boolean | null,
            approve?: boolean | null,
            deleted?: boolean | null,
            updatedAt: string,
          } | null,
          email: string,
          file?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          dpi?: number | null,
          length?: number | null,
          width?: number | null,
          resolution_length?: number | null,
          resolution_width?: number | null,
          paper?: string | null,
          frame?: boolean | null,
          moulding?: string | null,
          moulding_finish?: string | null,
          mount?: string | null,
          total?: number | null,
          tax?: number | null,
          updatedAt: string,
          cartArtOrdersId?: string | null,
          artOrderArtId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      email: string,
      status?: string | null,
      cost_total?: number | null,
      updatedAt: string,
      cartOrderId?: string | null,
    } | null,
    email: string,
    status?: string | null,
    cost_total?: number | null,
    cost_taxes?: number | null,
    cost_shipping?: number | null,
    couponId?: string | null,
    coupon_amount_off?: number | null,
    coupon_name?: string | null,
    discountId?: string | null,
    discount_amount?: number | null,
    promotionID?: string | null,
    promotion_code?: string | null,
    fulfillment_tracking_id?: string | null,
    fulfillment_method?: string | null,
    fulfillment_status?: string | null,
    fulfillment_createdAt?: string | null,
    fulfillment_updatedAt?: string | null,
    fulfillment_completedAt?: string | null,
    billing_name?: string | null,
    billing_address?: string | null,
    billing_address2?: string | null,
    billing_city?: string | null,
    billing_state?: string | null,
    billing_zip?: string | null,
    billing_country?: string | null,
    shipping_name?: string | null,
    shipping_address?: string | null,
    shipping_address2?: string | null,
    shipping_city?: string | null,
    shipping_state?: string | null,
    shipping_zip?: string | null,
    shipping_country?: string | null,
    shipping_phone?: string | null,
    notes?: string | null,
    vendor?: string | null,
    order_source?: string | null,
    currency?: string | null,
    cancel?: boolean | null,
    updatedAt: string,
    userOrdersId?: string | null,
    orderCartId?: string | null,
  } | null,
};

export type DeleteOrderMutationVariables = {
  input: DeleteOrderInput,
  condition?: ModelOrderConditionInput | null,
};

export type DeleteOrderMutation = {
  deleteOrder?:  {
    __typename: "Order",
    id: string,
    createdAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      username?: string | null,
      emailVerified?: boolean | null,
      identityId?: string | null,
      credits?: number | null,
      boughtCredits?: number | null,
      creditPurchases?:  {
        __typename: "ModelCreditPurchaseConnection",
        items:  Array< {
          __typename: "CreditPurchase",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          creditAmount?: number | null,
          checkoutSessionId: string,
          paymentIntentId?: string | null,
          owner?: string | null,
          updatedAt: string,
          userCreditPurchasesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      orders?:  {
        __typename: "ModelOrderConnection",
        items:  Array< {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    stripeCustomerId?: string | null,
    invoiceNumber?: string | null,
    invoiceId?: string | null,
    receiptNumber?: string | null,
    cart?:  {
      __typename: "Cart",
      id: string,
      createdAt: string,
      order?:  {
        __typename: "Order",
        id: string,
        createdAt: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          username?: string | null,
          emailVerified?: boolean | null,
          identityId?: string | null,
          credits?: number | null,
          boughtCredits?: number | null,
          creditPurchases?:  {
            __typename: "ModelCreditPurchaseConnection",
            nextToken?: string | null,
          } | null,
          orders?:  {
            __typename: "ModelOrderConnection",
            nextToken?: string | null,
          } | null,
          stripeCustomerId?: string | null,
          owner?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        stripeCustomerId?: string | null,
        invoiceNumber?: string | null,
        invoiceId?: string | null,
        receiptNumber?: string | null,
        cart?:  {
          __typename: "Cart",
          id: string,
          createdAt: string,
          order?:  {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null,
          artOrders?:  {
            __typename: "ModelartOrderConnection",
            nextToken?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          updatedAt: string,
          cartOrderId?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        cost_taxes?: number | null,
        cost_shipping?: number | null,
        couponId?: string | null,
        coupon_amount_off?: number | null,
        coupon_name?: string | null,
        discountId?: string | null,
        discount_amount?: number | null,
        promotionID?: string | null,
        promotion_code?: string | null,
        fulfillment_tracking_id?: string | null,
        fulfillment_method?: string | null,
        fulfillment_status?: string | null,
        fulfillment_createdAt?: string | null,
        fulfillment_updatedAt?: string | null,
        fulfillment_completedAt?: string | null,
        billing_name?: string | null,
        billing_address?: string | null,
        billing_address2?: string | null,
        billing_city?: string | null,
        billing_state?: string | null,
        billing_zip?: string | null,
        billing_country?: string | null,
        shipping_name?: string | null,
        shipping_address?: string | null,
        shipping_address2?: string | null,
        shipping_city?: string | null,
        shipping_state?: string | null,
        shipping_zip?: string | null,
        shipping_country?: string | null,
        shipping_phone?: string | null,
        notes?: string | null,
        vendor?: string | null,
        order_source?: string | null,
        currency?: string | null,
        cancel?: boolean | null,
        updatedAt: string,
        userOrdersId?: string | null,
        orderCartId?: string | null,
      } | null,
      artOrders?:  {
        __typename: "ModelartOrderConnection",
        items:  Array< {
          __typename: "artOrder",
          id: string,
          createdAt: string,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          orderID?: string | null,
          art?:  {
            __typename: "Art",
            id: string,
            userId: string,
            createdAt: string,
            title?: string | null,
            inputImage?: string | null,
            prompt?: string | null,
            revisedPrompt?: string | null,
            subject?: string | null,
            subjectText?: string | null,
            subOption?: string | null,
            styles?: string | null,
            stylesText?: string | null,
            color?: string | null,
            colorText?: string | null,
            medium?: string | null,
            mediumText?: string | null,
            model?: string | null,
            feeling?: string | null,
            feelingText?: string | null,
            like?: boolean | null,
            approve?: boolean | null,
            deleted?: boolean | null,
            updatedAt: string,
          } | null,
          email: string,
          file?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          dpi?: number | null,
          length?: number | null,
          width?: number | null,
          resolution_length?: number | null,
          resolution_width?: number | null,
          paper?: string | null,
          frame?: boolean | null,
          moulding?: string | null,
          moulding_finish?: string | null,
          mount?: string | null,
          total?: number | null,
          tax?: number | null,
          updatedAt: string,
          cartArtOrdersId?: string | null,
          artOrderArtId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      email: string,
      status?: string | null,
      cost_total?: number | null,
      updatedAt: string,
      cartOrderId?: string | null,
    } | null,
    email: string,
    status?: string | null,
    cost_total?: number | null,
    cost_taxes?: number | null,
    cost_shipping?: number | null,
    couponId?: string | null,
    coupon_amount_off?: number | null,
    coupon_name?: string | null,
    discountId?: string | null,
    discount_amount?: number | null,
    promotionID?: string | null,
    promotion_code?: string | null,
    fulfillment_tracking_id?: string | null,
    fulfillment_method?: string | null,
    fulfillment_status?: string | null,
    fulfillment_createdAt?: string | null,
    fulfillment_updatedAt?: string | null,
    fulfillment_completedAt?: string | null,
    billing_name?: string | null,
    billing_address?: string | null,
    billing_address2?: string | null,
    billing_city?: string | null,
    billing_state?: string | null,
    billing_zip?: string | null,
    billing_country?: string | null,
    shipping_name?: string | null,
    shipping_address?: string | null,
    shipping_address2?: string | null,
    shipping_city?: string | null,
    shipping_state?: string | null,
    shipping_zip?: string | null,
    shipping_country?: string | null,
    shipping_phone?: string | null,
    notes?: string | null,
    vendor?: string | null,
    order_source?: string | null,
    currency?: string | null,
    cancel?: boolean | null,
    updatedAt: string,
    userOrdersId?: string | null,
    orderCartId?: string | null,
  } | null,
};

export type CreateCartMutationVariables = {
  input: CreateCartInput,
  condition?: ModelCartConditionInput | null,
};

export type CreateCartMutation = {
  createCart?:  {
    __typename: "Cart",
    id: string,
    createdAt: string,
    order?:  {
      __typename: "Order",
      id: string,
      createdAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        username?: string | null,
        emailVerified?: boolean | null,
        identityId?: string | null,
        credits?: number | null,
        boughtCredits?: number | null,
        creditPurchases?:  {
          __typename: "ModelCreditPurchaseConnection",
          items:  Array< {
            __typename: "CreditPurchase",
            id: string,
            createdAt: string,
            creditAmount?: number | null,
            checkoutSessionId: string,
            paymentIntentId?: string | null,
            owner?: string | null,
            updatedAt: string,
            userCreditPurchasesId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        orders?:  {
          __typename: "ModelOrderConnection",
          items:  Array< {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        stripeCustomerId?: string | null,
        owner?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      stripeCustomerId?: string | null,
      invoiceNumber?: string | null,
      invoiceId?: string | null,
      receiptNumber?: string | null,
      cart?:  {
        __typename: "Cart",
        id: string,
        createdAt: string,
        order?:  {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null,
        artOrders?:  {
          __typename: "ModelartOrderConnection",
          items:  Array< {
            __typename: "artOrder",
            id: string,
            createdAt: string,
            orderID?: string | null,
            email: string,
            dpi?: number | null,
            length?: number | null,
            width?: number | null,
            resolution_length?: number | null,
            resolution_width?: number | null,
            paper?: string | null,
            frame?: boolean | null,
            moulding?: string | null,
            moulding_finish?: string | null,
            mount?: string | null,
            total?: number | null,
            tax?: number | null,
            updatedAt: string,
            cartArtOrdersId?: string | null,
            artOrderArtId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        updatedAt: string,
        cartOrderId?: string | null,
      } | null,
      email: string,
      status?: string | null,
      cost_total?: number | null,
      cost_taxes?: number | null,
      cost_shipping?: number | null,
      couponId?: string | null,
      coupon_amount_off?: number | null,
      coupon_name?: string | null,
      discountId?: string | null,
      discount_amount?: number | null,
      promotionID?: string | null,
      promotion_code?: string | null,
      fulfillment_tracking_id?: string | null,
      fulfillment_method?: string | null,
      fulfillment_status?: string | null,
      fulfillment_createdAt?: string | null,
      fulfillment_updatedAt?: string | null,
      fulfillment_completedAt?: string | null,
      billing_name?: string | null,
      billing_address?: string | null,
      billing_address2?: string | null,
      billing_city?: string | null,
      billing_state?: string | null,
      billing_zip?: string | null,
      billing_country?: string | null,
      shipping_name?: string | null,
      shipping_address?: string | null,
      shipping_address2?: string | null,
      shipping_city?: string | null,
      shipping_state?: string | null,
      shipping_zip?: string | null,
      shipping_country?: string | null,
      shipping_phone?: string | null,
      notes?: string | null,
      vendor?: string | null,
      order_source?: string | null,
      currency?: string | null,
      cancel?: boolean | null,
      updatedAt: string,
      userOrdersId?: string | null,
      orderCartId?: string | null,
    } | null,
    artOrders?:  {
      __typename: "ModelartOrderConnection",
      items:  Array< {
        __typename: "artOrder",
        id: string,
        createdAt: string,
        cart?:  {
          __typename: "Cart",
          id: string,
          createdAt: string,
          order?:  {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null,
          artOrders?:  {
            __typename: "ModelartOrderConnection",
            nextToken?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          updatedAt: string,
          cartOrderId?: string | null,
        } | null,
        orderID?: string | null,
        art?:  {
          __typename: "Art",
          id: string,
          userId: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          title?: string | null,
          inputImage?: string | null,
          s3Image?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          prompt?: string | null,
          revisedPrompt?: string | null,
          subject?: string | null,
          subjectText?: string | null,
          subOption?: string | null,
          styles?: string | null,
          stylesText?: string | null,
          color?: string | null,
          colorText?: string | null,
          medium?: string | null,
          mediumText?: string | null,
          model?: string | null,
          feeling?: string | null,
          feelingText?: string | null,
          like?: boolean | null,
          approve?: boolean | null,
          deleted?: boolean | null,
          updatedAt: string,
        } | null,
        email: string,
        file?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        dpi?: number | null,
        length?: number | null,
        width?: number | null,
        resolution_length?: number | null,
        resolution_width?: number | null,
        paper?: string | null,
        frame?: boolean | null,
        moulding?: string | null,
        moulding_finish?: string | null,
        mount?: string | null,
        total?: number | null,
        tax?: number | null,
        updatedAt: string,
        cartArtOrdersId?: string | null,
        artOrderArtId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    email: string,
    status?: string | null,
    cost_total?: number | null,
    updatedAt: string,
    cartOrderId?: string | null,
  } | null,
};

export type UpdateCartMutationVariables = {
  input: UpdateCartInput,
  condition?: ModelCartConditionInput | null,
};

export type UpdateCartMutation = {
  updateCart?:  {
    __typename: "Cart",
    id: string,
    createdAt: string,
    order?:  {
      __typename: "Order",
      id: string,
      createdAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        username?: string | null,
        emailVerified?: boolean | null,
        identityId?: string | null,
        credits?: number | null,
        boughtCredits?: number | null,
        creditPurchases?:  {
          __typename: "ModelCreditPurchaseConnection",
          items:  Array< {
            __typename: "CreditPurchase",
            id: string,
            createdAt: string,
            creditAmount?: number | null,
            checkoutSessionId: string,
            paymentIntentId?: string | null,
            owner?: string | null,
            updatedAt: string,
            userCreditPurchasesId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        orders?:  {
          __typename: "ModelOrderConnection",
          items:  Array< {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        stripeCustomerId?: string | null,
        owner?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      stripeCustomerId?: string | null,
      invoiceNumber?: string | null,
      invoiceId?: string | null,
      receiptNumber?: string | null,
      cart?:  {
        __typename: "Cart",
        id: string,
        createdAt: string,
        order?:  {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null,
        artOrders?:  {
          __typename: "ModelartOrderConnection",
          items:  Array< {
            __typename: "artOrder",
            id: string,
            createdAt: string,
            orderID?: string | null,
            email: string,
            dpi?: number | null,
            length?: number | null,
            width?: number | null,
            resolution_length?: number | null,
            resolution_width?: number | null,
            paper?: string | null,
            frame?: boolean | null,
            moulding?: string | null,
            moulding_finish?: string | null,
            mount?: string | null,
            total?: number | null,
            tax?: number | null,
            updatedAt: string,
            cartArtOrdersId?: string | null,
            artOrderArtId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        updatedAt: string,
        cartOrderId?: string | null,
      } | null,
      email: string,
      status?: string | null,
      cost_total?: number | null,
      cost_taxes?: number | null,
      cost_shipping?: number | null,
      couponId?: string | null,
      coupon_amount_off?: number | null,
      coupon_name?: string | null,
      discountId?: string | null,
      discount_amount?: number | null,
      promotionID?: string | null,
      promotion_code?: string | null,
      fulfillment_tracking_id?: string | null,
      fulfillment_method?: string | null,
      fulfillment_status?: string | null,
      fulfillment_createdAt?: string | null,
      fulfillment_updatedAt?: string | null,
      fulfillment_completedAt?: string | null,
      billing_name?: string | null,
      billing_address?: string | null,
      billing_address2?: string | null,
      billing_city?: string | null,
      billing_state?: string | null,
      billing_zip?: string | null,
      billing_country?: string | null,
      shipping_name?: string | null,
      shipping_address?: string | null,
      shipping_address2?: string | null,
      shipping_city?: string | null,
      shipping_state?: string | null,
      shipping_zip?: string | null,
      shipping_country?: string | null,
      shipping_phone?: string | null,
      notes?: string | null,
      vendor?: string | null,
      order_source?: string | null,
      currency?: string | null,
      cancel?: boolean | null,
      updatedAt: string,
      userOrdersId?: string | null,
      orderCartId?: string | null,
    } | null,
    artOrders?:  {
      __typename: "ModelartOrderConnection",
      items:  Array< {
        __typename: "artOrder",
        id: string,
        createdAt: string,
        cart?:  {
          __typename: "Cart",
          id: string,
          createdAt: string,
          order?:  {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null,
          artOrders?:  {
            __typename: "ModelartOrderConnection",
            nextToken?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          updatedAt: string,
          cartOrderId?: string | null,
        } | null,
        orderID?: string | null,
        art?:  {
          __typename: "Art",
          id: string,
          userId: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          title?: string | null,
          inputImage?: string | null,
          s3Image?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          prompt?: string | null,
          revisedPrompt?: string | null,
          subject?: string | null,
          subjectText?: string | null,
          subOption?: string | null,
          styles?: string | null,
          stylesText?: string | null,
          color?: string | null,
          colorText?: string | null,
          medium?: string | null,
          mediumText?: string | null,
          model?: string | null,
          feeling?: string | null,
          feelingText?: string | null,
          like?: boolean | null,
          approve?: boolean | null,
          deleted?: boolean | null,
          updatedAt: string,
        } | null,
        email: string,
        file?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        dpi?: number | null,
        length?: number | null,
        width?: number | null,
        resolution_length?: number | null,
        resolution_width?: number | null,
        paper?: string | null,
        frame?: boolean | null,
        moulding?: string | null,
        moulding_finish?: string | null,
        mount?: string | null,
        total?: number | null,
        tax?: number | null,
        updatedAt: string,
        cartArtOrdersId?: string | null,
        artOrderArtId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    email: string,
    status?: string | null,
    cost_total?: number | null,
    updatedAt: string,
    cartOrderId?: string | null,
  } | null,
};

export type DeleteCartMutationVariables = {
  input: DeleteCartInput,
  condition?: ModelCartConditionInput | null,
};

export type DeleteCartMutation = {
  deleteCart?:  {
    __typename: "Cart",
    id: string,
    createdAt: string,
    order?:  {
      __typename: "Order",
      id: string,
      createdAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        username?: string | null,
        emailVerified?: boolean | null,
        identityId?: string | null,
        credits?: number | null,
        boughtCredits?: number | null,
        creditPurchases?:  {
          __typename: "ModelCreditPurchaseConnection",
          items:  Array< {
            __typename: "CreditPurchase",
            id: string,
            createdAt: string,
            creditAmount?: number | null,
            checkoutSessionId: string,
            paymentIntentId?: string | null,
            owner?: string | null,
            updatedAt: string,
            userCreditPurchasesId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        orders?:  {
          __typename: "ModelOrderConnection",
          items:  Array< {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        stripeCustomerId?: string | null,
        owner?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      stripeCustomerId?: string | null,
      invoiceNumber?: string | null,
      invoiceId?: string | null,
      receiptNumber?: string | null,
      cart?:  {
        __typename: "Cart",
        id: string,
        createdAt: string,
        order?:  {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null,
        artOrders?:  {
          __typename: "ModelartOrderConnection",
          items:  Array< {
            __typename: "artOrder",
            id: string,
            createdAt: string,
            orderID?: string | null,
            email: string,
            dpi?: number | null,
            length?: number | null,
            width?: number | null,
            resolution_length?: number | null,
            resolution_width?: number | null,
            paper?: string | null,
            frame?: boolean | null,
            moulding?: string | null,
            moulding_finish?: string | null,
            mount?: string | null,
            total?: number | null,
            tax?: number | null,
            updatedAt: string,
            cartArtOrdersId?: string | null,
            artOrderArtId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        updatedAt: string,
        cartOrderId?: string | null,
      } | null,
      email: string,
      status?: string | null,
      cost_total?: number | null,
      cost_taxes?: number | null,
      cost_shipping?: number | null,
      couponId?: string | null,
      coupon_amount_off?: number | null,
      coupon_name?: string | null,
      discountId?: string | null,
      discount_amount?: number | null,
      promotionID?: string | null,
      promotion_code?: string | null,
      fulfillment_tracking_id?: string | null,
      fulfillment_method?: string | null,
      fulfillment_status?: string | null,
      fulfillment_createdAt?: string | null,
      fulfillment_updatedAt?: string | null,
      fulfillment_completedAt?: string | null,
      billing_name?: string | null,
      billing_address?: string | null,
      billing_address2?: string | null,
      billing_city?: string | null,
      billing_state?: string | null,
      billing_zip?: string | null,
      billing_country?: string | null,
      shipping_name?: string | null,
      shipping_address?: string | null,
      shipping_address2?: string | null,
      shipping_city?: string | null,
      shipping_state?: string | null,
      shipping_zip?: string | null,
      shipping_country?: string | null,
      shipping_phone?: string | null,
      notes?: string | null,
      vendor?: string | null,
      order_source?: string | null,
      currency?: string | null,
      cancel?: boolean | null,
      updatedAt: string,
      userOrdersId?: string | null,
      orderCartId?: string | null,
    } | null,
    artOrders?:  {
      __typename: "ModelartOrderConnection",
      items:  Array< {
        __typename: "artOrder",
        id: string,
        createdAt: string,
        cart?:  {
          __typename: "Cart",
          id: string,
          createdAt: string,
          order?:  {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null,
          artOrders?:  {
            __typename: "ModelartOrderConnection",
            nextToken?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          updatedAt: string,
          cartOrderId?: string | null,
        } | null,
        orderID?: string | null,
        art?:  {
          __typename: "Art",
          id: string,
          userId: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          title?: string | null,
          inputImage?: string | null,
          s3Image?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          prompt?: string | null,
          revisedPrompt?: string | null,
          subject?: string | null,
          subjectText?: string | null,
          subOption?: string | null,
          styles?: string | null,
          stylesText?: string | null,
          color?: string | null,
          colorText?: string | null,
          medium?: string | null,
          mediumText?: string | null,
          model?: string | null,
          feeling?: string | null,
          feelingText?: string | null,
          like?: boolean | null,
          approve?: boolean | null,
          deleted?: boolean | null,
          updatedAt: string,
        } | null,
        email: string,
        file?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        dpi?: number | null,
        length?: number | null,
        width?: number | null,
        resolution_length?: number | null,
        resolution_width?: number | null,
        paper?: string | null,
        frame?: boolean | null,
        moulding?: string | null,
        moulding_finish?: string | null,
        mount?: string | null,
        total?: number | null,
        tax?: number | null,
        updatedAt: string,
        cartArtOrdersId?: string | null,
        artOrderArtId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    email: string,
    status?: string | null,
    cost_total?: number | null,
    updatedAt: string,
    cartOrderId?: string | null,
  } | null,
};

export type CreateArtOrderMutationVariables = {
  input: CreateArtOrderInput,
  condition?: ModelArtOrderConditionInput | null,
};

export type CreateArtOrderMutation = {
  createArtOrder?:  {
    __typename: "artOrder",
    id: string,
    createdAt: string,
    cart?:  {
      __typename: "Cart",
      id: string,
      createdAt: string,
      order?:  {
        __typename: "Order",
        id: string,
        createdAt: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          username?: string | null,
          emailVerified?: boolean | null,
          identityId?: string | null,
          credits?: number | null,
          boughtCredits?: number | null,
          creditPurchases?:  {
            __typename: "ModelCreditPurchaseConnection",
            nextToken?: string | null,
          } | null,
          orders?:  {
            __typename: "ModelOrderConnection",
            nextToken?: string | null,
          } | null,
          stripeCustomerId?: string | null,
          owner?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        stripeCustomerId?: string | null,
        invoiceNumber?: string | null,
        invoiceId?: string | null,
        receiptNumber?: string | null,
        cart?:  {
          __typename: "Cart",
          id: string,
          createdAt: string,
          order?:  {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null,
          artOrders?:  {
            __typename: "ModelartOrderConnection",
            nextToken?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          updatedAt: string,
          cartOrderId?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        cost_taxes?: number | null,
        cost_shipping?: number | null,
        couponId?: string | null,
        coupon_amount_off?: number | null,
        coupon_name?: string | null,
        discountId?: string | null,
        discount_amount?: number | null,
        promotionID?: string | null,
        promotion_code?: string | null,
        fulfillment_tracking_id?: string | null,
        fulfillment_method?: string | null,
        fulfillment_status?: string | null,
        fulfillment_createdAt?: string | null,
        fulfillment_updatedAt?: string | null,
        fulfillment_completedAt?: string | null,
        billing_name?: string | null,
        billing_address?: string | null,
        billing_address2?: string | null,
        billing_city?: string | null,
        billing_state?: string | null,
        billing_zip?: string | null,
        billing_country?: string | null,
        shipping_name?: string | null,
        shipping_address?: string | null,
        shipping_address2?: string | null,
        shipping_city?: string | null,
        shipping_state?: string | null,
        shipping_zip?: string | null,
        shipping_country?: string | null,
        shipping_phone?: string | null,
        notes?: string | null,
        vendor?: string | null,
        order_source?: string | null,
        currency?: string | null,
        cancel?: boolean | null,
        updatedAt: string,
        userOrdersId?: string | null,
        orderCartId?: string | null,
      } | null,
      artOrders?:  {
        __typename: "ModelartOrderConnection",
        items:  Array< {
          __typename: "artOrder",
          id: string,
          createdAt: string,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          orderID?: string | null,
          art?:  {
            __typename: "Art",
            id: string,
            userId: string,
            createdAt: string,
            title?: string | null,
            inputImage?: string | null,
            prompt?: string | null,
            revisedPrompt?: string | null,
            subject?: string | null,
            subjectText?: string | null,
            subOption?: string | null,
            styles?: string | null,
            stylesText?: string | null,
            color?: string | null,
            colorText?: string | null,
            medium?: string | null,
            mediumText?: string | null,
            model?: string | null,
            feeling?: string | null,
            feelingText?: string | null,
            like?: boolean | null,
            approve?: boolean | null,
            deleted?: boolean | null,
            updatedAt: string,
          } | null,
          email: string,
          file?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          dpi?: number | null,
          length?: number | null,
          width?: number | null,
          resolution_length?: number | null,
          resolution_width?: number | null,
          paper?: string | null,
          frame?: boolean | null,
          moulding?: string | null,
          moulding_finish?: string | null,
          mount?: string | null,
          total?: number | null,
          tax?: number | null,
          updatedAt: string,
          cartArtOrdersId?: string | null,
          artOrderArtId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      email: string,
      status?: string | null,
      cost_total?: number | null,
      updatedAt: string,
      cartOrderId?: string | null,
    } | null,
    orderID?: string | null,
    art?:  {
      __typename: "Art",
      id: string,
      userId: string,
      createdAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        username?: string | null,
        emailVerified?: boolean | null,
        identityId?: string | null,
        credits?: number | null,
        boughtCredits?: number | null,
        creditPurchases?:  {
          __typename: "ModelCreditPurchaseConnection",
          items:  Array< {
            __typename: "CreditPurchase",
            id: string,
            createdAt: string,
            creditAmount?: number | null,
            checkoutSessionId: string,
            paymentIntentId?: string | null,
            owner?: string | null,
            updatedAt: string,
            userCreditPurchasesId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        orders?:  {
          __typename: "ModelOrderConnection",
          items:  Array< {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        stripeCustomerId?: string | null,
        owner?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      title?: string | null,
      inputImage?: string | null,
      s3Image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      prompt?: string | null,
      revisedPrompt?: string | null,
      subject?: string | null,
      subjectText?: string | null,
      subOption?: string | null,
      styles?: string | null,
      stylesText?: string | null,
      color?: string | null,
      colorText?: string | null,
      medium?: string | null,
      mediumText?: string | null,
      model?: string | null,
      feeling?: string | null,
      feelingText?: string | null,
      like?: boolean | null,
      approve?: boolean | null,
      deleted?: boolean | null,
      updatedAt: string,
    } | null,
    email: string,
    file?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    dpi?: number | null,
    length?: number | null,
    width?: number | null,
    resolution_length?: number | null,
    resolution_width?: number | null,
    paper?: string | null,
    frame?: boolean | null,
    moulding?: string | null,
    moulding_finish?: string | null,
    mount?: string | null,
    total?: number | null,
    tax?: number | null,
    updatedAt: string,
    cartArtOrdersId?: string | null,
    artOrderArtId?: string | null,
  } | null,
};

export type UpdateArtOrderMutationVariables = {
  input: UpdateArtOrderInput,
  condition?: ModelArtOrderConditionInput | null,
};

export type UpdateArtOrderMutation = {
  updateArtOrder?:  {
    __typename: "artOrder",
    id: string,
    createdAt: string,
    cart?:  {
      __typename: "Cart",
      id: string,
      createdAt: string,
      order?:  {
        __typename: "Order",
        id: string,
        createdAt: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          username?: string | null,
          emailVerified?: boolean | null,
          identityId?: string | null,
          credits?: number | null,
          boughtCredits?: number | null,
          creditPurchases?:  {
            __typename: "ModelCreditPurchaseConnection",
            nextToken?: string | null,
          } | null,
          orders?:  {
            __typename: "ModelOrderConnection",
            nextToken?: string | null,
          } | null,
          stripeCustomerId?: string | null,
          owner?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        stripeCustomerId?: string | null,
        invoiceNumber?: string | null,
        invoiceId?: string | null,
        receiptNumber?: string | null,
        cart?:  {
          __typename: "Cart",
          id: string,
          createdAt: string,
          order?:  {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null,
          artOrders?:  {
            __typename: "ModelartOrderConnection",
            nextToken?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          updatedAt: string,
          cartOrderId?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        cost_taxes?: number | null,
        cost_shipping?: number | null,
        couponId?: string | null,
        coupon_amount_off?: number | null,
        coupon_name?: string | null,
        discountId?: string | null,
        discount_amount?: number | null,
        promotionID?: string | null,
        promotion_code?: string | null,
        fulfillment_tracking_id?: string | null,
        fulfillment_method?: string | null,
        fulfillment_status?: string | null,
        fulfillment_createdAt?: string | null,
        fulfillment_updatedAt?: string | null,
        fulfillment_completedAt?: string | null,
        billing_name?: string | null,
        billing_address?: string | null,
        billing_address2?: string | null,
        billing_city?: string | null,
        billing_state?: string | null,
        billing_zip?: string | null,
        billing_country?: string | null,
        shipping_name?: string | null,
        shipping_address?: string | null,
        shipping_address2?: string | null,
        shipping_city?: string | null,
        shipping_state?: string | null,
        shipping_zip?: string | null,
        shipping_country?: string | null,
        shipping_phone?: string | null,
        notes?: string | null,
        vendor?: string | null,
        order_source?: string | null,
        currency?: string | null,
        cancel?: boolean | null,
        updatedAt: string,
        userOrdersId?: string | null,
        orderCartId?: string | null,
      } | null,
      artOrders?:  {
        __typename: "ModelartOrderConnection",
        items:  Array< {
          __typename: "artOrder",
          id: string,
          createdAt: string,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          orderID?: string | null,
          art?:  {
            __typename: "Art",
            id: string,
            userId: string,
            createdAt: string,
            title?: string | null,
            inputImage?: string | null,
            prompt?: string | null,
            revisedPrompt?: string | null,
            subject?: string | null,
            subjectText?: string | null,
            subOption?: string | null,
            styles?: string | null,
            stylesText?: string | null,
            color?: string | null,
            colorText?: string | null,
            medium?: string | null,
            mediumText?: string | null,
            model?: string | null,
            feeling?: string | null,
            feelingText?: string | null,
            like?: boolean | null,
            approve?: boolean | null,
            deleted?: boolean | null,
            updatedAt: string,
          } | null,
          email: string,
          file?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          dpi?: number | null,
          length?: number | null,
          width?: number | null,
          resolution_length?: number | null,
          resolution_width?: number | null,
          paper?: string | null,
          frame?: boolean | null,
          moulding?: string | null,
          moulding_finish?: string | null,
          mount?: string | null,
          total?: number | null,
          tax?: number | null,
          updatedAt: string,
          cartArtOrdersId?: string | null,
          artOrderArtId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      email: string,
      status?: string | null,
      cost_total?: number | null,
      updatedAt: string,
      cartOrderId?: string | null,
    } | null,
    orderID?: string | null,
    art?:  {
      __typename: "Art",
      id: string,
      userId: string,
      createdAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        username?: string | null,
        emailVerified?: boolean | null,
        identityId?: string | null,
        credits?: number | null,
        boughtCredits?: number | null,
        creditPurchases?:  {
          __typename: "ModelCreditPurchaseConnection",
          items:  Array< {
            __typename: "CreditPurchase",
            id: string,
            createdAt: string,
            creditAmount?: number | null,
            checkoutSessionId: string,
            paymentIntentId?: string | null,
            owner?: string | null,
            updatedAt: string,
            userCreditPurchasesId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        orders?:  {
          __typename: "ModelOrderConnection",
          items:  Array< {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        stripeCustomerId?: string | null,
        owner?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      title?: string | null,
      inputImage?: string | null,
      s3Image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      prompt?: string | null,
      revisedPrompt?: string | null,
      subject?: string | null,
      subjectText?: string | null,
      subOption?: string | null,
      styles?: string | null,
      stylesText?: string | null,
      color?: string | null,
      colorText?: string | null,
      medium?: string | null,
      mediumText?: string | null,
      model?: string | null,
      feeling?: string | null,
      feelingText?: string | null,
      like?: boolean | null,
      approve?: boolean | null,
      deleted?: boolean | null,
      updatedAt: string,
    } | null,
    email: string,
    file?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    dpi?: number | null,
    length?: number | null,
    width?: number | null,
    resolution_length?: number | null,
    resolution_width?: number | null,
    paper?: string | null,
    frame?: boolean | null,
    moulding?: string | null,
    moulding_finish?: string | null,
    mount?: string | null,
    total?: number | null,
    tax?: number | null,
    updatedAt: string,
    cartArtOrdersId?: string | null,
    artOrderArtId?: string | null,
  } | null,
};

export type DeleteArtOrderMutationVariables = {
  input: DeleteArtOrderInput,
  condition?: ModelArtOrderConditionInput | null,
};

export type DeleteArtOrderMutation = {
  deleteArtOrder?:  {
    __typename: "artOrder",
    id: string,
    createdAt: string,
    cart?:  {
      __typename: "Cart",
      id: string,
      createdAt: string,
      order?:  {
        __typename: "Order",
        id: string,
        createdAt: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          username?: string | null,
          emailVerified?: boolean | null,
          identityId?: string | null,
          credits?: number | null,
          boughtCredits?: number | null,
          creditPurchases?:  {
            __typename: "ModelCreditPurchaseConnection",
            nextToken?: string | null,
          } | null,
          orders?:  {
            __typename: "ModelOrderConnection",
            nextToken?: string | null,
          } | null,
          stripeCustomerId?: string | null,
          owner?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        stripeCustomerId?: string | null,
        invoiceNumber?: string | null,
        invoiceId?: string | null,
        receiptNumber?: string | null,
        cart?:  {
          __typename: "Cart",
          id: string,
          createdAt: string,
          order?:  {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null,
          artOrders?:  {
            __typename: "ModelartOrderConnection",
            nextToken?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          updatedAt: string,
          cartOrderId?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        cost_taxes?: number | null,
        cost_shipping?: number | null,
        couponId?: string | null,
        coupon_amount_off?: number | null,
        coupon_name?: string | null,
        discountId?: string | null,
        discount_amount?: number | null,
        promotionID?: string | null,
        promotion_code?: string | null,
        fulfillment_tracking_id?: string | null,
        fulfillment_method?: string | null,
        fulfillment_status?: string | null,
        fulfillment_createdAt?: string | null,
        fulfillment_updatedAt?: string | null,
        fulfillment_completedAt?: string | null,
        billing_name?: string | null,
        billing_address?: string | null,
        billing_address2?: string | null,
        billing_city?: string | null,
        billing_state?: string | null,
        billing_zip?: string | null,
        billing_country?: string | null,
        shipping_name?: string | null,
        shipping_address?: string | null,
        shipping_address2?: string | null,
        shipping_city?: string | null,
        shipping_state?: string | null,
        shipping_zip?: string | null,
        shipping_country?: string | null,
        shipping_phone?: string | null,
        notes?: string | null,
        vendor?: string | null,
        order_source?: string | null,
        currency?: string | null,
        cancel?: boolean | null,
        updatedAt: string,
        userOrdersId?: string | null,
        orderCartId?: string | null,
      } | null,
      artOrders?:  {
        __typename: "ModelartOrderConnection",
        items:  Array< {
          __typename: "artOrder",
          id: string,
          createdAt: string,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          orderID?: string | null,
          art?:  {
            __typename: "Art",
            id: string,
            userId: string,
            createdAt: string,
            title?: string | null,
            inputImage?: string | null,
            prompt?: string | null,
            revisedPrompt?: string | null,
            subject?: string | null,
            subjectText?: string | null,
            subOption?: string | null,
            styles?: string | null,
            stylesText?: string | null,
            color?: string | null,
            colorText?: string | null,
            medium?: string | null,
            mediumText?: string | null,
            model?: string | null,
            feeling?: string | null,
            feelingText?: string | null,
            like?: boolean | null,
            approve?: boolean | null,
            deleted?: boolean | null,
            updatedAt: string,
          } | null,
          email: string,
          file?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          dpi?: number | null,
          length?: number | null,
          width?: number | null,
          resolution_length?: number | null,
          resolution_width?: number | null,
          paper?: string | null,
          frame?: boolean | null,
          moulding?: string | null,
          moulding_finish?: string | null,
          mount?: string | null,
          total?: number | null,
          tax?: number | null,
          updatedAt: string,
          cartArtOrdersId?: string | null,
          artOrderArtId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      email: string,
      status?: string | null,
      cost_total?: number | null,
      updatedAt: string,
      cartOrderId?: string | null,
    } | null,
    orderID?: string | null,
    art?:  {
      __typename: "Art",
      id: string,
      userId: string,
      createdAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        username?: string | null,
        emailVerified?: boolean | null,
        identityId?: string | null,
        credits?: number | null,
        boughtCredits?: number | null,
        creditPurchases?:  {
          __typename: "ModelCreditPurchaseConnection",
          items:  Array< {
            __typename: "CreditPurchase",
            id: string,
            createdAt: string,
            creditAmount?: number | null,
            checkoutSessionId: string,
            paymentIntentId?: string | null,
            owner?: string | null,
            updatedAt: string,
            userCreditPurchasesId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        orders?:  {
          __typename: "ModelOrderConnection",
          items:  Array< {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        stripeCustomerId?: string | null,
        owner?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      title?: string | null,
      inputImage?: string | null,
      s3Image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      prompt?: string | null,
      revisedPrompt?: string | null,
      subject?: string | null,
      subjectText?: string | null,
      subOption?: string | null,
      styles?: string | null,
      stylesText?: string | null,
      color?: string | null,
      colorText?: string | null,
      medium?: string | null,
      mediumText?: string | null,
      model?: string | null,
      feeling?: string | null,
      feelingText?: string | null,
      like?: boolean | null,
      approve?: boolean | null,
      deleted?: boolean | null,
      updatedAt: string,
    } | null,
    email: string,
    file?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    dpi?: number | null,
    length?: number | null,
    width?: number | null,
    resolution_length?: number | null,
    resolution_width?: number | null,
    paper?: string | null,
    frame?: boolean | null,
    moulding?: string | null,
    moulding_finish?: string | null,
    mount?: string | null,
    total?: number | null,
    tax?: number | null,
    updatedAt: string,
    cartArtOrdersId?: string | null,
    artOrderArtId?: string | null,
  } | null,
};

export type CreateArtMutationVariables = {
  input: CreateArtInput,
  condition?: ModelArtConditionInput | null,
};

export type CreateArtMutation = {
  createArt?:  {
    __typename: "Art",
    id: string,
    userId: string,
    createdAt: string,
    title?: string | null,
    inputImage?: string | null,
    s3Image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    prompt?: string | null,
    revisedPrompt?: string | null,
    subject?: string | null,
    subjectText?: string | null,
    subOption?: string | null,
    styles?: string | null,
    stylesText?: string | null,
    color?: string | null,
    colorText?: string | null,
    medium?: string | null,
    mediumText?: string | null,
    model?: string | null,
    feeling?: string | null,
    feelingText?: string | null,
    like?: boolean | null,
    approve?: boolean | null,
    deleted?: boolean | null,
    updatedAt: string,
  } | null,
};

export type UpdateArtMutationVariables = {
  input: UpdateArtInput,
  condition?: ModelArtConditionInput | null,
};

export type UpdateArtMutation = {
  updateArt?:  {
    __typename: "Art",
    id: string,
    userId: string,
    createdAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      username?: string | null,
      emailVerified?: boolean | null,
      identityId?: string | null,
      credits?: number | null,
      boughtCredits?: number | null,
      creditPurchases?:  {
        __typename: "ModelCreditPurchaseConnection",
        items:  Array< {
          __typename: "CreditPurchase",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          creditAmount?: number | null,
          checkoutSessionId: string,
          paymentIntentId?: string | null,
          owner?: string | null,
          updatedAt: string,
          userCreditPurchasesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      orders?:  {
        __typename: "ModelOrderConnection",
        items:  Array< {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    title?: string | null,
    inputImage?: string | null,
    s3Image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    prompt?: string | null,
    revisedPrompt?: string | null,
    subject?: string | null,
    subjectText?: string | null,
    subOption?: string | null,
    styles?: string | null,
    stylesText?: string | null,
    color?: string | null,
    colorText?: string | null,
    medium?: string | null,
    mediumText?: string | null,
    model?: string | null,
    feeling?: string | null,
    feelingText?: string | null,
    like?: boolean | null,
    approve?: boolean | null,
    deleted?: boolean | null,
    updatedAt: string,
  } | null,
};

export type DeleteArtMutationVariables = {
  input: DeleteArtInput,
  condition?: ModelArtConditionInput | null,
};

export type DeleteArtMutation = {
  deleteArt?:  {
    __typename: "Art",
    id: string,
    userId: string,
    createdAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      username?: string | null,
      emailVerified?: boolean | null,
      identityId?: string | null,
      credits?: number | null,
      boughtCredits?: number | null,
      creditPurchases?:  {
        __typename: "ModelCreditPurchaseConnection",
        items:  Array< {
          __typename: "CreditPurchase",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          creditAmount?: number | null,
          checkoutSessionId: string,
          paymentIntentId?: string | null,
          owner?: string | null,
          updatedAt: string,
          userCreditPurchasesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      orders?:  {
        __typename: "ModelOrderConnection",
        items:  Array< {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    title?: string | null,
    inputImage?: string | null,
    s3Image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    prompt?: string | null,
    revisedPrompt?: string | null,
    subject?: string | null,
    subjectText?: string | null,
    subOption?: string | null,
    styles?: string | null,
    stylesText?: string | null,
    color?: string | null,
    colorText?: string | null,
    medium?: string | null,
    mediumText?: string | null,
    model?: string | null,
    feeling?: string | null,
    feelingText?: string | null,
    like?: boolean | null,
    approve?: boolean | null,
    deleted?: boolean | null,
    updatedAt: string,
  } | null,
};

export type CreateUserMutationVariables = {
  input: CreateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type CreateUserMutation = {
  createUser?:  {
    __typename: "User",
    id: string,
    email: string,
    username?: string | null,
    emailVerified?: boolean | null,
    identityId?: string | null,
    credits?: number | null,
    boughtCredits?: number | null,
    creditPurchases?:  {
      __typename: "ModelCreditPurchaseConnection",
      items:  Array< {
        __typename: "CreditPurchase",
        id: string,
        createdAt: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          username?: string | null,
          emailVerified?: boolean | null,
          identityId?: string | null,
          credits?: number | null,
          boughtCredits?: number | null,
          creditPurchases?:  {
            __typename: "ModelCreditPurchaseConnection",
            nextToken?: string | null,
          } | null,
          orders?:  {
            __typename: "ModelOrderConnection",
            nextToken?: string | null,
          } | null,
          stripeCustomerId?: string | null,
          owner?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        creditAmount?: number | null,
        checkoutSessionId: string,
        paymentIntentId?: string | null,
        owner?: string | null,
        updatedAt: string,
        userCreditPurchasesId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    orders?:  {
      __typename: "ModelOrderConnection",
      items:  Array< {
        __typename: "Order",
        id: string,
        createdAt: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          username?: string | null,
          emailVerified?: boolean | null,
          identityId?: string | null,
          credits?: number | null,
          boughtCredits?: number | null,
          creditPurchases?:  {
            __typename: "ModelCreditPurchaseConnection",
            nextToken?: string | null,
          } | null,
          orders?:  {
            __typename: "ModelOrderConnection",
            nextToken?: string | null,
          } | null,
          stripeCustomerId?: string | null,
          owner?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        stripeCustomerId?: string | null,
        invoiceNumber?: string | null,
        invoiceId?: string | null,
        receiptNumber?: string | null,
        cart?:  {
          __typename: "Cart",
          id: string,
          createdAt: string,
          order?:  {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null,
          artOrders?:  {
            __typename: "ModelartOrderConnection",
            nextToken?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          updatedAt: string,
          cartOrderId?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        cost_taxes?: number | null,
        cost_shipping?: number | null,
        couponId?: string | null,
        coupon_amount_off?: number | null,
        coupon_name?: string | null,
        discountId?: string | null,
        discount_amount?: number | null,
        promotionID?: string | null,
        promotion_code?: string | null,
        fulfillment_tracking_id?: string | null,
        fulfillment_method?: string | null,
        fulfillment_status?: string | null,
        fulfillment_createdAt?: string | null,
        fulfillment_updatedAt?: string | null,
        fulfillment_completedAt?: string | null,
        billing_name?: string | null,
        billing_address?: string | null,
        billing_address2?: string | null,
        billing_city?: string | null,
        billing_state?: string | null,
        billing_zip?: string | null,
        billing_country?: string | null,
        shipping_name?: string | null,
        shipping_address?: string | null,
        shipping_address2?: string | null,
        shipping_city?: string | null,
        shipping_state?: string | null,
        shipping_zip?: string | null,
        shipping_country?: string | null,
        shipping_phone?: string | null,
        notes?: string | null,
        vendor?: string | null,
        order_source?: string | null,
        currency?: string | null,
        cancel?: boolean | null,
        updatedAt: string,
        userOrdersId?: string | null,
        orderCartId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    stripeCustomerId?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserMutationVariables = {
  input: UpdateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type UpdateUserMutation = {
  updateUser?:  {
    __typename: "User",
    id: string,
    email: string,
    username?: string | null,
    emailVerified?: boolean | null,
    identityId?: string | null,
    credits?: number | null,
    boughtCredits?: number | null,
    creditPurchases?:  {
      __typename: "ModelCreditPurchaseConnection",
      items:  Array< {
        __typename: "CreditPurchase",
        id: string,
        createdAt: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          username?: string | null,
          emailVerified?: boolean | null,
          identityId?: string | null,
          credits?: number | null,
          boughtCredits?: number | null,
          creditPurchases?:  {
            __typename: "ModelCreditPurchaseConnection",
            nextToken?: string | null,
          } | null,
          orders?:  {
            __typename: "ModelOrderConnection",
            nextToken?: string | null,
          } | null,
          stripeCustomerId?: string | null,
          owner?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        creditAmount?: number | null,
        checkoutSessionId: string,
        paymentIntentId?: string | null,
        owner?: string | null,
        updatedAt: string,
        userCreditPurchasesId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    orders?:  {
      __typename: "ModelOrderConnection",
      items:  Array< {
        __typename: "Order",
        id: string,
        createdAt: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          username?: string | null,
          emailVerified?: boolean | null,
          identityId?: string | null,
          credits?: number | null,
          boughtCredits?: number | null,
          creditPurchases?:  {
            __typename: "ModelCreditPurchaseConnection",
            nextToken?: string | null,
          } | null,
          orders?:  {
            __typename: "ModelOrderConnection",
            nextToken?: string | null,
          } | null,
          stripeCustomerId?: string | null,
          owner?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        stripeCustomerId?: string | null,
        invoiceNumber?: string | null,
        invoiceId?: string | null,
        receiptNumber?: string | null,
        cart?:  {
          __typename: "Cart",
          id: string,
          createdAt: string,
          order?:  {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null,
          artOrders?:  {
            __typename: "ModelartOrderConnection",
            nextToken?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          updatedAt: string,
          cartOrderId?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        cost_taxes?: number | null,
        cost_shipping?: number | null,
        couponId?: string | null,
        coupon_amount_off?: number | null,
        coupon_name?: string | null,
        discountId?: string | null,
        discount_amount?: number | null,
        promotionID?: string | null,
        promotion_code?: string | null,
        fulfillment_tracking_id?: string | null,
        fulfillment_method?: string | null,
        fulfillment_status?: string | null,
        fulfillment_createdAt?: string | null,
        fulfillment_updatedAt?: string | null,
        fulfillment_completedAt?: string | null,
        billing_name?: string | null,
        billing_address?: string | null,
        billing_address2?: string | null,
        billing_city?: string | null,
        billing_state?: string | null,
        billing_zip?: string | null,
        billing_country?: string | null,
        shipping_name?: string | null,
        shipping_address?: string | null,
        shipping_address2?: string | null,
        shipping_city?: string | null,
        shipping_state?: string | null,
        shipping_zip?: string | null,
        shipping_country?: string | null,
        shipping_phone?: string | null,
        notes?: string | null,
        vendor?: string | null,
        order_source?: string | null,
        currency?: string | null,
        cancel?: boolean | null,
        updatedAt: string,
        userOrdersId?: string | null,
        orderCartId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    stripeCustomerId?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserMutationVariables = {
  input: DeleteUserInput,
  condition?: ModelUserConditionInput | null,
};

export type DeleteUserMutation = {
  deleteUser?:  {
    __typename: "User",
    id: string,
    email: string,
    username?: string | null,
    emailVerified?: boolean | null,
    identityId?: string | null,
    credits?: number | null,
    boughtCredits?: number | null,
    creditPurchases?:  {
      __typename: "ModelCreditPurchaseConnection",
      items:  Array< {
        __typename: "CreditPurchase",
        id: string,
        createdAt: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          username?: string | null,
          emailVerified?: boolean | null,
          identityId?: string | null,
          credits?: number | null,
          boughtCredits?: number | null,
          creditPurchases?:  {
            __typename: "ModelCreditPurchaseConnection",
            nextToken?: string | null,
          } | null,
          orders?:  {
            __typename: "ModelOrderConnection",
            nextToken?: string | null,
          } | null,
          stripeCustomerId?: string | null,
          owner?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        creditAmount?: number | null,
        checkoutSessionId: string,
        paymentIntentId?: string | null,
        owner?: string | null,
        updatedAt: string,
        userCreditPurchasesId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    orders?:  {
      __typename: "ModelOrderConnection",
      items:  Array< {
        __typename: "Order",
        id: string,
        createdAt: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          username?: string | null,
          emailVerified?: boolean | null,
          identityId?: string | null,
          credits?: number | null,
          boughtCredits?: number | null,
          creditPurchases?:  {
            __typename: "ModelCreditPurchaseConnection",
            nextToken?: string | null,
          } | null,
          orders?:  {
            __typename: "ModelOrderConnection",
            nextToken?: string | null,
          } | null,
          stripeCustomerId?: string | null,
          owner?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        stripeCustomerId?: string | null,
        invoiceNumber?: string | null,
        invoiceId?: string | null,
        receiptNumber?: string | null,
        cart?:  {
          __typename: "Cart",
          id: string,
          createdAt: string,
          order?:  {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null,
          artOrders?:  {
            __typename: "ModelartOrderConnection",
            nextToken?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          updatedAt: string,
          cartOrderId?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        cost_taxes?: number | null,
        cost_shipping?: number | null,
        couponId?: string | null,
        coupon_amount_off?: number | null,
        coupon_name?: string | null,
        discountId?: string | null,
        discount_amount?: number | null,
        promotionID?: string | null,
        promotion_code?: string | null,
        fulfillment_tracking_id?: string | null,
        fulfillment_method?: string | null,
        fulfillment_status?: string | null,
        fulfillment_createdAt?: string | null,
        fulfillment_updatedAt?: string | null,
        fulfillment_completedAt?: string | null,
        billing_name?: string | null,
        billing_address?: string | null,
        billing_address2?: string | null,
        billing_city?: string | null,
        billing_state?: string | null,
        billing_zip?: string | null,
        billing_country?: string | null,
        shipping_name?: string | null,
        shipping_address?: string | null,
        shipping_address2?: string | null,
        shipping_city?: string | null,
        shipping_state?: string | null,
        shipping_zip?: string | null,
        shipping_country?: string | null,
        shipping_phone?: string | null,
        notes?: string | null,
        vendor?: string | null,
        order_source?: string | null,
        currency?: string | null,
        cancel?: boolean | null,
        updatedAt: string,
        userOrdersId?: string | null,
        orderCartId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    stripeCustomerId?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateSessionMutationVariables = {
  input: CreateSessionInput,
  condition?: ModelSessionConditionInput | null,
};

export type CreateSessionMutation = {
  createSession?:  {
    __typename: "Session",
    id: string,
    createdAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      username?: string | null,
      emailVerified?: boolean | null,
      identityId?: string | null,
      credits?: number | null,
      boughtCredits?: number | null,
      creditPurchases?:  {
        __typename: "ModelCreditPurchaseConnection",
        items:  Array< {
          __typename: "CreditPurchase",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          creditAmount?: number | null,
          checkoutSessionId: string,
          paymentIntentId?: string | null,
          owner?: string | null,
          updatedAt: string,
          userCreditPurchasesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      orders?:  {
        __typename: "ModelOrderConnection",
        items:  Array< {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    credentials?:  {
      __typename: "CognitoCredentials",
      AccessKeyId?: string | null,
      Expiration?: string | null,
      SecretKey?: string | null,
    } | null,
    owner?: string | null,
    updatedAt: string,
    sessionUserId?: string | null,
  } | null,
};

export type UpdateSessionMutationVariables = {
  input: UpdateSessionInput,
  condition?: ModelSessionConditionInput | null,
};

export type UpdateSessionMutation = {
  updateSession?:  {
    __typename: "Session",
    id: string,
    createdAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      username?: string | null,
      emailVerified?: boolean | null,
      identityId?: string | null,
      credits?: number | null,
      boughtCredits?: number | null,
      creditPurchases?:  {
        __typename: "ModelCreditPurchaseConnection",
        items:  Array< {
          __typename: "CreditPurchase",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          creditAmount?: number | null,
          checkoutSessionId: string,
          paymentIntentId?: string | null,
          owner?: string | null,
          updatedAt: string,
          userCreditPurchasesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      orders?:  {
        __typename: "ModelOrderConnection",
        items:  Array< {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    credentials?:  {
      __typename: "CognitoCredentials",
      AccessKeyId?: string | null,
      Expiration?: string | null,
      SecretKey?: string | null,
    } | null,
    owner?: string | null,
    updatedAt: string,
    sessionUserId?: string | null,
  } | null,
};

export type DeleteSessionMutationVariables = {
  input: DeleteSessionInput,
  condition?: ModelSessionConditionInput | null,
};

export type DeleteSessionMutation = {
  deleteSession?:  {
    __typename: "Session",
    id: string,
    createdAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      username?: string | null,
      emailVerified?: boolean | null,
      identityId?: string | null,
      credits?: number | null,
      boughtCredits?: number | null,
      creditPurchases?:  {
        __typename: "ModelCreditPurchaseConnection",
        items:  Array< {
          __typename: "CreditPurchase",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          creditAmount?: number | null,
          checkoutSessionId: string,
          paymentIntentId?: string | null,
          owner?: string | null,
          updatedAt: string,
          userCreditPurchasesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      orders?:  {
        __typename: "ModelOrderConnection",
        items:  Array< {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    credentials?:  {
      __typename: "CognitoCredentials",
      AccessKeyId?: string | null,
      Expiration?: string | null,
      SecretKey?: string | null,
    } | null,
    owner?: string | null,
    updatedAt: string,
    sessionUserId?: string | null,
  } | null,
};

export type CreateCreditPurchaseMutationVariables = {
  input: CreateCreditPurchaseInput,
  condition?: ModelCreditPurchaseConditionInput | null,
};

export type CreateCreditPurchaseMutation = {
  createCreditPurchase?:  {
    __typename: "CreditPurchase",
    id: string,
    createdAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      username?: string | null,
      emailVerified?: boolean | null,
      identityId?: string | null,
      credits?: number | null,
      boughtCredits?: number | null,
      creditPurchases?:  {
        __typename: "ModelCreditPurchaseConnection",
        items:  Array< {
          __typename: "CreditPurchase",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          creditAmount?: number | null,
          checkoutSessionId: string,
          paymentIntentId?: string | null,
          owner?: string | null,
          updatedAt: string,
          userCreditPurchasesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      orders?:  {
        __typename: "ModelOrderConnection",
        items:  Array< {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    creditAmount?: number | null,
    checkoutSessionId: string,
    paymentIntentId?: string | null,
    owner?: string | null,
    updatedAt: string,
    userCreditPurchasesId?: string | null,
  } | null,
};

export type UpdateCreditPurchaseMutationVariables = {
  input: UpdateCreditPurchaseInput,
  condition?: ModelCreditPurchaseConditionInput | null,
};

export type UpdateCreditPurchaseMutation = {
  updateCreditPurchase?:  {
    __typename: "CreditPurchase",
    id: string,
    createdAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      username?: string | null,
      emailVerified?: boolean | null,
      identityId?: string | null,
      credits?: number | null,
      boughtCredits?: number | null,
      creditPurchases?:  {
        __typename: "ModelCreditPurchaseConnection",
        items:  Array< {
          __typename: "CreditPurchase",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          creditAmount?: number | null,
          checkoutSessionId: string,
          paymentIntentId?: string | null,
          owner?: string | null,
          updatedAt: string,
          userCreditPurchasesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      orders?:  {
        __typename: "ModelOrderConnection",
        items:  Array< {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    creditAmount?: number | null,
    checkoutSessionId: string,
    paymentIntentId?: string | null,
    owner?: string | null,
    updatedAt: string,
    userCreditPurchasesId?: string | null,
  } | null,
};

export type DeleteCreditPurchaseMutationVariables = {
  input: DeleteCreditPurchaseInput,
  condition?: ModelCreditPurchaseConditionInput | null,
};

export type DeleteCreditPurchaseMutation = {
  deleteCreditPurchase?:  {
    __typename: "CreditPurchase",
    id: string,
    createdAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      username?: string | null,
      emailVerified?: boolean | null,
      identityId?: string | null,
      credits?: number | null,
      boughtCredits?: number | null,
      creditPurchases?:  {
        __typename: "ModelCreditPurchaseConnection",
        items:  Array< {
          __typename: "CreditPurchase",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          creditAmount?: number | null,
          checkoutSessionId: string,
          paymentIntentId?: string | null,
          owner?: string | null,
          updatedAt: string,
          userCreditPurchasesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      orders?:  {
        __typename: "ModelOrderConnection",
        items:  Array< {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    creditAmount?: number | null,
    checkoutSessionId: string,
    paymentIntentId?: string | null,
    owner?: string | null,
    updatedAt: string,
    userCreditPurchasesId?: string | null,
  } | null,
};

export type CreateGiftCardPurchaseMutationVariables = {
  input: CreateGiftCardPurchaseInput,
  condition?: ModelGiftCardPurchaseConditionInput | null,
};

export type CreateGiftCardPurchaseMutation = {
  createGiftCardPurchase?:  {
    __typename: "GiftCardPurchase",
    id: string,
    createdAt: string,
    originalBalance?: number | null,
    couponId?: string | null,
    couponAmountOff?: number | null,
    couponCurrency?: string | null,
    couponName?: string | null,
    couponDuration?: string | null,
    couponMaxRedemptions?: number | null,
    promotionCode?: string | null,
    promotionID?: string | null,
    checkoutSessionId: string,
    paymentIntentId?: string | null,
    recipientEmail: string,
    customMessage?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateGiftCardPurchaseMutationVariables = {
  input: UpdateGiftCardPurchaseInput,
  condition?: ModelGiftCardPurchaseConditionInput | null,
};

export type UpdateGiftCardPurchaseMutation = {
  updateGiftCardPurchase?:  {
    __typename: "GiftCardPurchase",
    id: string,
    createdAt: string,
    originalBalance?: number | null,
    couponId?: string | null,
    couponAmountOff?: number | null,
    couponCurrency?: string | null,
    couponName?: string | null,
    couponDuration?: string | null,
    couponMaxRedemptions?: number | null,
    promotionCode?: string | null,
    promotionID?: string | null,
    checkoutSessionId: string,
    paymentIntentId?: string | null,
    recipientEmail: string,
    customMessage?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteGiftCardPurchaseMutationVariables = {
  input: DeleteGiftCardPurchaseInput,
  condition?: ModelGiftCardPurchaseConditionInput | null,
};

export type DeleteGiftCardPurchaseMutation = {
  deleteGiftCardPurchase?:  {
    __typename: "GiftCardPurchase",
    id: string,
    createdAt: string,
    originalBalance?: number | null,
    couponId?: string | null,
    couponAmountOff?: number | null,
    couponCurrency?: string | null,
    couponName?: string | null,
    couponDuration?: string | null,
    couponMaxRedemptions?: number | null,
    promotionCode?: string | null,
    promotionID?: string | null,
    checkoutSessionId: string,
    paymentIntentId?: string | null,
    recipientEmail: string,
    customMessage?: string | null,
    updatedAt: string,
  } | null,
};

export type GetOrderQueryVariables = {
  id: string,
};

export type GetOrderQuery = {
  getOrder?:  {
    __typename: "Order",
    id: string,
    createdAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      username?: string | null,
      emailVerified?: boolean | null,
      identityId?: string | null,
      credits?: number | null,
      boughtCredits?: number | null,
      creditPurchases?:  {
        __typename: "ModelCreditPurchaseConnection",
        items:  Array< {
          __typename: "CreditPurchase",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          creditAmount?: number | null,
          checkoutSessionId: string,
          paymentIntentId?: string | null,
          owner?: string | null,
          updatedAt: string,
          userCreditPurchasesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      orders?:  {
        __typename: "ModelOrderConnection",
        items:  Array< {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    stripeCustomerId?: string | null,
    invoiceNumber?: string | null,
    invoiceId?: string | null,
    receiptNumber?: string | null,
    cart?:  {
      __typename: "Cart",
      id: string,
      createdAt: string,
      order?:  {
        __typename: "Order",
        id: string,
        createdAt: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          username?: string | null,
          emailVerified?: boolean | null,
          identityId?: string | null,
          credits?: number | null,
          boughtCredits?: number | null,
          creditPurchases?:  {
            __typename: "ModelCreditPurchaseConnection",
            nextToken?: string | null,
          } | null,
          orders?:  {
            __typename: "ModelOrderConnection",
            nextToken?: string | null,
          } | null,
          stripeCustomerId?: string | null,
          owner?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        stripeCustomerId?: string | null,
        invoiceNumber?: string | null,
        invoiceId?: string | null,
        receiptNumber?: string | null,
        cart?:  {
          __typename: "Cart",
          id: string,
          createdAt: string,
          order?:  {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null,
          artOrders?:  {
            __typename: "ModelartOrderConnection",
            nextToken?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          updatedAt: string,
          cartOrderId?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        cost_taxes?: number | null,
        cost_shipping?: number | null,
        couponId?: string | null,
        coupon_amount_off?: number | null,
        coupon_name?: string | null,
        discountId?: string | null,
        discount_amount?: number | null,
        promotionID?: string | null,
        promotion_code?: string | null,
        fulfillment_tracking_id?: string | null,
        fulfillment_method?: string | null,
        fulfillment_status?: string | null,
        fulfillment_createdAt?: string | null,
        fulfillment_updatedAt?: string | null,
        fulfillment_completedAt?: string | null,
        billing_name?: string | null,
        billing_address?: string | null,
        billing_address2?: string | null,
        billing_city?: string | null,
        billing_state?: string | null,
        billing_zip?: string | null,
        billing_country?: string | null,
        shipping_name?: string | null,
        shipping_address?: string | null,
        shipping_address2?: string | null,
        shipping_city?: string | null,
        shipping_state?: string | null,
        shipping_zip?: string | null,
        shipping_country?: string | null,
        shipping_phone?: string | null,
        notes?: string | null,
        vendor?: string | null,
        order_source?: string | null,
        currency?: string | null,
        cancel?: boolean | null,
        updatedAt: string,
        userOrdersId?: string | null,
        orderCartId?: string | null,
      } | null,
      artOrders?:  {
        __typename: "ModelartOrderConnection",
        items:  Array< {
          __typename: "artOrder",
          id: string,
          createdAt: string,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          orderID?: string | null,
          art?:  {
            __typename: "Art",
            id: string,
            userId: string,
            createdAt: string,
            title?: string | null,
            inputImage?: string | null,
            prompt?: string | null,
            revisedPrompt?: string | null,
            subject?: string | null,
            subjectText?: string | null,
            subOption?: string | null,
            styles?: string | null,
            stylesText?: string | null,
            color?: string | null,
            colorText?: string | null,
            medium?: string | null,
            mediumText?: string | null,
            model?: string | null,
            feeling?: string | null,
            feelingText?: string | null,
            like?: boolean | null,
            approve?: boolean | null,
            deleted?: boolean | null,
            updatedAt: string,
          } | null,
          email: string,
          file?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          dpi?: number | null,
          length?: number | null,
          width?: number | null,
          resolution_length?: number | null,
          resolution_width?: number | null,
          paper?: string | null,
          frame?: boolean | null,
          moulding?: string | null,
          moulding_finish?: string | null,
          mount?: string | null,
          total?: number | null,
          tax?: number | null,
          updatedAt: string,
          cartArtOrdersId?: string | null,
          artOrderArtId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      email: string,
      status?: string | null,
      cost_total?: number | null,
      updatedAt: string,
      cartOrderId?: string | null,
    } | null,
    email: string,
    status?: string | null,
    cost_total?: number | null,
    cost_taxes?: number | null,
    cost_shipping?: number | null,
    couponId?: string | null,
    coupon_amount_off?: number | null,
    coupon_name?: string | null,
    discountId?: string | null,
    discount_amount?: number | null,
    promotionID?: string | null,
    promotion_code?: string | null,
    fulfillment_tracking_id?: string | null,
    fulfillment_method?: string | null,
    fulfillment_status?: string | null,
    fulfillment_createdAt?: string | null,
    fulfillment_updatedAt?: string | null,
    fulfillment_completedAt?: string | null,
    billing_name?: string | null,
    billing_address?: string | null,
    billing_address2?: string | null,
    billing_city?: string | null,
    billing_state?: string | null,
    billing_zip?: string | null,
    billing_country?: string | null,
    shipping_name?: string | null,
    shipping_address?: string | null,
    shipping_address2?: string | null,
    shipping_city?: string | null,
    shipping_state?: string | null,
    shipping_zip?: string | null,
    shipping_country?: string | null,
    shipping_phone?: string | null,
    notes?: string | null,
    vendor?: string | null,
    order_source?: string | null,
    currency?: string | null,
    cancel?: boolean | null,
    updatedAt: string,
    userOrdersId?: string | null,
    orderCartId?: string | null,
  } | null,
};

export type ListOrdersQueryVariables = {
  filter?: ModelOrderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrdersQuery = {
  listOrders?:  {
    __typename: "ModelOrderConnection",
    items:  Array< {
      __typename: "Order",
      id: string,
      createdAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        username?: string | null,
        emailVerified?: boolean | null,
        identityId?: string | null,
        credits?: number | null,
        boughtCredits?: number | null,
        creditPurchases?:  {
          __typename: "ModelCreditPurchaseConnection",
          items:  Array< {
            __typename: "CreditPurchase",
            id: string,
            createdAt: string,
            creditAmount?: number | null,
            checkoutSessionId: string,
            paymentIntentId?: string | null,
            owner?: string | null,
            updatedAt: string,
            userCreditPurchasesId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        orders?:  {
          __typename: "ModelOrderConnection",
          items:  Array< {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        stripeCustomerId?: string | null,
        owner?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      stripeCustomerId?: string | null,
      invoiceNumber?: string | null,
      invoiceId?: string | null,
      receiptNumber?: string | null,
      cart?:  {
        __typename: "Cart",
        id: string,
        createdAt: string,
        order?:  {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null,
        artOrders?:  {
          __typename: "ModelartOrderConnection",
          items:  Array< {
            __typename: "artOrder",
            id: string,
            createdAt: string,
            orderID?: string | null,
            email: string,
            dpi?: number | null,
            length?: number | null,
            width?: number | null,
            resolution_length?: number | null,
            resolution_width?: number | null,
            paper?: string | null,
            frame?: boolean | null,
            moulding?: string | null,
            moulding_finish?: string | null,
            mount?: string | null,
            total?: number | null,
            tax?: number | null,
            updatedAt: string,
            cartArtOrdersId?: string | null,
            artOrderArtId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        updatedAt: string,
        cartOrderId?: string | null,
      } | null,
      email: string,
      status?: string | null,
      cost_total?: number | null,
      cost_taxes?: number | null,
      cost_shipping?: number | null,
      couponId?: string | null,
      coupon_amount_off?: number | null,
      coupon_name?: string | null,
      discountId?: string | null,
      discount_amount?: number | null,
      promotionID?: string | null,
      promotion_code?: string | null,
      fulfillment_tracking_id?: string | null,
      fulfillment_method?: string | null,
      fulfillment_status?: string | null,
      fulfillment_createdAt?: string | null,
      fulfillment_updatedAt?: string | null,
      fulfillment_completedAt?: string | null,
      billing_name?: string | null,
      billing_address?: string | null,
      billing_address2?: string | null,
      billing_city?: string | null,
      billing_state?: string | null,
      billing_zip?: string | null,
      billing_country?: string | null,
      shipping_name?: string | null,
      shipping_address?: string | null,
      shipping_address2?: string | null,
      shipping_city?: string | null,
      shipping_state?: string | null,
      shipping_zip?: string | null,
      shipping_country?: string | null,
      shipping_phone?: string | null,
      notes?: string | null,
      vendor?: string | null,
      order_source?: string | null,
      currency?: string | null,
      cancel?: boolean | null,
      updatedAt: string,
      userOrdersId?: string | null,
      orderCartId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OrdersByInvoiceNumberQueryVariables = {
  invoiceNumber: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOrderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type OrdersByInvoiceNumberQuery = {
  ordersByInvoiceNumber?:  {
    __typename: "ModelOrderConnection",
    items:  Array< {
      __typename: "Order",
      id: string,
      createdAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        username?: string | null,
        emailVerified?: boolean | null,
        identityId?: string | null,
        credits?: number | null,
        boughtCredits?: number | null,
        creditPurchases?:  {
          __typename: "ModelCreditPurchaseConnection",
          items:  Array< {
            __typename: "CreditPurchase",
            id: string,
            createdAt: string,
            creditAmount?: number | null,
            checkoutSessionId: string,
            paymentIntentId?: string | null,
            owner?: string | null,
            updatedAt: string,
            userCreditPurchasesId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        orders?:  {
          __typename: "ModelOrderConnection",
          items:  Array< {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        stripeCustomerId?: string | null,
        owner?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      stripeCustomerId?: string | null,
      invoiceNumber?: string | null,
      invoiceId?: string | null,
      receiptNumber?: string | null,
      cart?:  {
        __typename: "Cart",
        id: string,
        createdAt: string,
        order?:  {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null,
        artOrders?:  {
          __typename: "ModelartOrderConnection",
          items:  Array< {
            __typename: "artOrder",
            id: string,
            createdAt: string,
            orderID?: string | null,
            email: string,
            dpi?: number | null,
            length?: number | null,
            width?: number | null,
            resolution_length?: number | null,
            resolution_width?: number | null,
            paper?: string | null,
            frame?: boolean | null,
            moulding?: string | null,
            moulding_finish?: string | null,
            mount?: string | null,
            total?: number | null,
            tax?: number | null,
            updatedAt: string,
            cartArtOrdersId?: string | null,
            artOrderArtId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        updatedAt: string,
        cartOrderId?: string | null,
      } | null,
      email: string,
      status?: string | null,
      cost_total?: number | null,
      cost_taxes?: number | null,
      cost_shipping?: number | null,
      couponId?: string | null,
      coupon_amount_off?: number | null,
      coupon_name?: string | null,
      discountId?: string | null,
      discount_amount?: number | null,
      promotionID?: string | null,
      promotion_code?: string | null,
      fulfillment_tracking_id?: string | null,
      fulfillment_method?: string | null,
      fulfillment_status?: string | null,
      fulfillment_createdAt?: string | null,
      fulfillment_updatedAt?: string | null,
      fulfillment_completedAt?: string | null,
      billing_name?: string | null,
      billing_address?: string | null,
      billing_address2?: string | null,
      billing_city?: string | null,
      billing_state?: string | null,
      billing_zip?: string | null,
      billing_country?: string | null,
      shipping_name?: string | null,
      shipping_address?: string | null,
      shipping_address2?: string | null,
      shipping_city?: string | null,
      shipping_state?: string | null,
      shipping_zip?: string | null,
      shipping_country?: string | null,
      shipping_phone?: string | null,
      notes?: string | null,
      vendor?: string | null,
      order_source?: string | null,
      currency?: string | null,
      cancel?: boolean | null,
      updatedAt: string,
      userOrdersId?: string | null,
      orderCartId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OrdersByInvoiceIdQueryVariables = {
  invoiceId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOrderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type OrdersByInvoiceIdQuery = {
  ordersByInvoiceId?:  {
    __typename: "ModelOrderConnection",
    items:  Array< {
      __typename: "Order",
      id: string,
      createdAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        username?: string | null,
        emailVerified?: boolean | null,
        identityId?: string | null,
        credits?: number | null,
        boughtCredits?: number | null,
        creditPurchases?:  {
          __typename: "ModelCreditPurchaseConnection",
          items:  Array< {
            __typename: "CreditPurchase",
            id: string,
            createdAt: string,
            creditAmount?: number | null,
            checkoutSessionId: string,
            paymentIntentId?: string | null,
            owner?: string | null,
            updatedAt: string,
            userCreditPurchasesId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        orders?:  {
          __typename: "ModelOrderConnection",
          items:  Array< {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        stripeCustomerId?: string | null,
        owner?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      stripeCustomerId?: string | null,
      invoiceNumber?: string | null,
      invoiceId?: string | null,
      receiptNumber?: string | null,
      cart?:  {
        __typename: "Cart",
        id: string,
        createdAt: string,
        order?:  {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null,
        artOrders?:  {
          __typename: "ModelartOrderConnection",
          items:  Array< {
            __typename: "artOrder",
            id: string,
            createdAt: string,
            orderID?: string | null,
            email: string,
            dpi?: number | null,
            length?: number | null,
            width?: number | null,
            resolution_length?: number | null,
            resolution_width?: number | null,
            paper?: string | null,
            frame?: boolean | null,
            moulding?: string | null,
            moulding_finish?: string | null,
            mount?: string | null,
            total?: number | null,
            tax?: number | null,
            updatedAt: string,
            cartArtOrdersId?: string | null,
            artOrderArtId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        updatedAt: string,
        cartOrderId?: string | null,
      } | null,
      email: string,
      status?: string | null,
      cost_total?: number | null,
      cost_taxes?: number | null,
      cost_shipping?: number | null,
      couponId?: string | null,
      coupon_amount_off?: number | null,
      coupon_name?: string | null,
      discountId?: string | null,
      discount_amount?: number | null,
      promotionID?: string | null,
      promotion_code?: string | null,
      fulfillment_tracking_id?: string | null,
      fulfillment_method?: string | null,
      fulfillment_status?: string | null,
      fulfillment_createdAt?: string | null,
      fulfillment_updatedAt?: string | null,
      fulfillment_completedAt?: string | null,
      billing_name?: string | null,
      billing_address?: string | null,
      billing_address2?: string | null,
      billing_city?: string | null,
      billing_state?: string | null,
      billing_zip?: string | null,
      billing_country?: string | null,
      shipping_name?: string | null,
      shipping_address?: string | null,
      shipping_address2?: string | null,
      shipping_city?: string | null,
      shipping_state?: string | null,
      shipping_zip?: string | null,
      shipping_country?: string | null,
      shipping_phone?: string | null,
      notes?: string | null,
      vendor?: string | null,
      order_source?: string | null,
      currency?: string | null,
      cancel?: boolean | null,
      updatedAt: string,
      userOrdersId?: string | null,
      orderCartId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OrdersByEmailAndCreatedAtQueryVariables = {
  email: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOrderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type OrdersByEmailAndCreatedAtQuery = {
  ordersByEmailAndCreatedAt?:  {
    __typename: "ModelOrderConnection",
    items:  Array< {
      __typename: "Order",
      id: string,
      createdAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        username?: string | null,
        emailVerified?: boolean | null,
        identityId?: string | null,
        credits?: number | null,
        boughtCredits?: number | null,
        creditPurchases?:  {
          __typename: "ModelCreditPurchaseConnection",
          items:  Array< {
            __typename: "CreditPurchase",
            id: string,
            createdAt: string,
            creditAmount?: number | null,
            checkoutSessionId: string,
            paymentIntentId?: string | null,
            owner?: string | null,
            updatedAt: string,
            userCreditPurchasesId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        orders?:  {
          __typename: "ModelOrderConnection",
          items:  Array< {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        stripeCustomerId?: string | null,
        owner?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      stripeCustomerId?: string | null,
      invoiceNumber?: string | null,
      invoiceId?: string | null,
      receiptNumber?: string | null,
      cart?:  {
        __typename: "Cart",
        id: string,
        createdAt: string,
        order?:  {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null,
        artOrders?:  {
          __typename: "ModelartOrderConnection",
          items:  Array< {
            __typename: "artOrder",
            id: string,
            createdAt: string,
            orderID?: string | null,
            email: string,
            dpi?: number | null,
            length?: number | null,
            width?: number | null,
            resolution_length?: number | null,
            resolution_width?: number | null,
            paper?: string | null,
            frame?: boolean | null,
            moulding?: string | null,
            moulding_finish?: string | null,
            mount?: string | null,
            total?: number | null,
            tax?: number | null,
            updatedAt: string,
            cartArtOrdersId?: string | null,
            artOrderArtId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        updatedAt: string,
        cartOrderId?: string | null,
      } | null,
      email: string,
      status?: string | null,
      cost_total?: number | null,
      cost_taxes?: number | null,
      cost_shipping?: number | null,
      couponId?: string | null,
      coupon_amount_off?: number | null,
      coupon_name?: string | null,
      discountId?: string | null,
      discount_amount?: number | null,
      promotionID?: string | null,
      promotion_code?: string | null,
      fulfillment_tracking_id?: string | null,
      fulfillment_method?: string | null,
      fulfillment_status?: string | null,
      fulfillment_createdAt?: string | null,
      fulfillment_updatedAt?: string | null,
      fulfillment_completedAt?: string | null,
      billing_name?: string | null,
      billing_address?: string | null,
      billing_address2?: string | null,
      billing_city?: string | null,
      billing_state?: string | null,
      billing_zip?: string | null,
      billing_country?: string | null,
      shipping_name?: string | null,
      shipping_address?: string | null,
      shipping_address2?: string | null,
      shipping_city?: string | null,
      shipping_state?: string | null,
      shipping_zip?: string | null,
      shipping_country?: string | null,
      shipping_phone?: string | null,
      notes?: string | null,
      vendor?: string | null,
      order_source?: string | null,
      currency?: string | null,
      cancel?: boolean | null,
      updatedAt: string,
      userOrdersId?: string | null,
      orderCartId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCartQueryVariables = {
  id: string,
};

export type GetCartQuery = {
  getCart?:  {
    __typename: "Cart",
    id: string,
    createdAt: string,
    order?:  {
      __typename: "Order",
      id: string,
      createdAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        username?: string | null,
        emailVerified?: boolean | null,
        identityId?: string | null,
        credits?: number | null,
        boughtCredits?: number | null,
        creditPurchases?:  {
          __typename: "ModelCreditPurchaseConnection",
          items:  Array< {
            __typename: "CreditPurchase",
            id: string,
            createdAt: string,
            creditAmount?: number | null,
            checkoutSessionId: string,
            paymentIntentId?: string | null,
            owner?: string | null,
            updatedAt: string,
            userCreditPurchasesId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        orders?:  {
          __typename: "ModelOrderConnection",
          items:  Array< {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        stripeCustomerId?: string | null,
        owner?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      stripeCustomerId?: string | null,
      invoiceNumber?: string | null,
      invoiceId?: string | null,
      receiptNumber?: string | null,
      cart?:  {
        __typename: "Cart",
        id: string,
        createdAt: string,
        order?:  {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null,
        artOrders?:  {
          __typename: "ModelartOrderConnection",
          items:  Array< {
            __typename: "artOrder",
            id: string,
            createdAt: string,
            orderID?: string | null,
            email: string,
            dpi?: number | null,
            length?: number | null,
            width?: number | null,
            resolution_length?: number | null,
            resolution_width?: number | null,
            paper?: string | null,
            frame?: boolean | null,
            moulding?: string | null,
            moulding_finish?: string | null,
            mount?: string | null,
            total?: number | null,
            tax?: number | null,
            updatedAt: string,
            cartArtOrdersId?: string | null,
            artOrderArtId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        updatedAt: string,
        cartOrderId?: string | null,
      } | null,
      email: string,
      status?: string | null,
      cost_total?: number | null,
      cost_taxes?: number | null,
      cost_shipping?: number | null,
      couponId?: string | null,
      coupon_amount_off?: number | null,
      coupon_name?: string | null,
      discountId?: string | null,
      discount_amount?: number | null,
      promotionID?: string | null,
      promotion_code?: string | null,
      fulfillment_tracking_id?: string | null,
      fulfillment_method?: string | null,
      fulfillment_status?: string | null,
      fulfillment_createdAt?: string | null,
      fulfillment_updatedAt?: string | null,
      fulfillment_completedAt?: string | null,
      billing_name?: string | null,
      billing_address?: string | null,
      billing_address2?: string | null,
      billing_city?: string | null,
      billing_state?: string | null,
      billing_zip?: string | null,
      billing_country?: string | null,
      shipping_name?: string | null,
      shipping_address?: string | null,
      shipping_address2?: string | null,
      shipping_city?: string | null,
      shipping_state?: string | null,
      shipping_zip?: string | null,
      shipping_country?: string | null,
      shipping_phone?: string | null,
      notes?: string | null,
      vendor?: string | null,
      order_source?: string | null,
      currency?: string | null,
      cancel?: boolean | null,
      updatedAt: string,
      userOrdersId?: string | null,
      orderCartId?: string | null,
    } | null,
    artOrders?:  {
      __typename: "ModelartOrderConnection",
      items:  Array< {
        __typename: "artOrder",
        id: string,
        createdAt: string,
        cart?:  {
          __typename: "Cart",
          id: string,
          createdAt: string,
          order?:  {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null,
          artOrders?:  {
            __typename: "ModelartOrderConnection",
            nextToken?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          updatedAt: string,
          cartOrderId?: string | null,
        } | null,
        orderID?: string | null,
        art?:  {
          __typename: "Art",
          id: string,
          userId: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          title?: string | null,
          inputImage?: string | null,
          s3Image?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          prompt?: string | null,
          revisedPrompt?: string | null,
          subject?: string | null,
          subjectText?: string | null,
          subOption?: string | null,
          styles?: string | null,
          stylesText?: string | null,
          color?: string | null,
          colorText?: string | null,
          medium?: string | null,
          mediumText?: string | null,
          model?: string | null,
          feeling?: string | null,
          feelingText?: string | null,
          like?: boolean | null,
          approve?: boolean | null,
          deleted?: boolean | null,
          updatedAt: string,
        } | null,
        email: string,
        file?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        dpi?: number | null,
        length?: number | null,
        width?: number | null,
        resolution_length?: number | null,
        resolution_width?: number | null,
        paper?: string | null,
        frame?: boolean | null,
        moulding?: string | null,
        moulding_finish?: string | null,
        mount?: string | null,
        total?: number | null,
        tax?: number | null,
        updatedAt: string,
        cartArtOrdersId?: string | null,
        artOrderArtId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    email: string,
    status?: string | null,
    cost_total?: number | null,
    updatedAt: string,
    cartOrderId?: string | null,
  } | null,
};

export type ListCartsQueryVariables = {
  filter?: ModelCartFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCartsQuery = {
  listCarts?:  {
    __typename: "ModelCartConnection",
    items:  Array< {
      __typename: "Cart",
      id: string,
      createdAt: string,
      order?:  {
        __typename: "Order",
        id: string,
        createdAt: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          username?: string | null,
          emailVerified?: boolean | null,
          identityId?: string | null,
          credits?: number | null,
          boughtCredits?: number | null,
          creditPurchases?:  {
            __typename: "ModelCreditPurchaseConnection",
            nextToken?: string | null,
          } | null,
          orders?:  {
            __typename: "ModelOrderConnection",
            nextToken?: string | null,
          } | null,
          stripeCustomerId?: string | null,
          owner?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        stripeCustomerId?: string | null,
        invoiceNumber?: string | null,
        invoiceId?: string | null,
        receiptNumber?: string | null,
        cart?:  {
          __typename: "Cart",
          id: string,
          createdAt: string,
          order?:  {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null,
          artOrders?:  {
            __typename: "ModelartOrderConnection",
            nextToken?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          updatedAt: string,
          cartOrderId?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        cost_taxes?: number | null,
        cost_shipping?: number | null,
        couponId?: string | null,
        coupon_amount_off?: number | null,
        coupon_name?: string | null,
        discountId?: string | null,
        discount_amount?: number | null,
        promotionID?: string | null,
        promotion_code?: string | null,
        fulfillment_tracking_id?: string | null,
        fulfillment_method?: string | null,
        fulfillment_status?: string | null,
        fulfillment_createdAt?: string | null,
        fulfillment_updatedAt?: string | null,
        fulfillment_completedAt?: string | null,
        billing_name?: string | null,
        billing_address?: string | null,
        billing_address2?: string | null,
        billing_city?: string | null,
        billing_state?: string | null,
        billing_zip?: string | null,
        billing_country?: string | null,
        shipping_name?: string | null,
        shipping_address?: string | null,
        shipping_address2?: string | null,
        shipping_city?: string | null,
        shipping_state?: string | null,
        shipping_zip?: string | null,
        shipping_country?: string | null,
        shipping_phone?: string | null,
        notes?: string | null,
        vendor?: string | null,
        order_source?: string | null,
        currency?: string | null,
        cancel?: boolean | null,
        updatedAt: string,
        userOrdersId?: string | null,
        orderCartId?: string | null,
      } | null,
      artOrders?:  {
        __typename: "ModelartOrderConnection",
        items:  Array< {
          __typename: "artOrder",
          id: string,
          createdAt: string,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          orderID?: string | null,
          art?:  {
            __typename: "Art",
            id: string,
            userId: string,
            createdAt: string,
            title?: string | null,
            inputImage?: string | null,
            prompt?: string | null,
            revisedPrompt?: string | null,
            subject?: string | null,
            subjectText?: string | null,
            subOption?: string | null,
            styles?: string | null,
            stylesText?: string | null,
            color?: string | null,
            colorText?: string | null,
            medium?: string | null,
            mediumText?: string | null,
            model?: string | null,
            feeling?: string | null,
            feelingText?: string | null,
            like?: boolean | null,
            approve?: boolean | null,
            deleted?: boolean | null,
            updatedAt: string,
          } | null,
          email: string,
          file?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          dpi?: number | null,
          length?: number | null,
          width?: number | null,
          resolution_length?: number | null,
          resolution_width?: number | null,
          paper?: string | null,
          frame?: boolean | null,
          moulding?: string | null,
          moulding_finish?: string | null,
          mount?: string | null,
          total?: number | null,
          tax?: number | null,
          updatedAt: string,
          cartArtOrdersId?: string | null,
          artOrderArtId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      email: string,
      status?: string | null,
      cost_total?: number | null,
      updatedAt: string,
      cartOrderId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CartsByEmailAndCreatedAtQueryVariables = {
  email: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCartFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CartsByEmailAndCreatedAtQuery = {
  cartsByEmailAndCreatedAt?:  {
    __typename: "ModelCartConnection",
    items:  Array< {
      __typename: "Cart",
      id: string,
      createdAt: string,
      order?:  {
        __typename: "Order",
        id: string,
        createdAt: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          username?: string | null,
          emailVerified?: boolean | null,
          identityId?: string | null,
          credits?: number | null,
          boughtCredits?: number | null,
          creditPurchases?:  {
            __typename: "ModelCreditPurchaseConnection",
            nextToken?: string | null,
          } | null,
          orders?:  {
            __typename: "ModelOrderConnection",
            nextToken?: string | null,
          } | null,
          stripeCustomerId?: string | null,
          owner?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        stripeCustomerId?: string | null,
        invoiceNumber?: string | null,
        invoiceId?: string | null,
        receiptNumber?: string | null,
        cart?:  {
          __typename: "Cart",
          id: string,
          createdAt: string,
          order?:  {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null,
          artOrders?:  {
            __typename: "ModelartOrderConnection",
            nextToken?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          updatedAt: string,
          cartOrderId?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        cost_taxes?: number | null,
        cost_shipping?: number | null,
        couponId?: string | null,
        coupon_amount_off?: number | null,
        coupon_name?: string | null,
        discountId?: string | null,
        discount_amount?: number | null,
        promotionID?: string | null,
        promotion_code?: string | null,
        fulfillment_tracking_id?: string | null,
        fulfillment_method?: string | null,
        fulfillment_status?: string | null,
        fulfillment_createdAt?: string | null,
        fulfillment_updatedAt?: string | null,
        fulfillment_completedAt?: string | null,
        billing_name?: string | null,
        billing_address?: string | null,
        billing_address2?: string | null,
        billing_city?: string | null,
        billing_state?: string | null,
        billing_zip?: string | null,
        billing_country?: string | null,
        shipping_name?: string | null,
        shipping_address?: string | null,
        shipping_address2?: string | null,
        shipping_city?: string | null,
        shipping_state?: string | null,
        shipping_zip?: string | null,
        shipping_country?: string | null,
        shipping_phone?: string | null,
        notes?: string | null,
        vendor?: string | null,
        order_source?: string | null,
        currency?: string | null,
        cancel?: boolean | null,
        updatedAt: string,
        userOrdersId?: string | null,
        orderCartId?: string | null,
      } | null,
      artOrders?:  {
        __typename: "ModelartOrderConnection",
        items:  Array< {
          __typename: "artOrder",
          id: string,
          createdAt: string,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          orderID?: string | null,
          art?:  {
            __typename: "Art",
            id: string,
            userId: string,
            createdAt: string,
            title?: string | null,
            inputImage?: string | null,
            prompt?: string | null,
            revisedPrompt?: string | null,
            subject?: string | null,
            subjectText?: string | null,
            subOption?: string | null,
            styles?: string | null,
            stylesText?: string | null,
            color?: string | null,
            colorText?: string | null,
            medium?: string | null,
            mediumText?: string | null,
            model?: string | null,
            feeling?: string | null,
            feelingText?: string | null,
            like?: boolean | null,
            approve?: boolean | null,
            deleted?: boolean | null,
            updatedAt: string,
          } | null,
          email: string,
          file?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          dpi?: number | null,
          length?: number | null,
          width?: number | null,
          resolution_length?: number | null,
          resolution_width?: number | null,
          paper?: string | null,
          frame?: boolean | null,
          moulding?: string | null,
          moulding_finish?: string | null,
          mount?: string | null,
          total?: number | null,
          tax?: number | null,
          updatedAt: string,
          cartArtOrdersId?: string | null,
          artOrderArtId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      email: string,
      status?: string | null,
      cost_total?: number | null,
      updatedAt: string,
      cartOrderId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetArtOrderQueryVariables = {
  id: string,
};

export type GetArtOrderQuery = {
  getArtOrder?:  {
    __typename: "artOrder",
    id: string,
    createdAt: string,
    cart?:  {
      __typename: "Cart",
      id: string,
      createdAt: string,
      order?:  {
        __typename: "Order",
        id: string,
        createdAt: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          username?: string | null,
          emailVerified?: boolean | null,
          identityId?: string | null,
          credits?: number | null,
          boughtCredits?: number | null,
          creditPurchases?:  {
            __typename: "ModelCreditPurchaseConnection",
            nextToken?: string | null,
          } | null,
          orders?:  {
            __typename: "ModelOrderConnection",
            nextToken?: string | null,
          } | null,
          stripeCustomerId?: string | null,
          owner?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        stripeCustomerId?: string | null,
        invoiceNumber?: string | null,
        invoiceId?: string | null,
        receiptNumber?: string | null,
        cart?:  {
          __typename: "Cart",
          id: string,
          createdAt: string,
          order?:  {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null,
          artOrders?:  {
            __typename: "ModelartOrderConnection",
            nextToken?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          updatedAt: string,
          cartOrderId?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        cost_taxes?: number | null,
        cost_shipping?: number | null,
        couponId?: string | null,
        coupon_amount_off?: number | null,
        coupon_name?: string | null,
        discountId?: string | null,
        discount_amount?: number | null,
        promotionID?: string | null,
        promotion_code?: string | null,
        fulfillment_tracking_id?: string | null,
        fulfillment_method?: string | null,
        fulfillment_status?: string | null,
        fulfillment_createdAt?: string | null,
        fulfillment_updatedAt?: string | null,
        fulfillment_completedAt?: string | null,
        billing_name?: string | null,
        billing_address?: string | null,
        billing_address2?: string | null,
        billing_city?: string | null,
        billing_state?: string | null,
        billing_zip?: string | null,
        billing_country?: string | null,
        shipping_name?: string | null,
        shipping_address?: string | null,
        shipping_address2?: string | null,
        shipping_city?: string | null,
        shipping_state?: string | null,
        shipping_zip?: string | null,
        shipping_country?: string | null,
        shipping_phone?: string | null,
        notes?: string | null,
        vendor?: string | null,
        order_source?: string | null,
        currency?: string | null,
        cancel?: boolean | null,
        updatedAt: string,
        userOrdersId?: string | null,
        orderCartId?: string | null,
      } | null,
      artOrders?:  {
        __typename: "ModelartOrderConnection",
        items:  Array< {
          __typename: "artOrder",
          id: string,
          createdAt: string,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          orderID?: string | null,
          art?:  {
            __typename: "Art",
            id: string,
            userId: string,
            createdAt: string,
            title?: string | null,
            inputImage?: string | null,
            prompt?: string | null,
            revisedPrompt?: string | null,
            subject?: string | null,
            subjectText?: string | null,
            subOption?: string | null,
            styles?: string | null,
            stylesText?: string | null,
            color?: string | null,
            colorText?: string | null,
            medium?: string | null,
            mediumText?: string | null,
            model?: string | null,
            feeling?: string | null,
            feelingText?: string | null,
            like?: boolean | null,
            approve?: boolean | null,
            deleted?: boolean | null,
            updatedAt: string,
          } | null,
          email: string,
          file?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          dpi?: number | null,
          length?: number | null,
          width?: number | null,
          resolution_length?: number | null,
          resolution_width?: number | null,
          paper?: string | null,
          frame?: boolean | null,
          moulding?: string | null,
          moulding_finish?: string | null,
          mount?: string | null,
          total?: number | null,
          tax?: number | null,
          updatedAt: string,
          cartArtOrdersId?: string | null,
          artOrderArtId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      email: string,
      status?: string | null,
      cost_total?: number | null,
      updatedAt: string,
      cartOrderId?: string | null,
    } | null,
    orderID?: string | null,
    art?:  {
      __typename: "Art",
      id: string,
      userId: string,
      createdAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        username?: string | null,
        emailVerified?: boolean | null,
        identityId?: string | null,
        credits?: number | null,
        boughtCredits?: number | null,
        creditPurchases?:  {
          __typename: "ModelCreditPurchaseConnection",
          items:  Array< {
            __typename: "CreditPurchase",
            id: string,
            createdAt: string,
            creditAmount?: number | null,
            checkoutSessionId: string,
            paymentIntentId?: string | null,
            owner?: string | null,
            updatedAt: string,
            userCreditPurchasesId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        orders?:  {
          __typename: "ModelOrderConnection",
          items:  Array< {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        stripeCustomerId?: string | null,
        owner?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      title?: string | null,
      inputImage?: string | null,
      s3Image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      prompt?: string | null,
      revisedPrompt?: string | null,
      subject?: string | null,
      subjectText?: string | null,
      subOption?: string | null,
      styles?: string | null,
      stylesText?: string | null,
      color?: string | null,
      colorText?: string | null,
      medium?: string | null,
      mediumText?: string | null,
      model?: string | null,
      feeling?: string | null,
      feelingText?: string | null,
      like?: boolean | null,
      approve?: boolean | null,
      deleted?: boolean | null,
      updatedAt: string,
    } | null,
    email: string,
    file?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    dpi?: number | null,
    length?: number | null,
    width?: number | null,
    resolution_length?: number | null,
    resolution_width?: number | null,
    paper?: string | null,
    frame?: boolean | null,
    moulding?: string | null,
    moulding_finish?: string | null,
    mount?: string | null,
    total?: number | null,
    tax?: number | null,
    updatedAt: string,
    cartArtOrdersId?: string | null,
    artOrderArtId?: string | null,
  } | null,
};

export type ListArtOrdersQueryVariables = {
  filter?: ModelArtOrderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListArtOrdersQuery = {
  listArtOrders?:  {
    __typename: "ModelArtOrderConnection",
    items:  Array< {
      __typename: "artOrder",
      id: string,
      createdAt: string,
      cart?:  {
        __typename: "Cart",
        id: string,
        createdAt: string,
        order?:  {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null,
        artOrders?:  {
          __typename: "ModelartOrderConnection",
          items:  Array< {
            __typename: "artOrder",
            id: string,
            createdAt: string,
            orderID?: string | null,
            email: string,
            dpi?: number | null,
            length?: number | null,
            width?: number | null,
            resolution_length?: number | null,
            resolution_width?: number | null,
            paper?: string | null,
            frame?: boolean | null,
            moulding?: string | null,
            moulding_finish?: string | null,
            mount?: string | null,
            total?: number | null,
            tax?: number | null,
            updatedAt: string,
            cartArtOrdersId?: string | null,
            artOrderArtId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        updatedAt: string,
        cartOrderId?: string | null,
      } | null,
      orderID?: string | null,
      art?:  {
        __typename: "Art",
        id: string,
        userId: string,
        createdAt: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          username?: string | null,
          emailVerified?: boolean | null,
          identityId?: string | null,
          credits?: number | null,
          boughtCredits?: number | null,
          creditPurchases?:  {
            __typename: "ModelCreditPurchaseConnection",
            nextToken?: string | null,
          } | null,
          orders?:  {
            __typename: "ModelOrderConnection",
            nextToken?: string | null,
          } | null,
          stripeCustomerId?: string | null,
          owner?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        title?: string | null,
        inputImage?: string | null,
        s3Image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        prompt?: string | null,
        revisedPrompt?: string | null,
        subject?: string | null,
        subjectText?: string | null,
        subOption?: string | null,
        styles?: string | null,
        stylesText?: string | null,
        color?: string | null,
        colorText?: string | null,
        medium?: string | null,
        mediumText?: string | null,
        model?: string | null,
        feeling?: string | null,
        feelingText?: string | null,
        like?: boolean | null,
        approve?: boolean | null,
        deleted?: boolean | null,
        updatedAt: string,
      } | null,
      email: string,
      file?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      dpi?: number | null,
      length?: number | null,
      width?: number | null,
      resolution_length?: number | null,
      resolution_width?: number | null,
      paper?: string | null,
      frame?: boolean | null,
      moulding?: string | null,
      moulding_finish?: string | null,
      mount?: string | null,
      total?: number | null,
      tax?: number | null,
      updatedAt: string,
      cartArtOrdersId?: string | null,
      artOrderArtId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ArtOrdersByEmailAndCreatedAtQueryVariables = {
  email: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelartOrderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ArtOrdersByEmailAndCreatedAtQuery = {
  artOrdersByEmailAndCreatedAt?:  {
    __typename: "ModelartOrderConnection",
    items:  Array< {
      __typename: "artOrder",
      id: string,
      createdAt: string,
      cart?:  {
        __typename: "Cart",
        id: string,
        createdAt: string,
        order?:  {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null,
        artOrders?:  {
          __typename: "ModelartOrderConnection",
          items:  Array< {
            __typename: "artOrder",
            id: string,
            createdAt: string,
            orderID?: string | null,
            email: string,
            dpi?: number | null,
            length?: number | null,
            width?: number | null,
            resolution_length?: number | null,
            resolution_width?: number | null,
            paper?: string | null,
            frame?: boolean | null,
            moulding?: string | null,
            moulding_finish?: string | null,
            mount?: string | null,
            total?: number | null,
            tax?: number | null,
            updatedAt: string,
            cartArtOrdersId?: string | null,
            artOrderArtId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        updatedAt: string,
        cartOrderId?: string | null,
      } | null,
      orderID?: string | null,
      art?:  {
        __typename: "Art",
        id: string,
        userId: string,
        createdAt: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          username?: string | null,
          emailVerified?: boolean | null,
          identityId?: string | null,
          credits?: number | null,
          boughtCredits?: number | null,
          creditPurchases?:  {
            __typename: "ModelCreditPurchaseConnection",
            nextToken?: string | null,
          } | null,
          orders?:  {
            __typename: "ModelOrderConnection",
            nextToken?: string | null,
          } | null,
          stripeCustomerId?: string | null,
          owner?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        title?: string | null,
        inputImage?: string | null,
        s3Image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        prompt?: string | null,
        revisedPrompt?: string | null,
        subject?: string | null,
        subjectText?: string | null,
        subOption?: string | null,
        styles?: string | null,
        stylesText?: string | null,
        color?: string | null,
        colorText?: string | null,
        medium?: string | null,
        mediumText?: string | null,
        model?: string | null,
        feeling?: string | null,
        feelingText?: string | null,
        like?: boolean | null,
        approve?: boolean | null,
        deleted?: boolean | null,
        updatedAt: string,
      } | null,
      email: string,
      file?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      dpi?: number | null,
      length?: number | null,
      width?: number | null,
      resolution_length?: number | null,
      resolution_width?: number | null,
      paper?: string | null,
      frame?: boolean | null,
      moulding?: string | null,
      moulding_finish?: string | null,
      mount?: string | null,
      total?: number | null,
      tax?: number | null,
      updatedAt: string,
      cartArtOrdersId?: string | null,
      artOrderArtId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetArtQueryVariables = {
  id: string,
};

export type GetArtQuery = {
  getArt?:  {
    __typename: "Art",
    id: string,
    userId: string,
    createdAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      username?: string | null,
      emailVerified?: boolean | null,
      identityId?: string | null,
      credits?: number | null,
      boughtCredits?: number | null,
      creditPurchases?:  {
        __typename: "ModelCreditPurchaseConnection",
        items:  Array< {
          __typename: "CreditPurchase",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          creditAmount?: number | null,
          checkoutSessionId: string,
          paymentIntentId?: string | null,
          owner?: string | null,
          updatedAt: string,
          userCreditPurchasesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      orders?:  {
        __typename: "ModelOrderConnection",
        items:  Array< {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    title?: string | null,
    inputImage?: string | null,
    s3Image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    prompt?: string | null,
    revisedPrompt?: string | null,
    subject?: string | null,
    subjectText?: string | null,
    subOption?: string | null,
    styles?: string | null,
    stylesText?: string | null,
    color?: string | null,
    colorText?: string | null,
    medium?: string | null,
    mediumText?: string | null,
    model?: string | null,
    feeling?: string | null,
    feelingText?: string | null,
    like?: boolean | null,
    approve?: boolean | null,
    deleted?: boolean | null,
    updatedAt: string,
  } | null,
};

export type ListArtsQueryVariables = {
  filter?: ModelArtFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListArtsQuery = {
  listArts?:  {
    __typename: "ModelArtConnection",
    items:  Array< {
      __typename: "Art",
      id: string,
      userId: string,
      createdAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        username?: string | null,
        emailVerified?: boolean | null,
        identityId?: string | null,
        credits?: number | null,
        boughtCredits?: number | null,
        creditPurchases?:  {
          __typename: "ModelCreditPurchaseConnection",
          items:  Array< {
            __typename: "CreditPurchase",
            id: string,
            createdAt: string,
            creditAmount?: number | null,
            checkoutSessionId: string,
            paymentIntentId?: string | null,
            owner?: string | null,
            updatedAt: string,
            userCreditPurchasesId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        orders?:  {
          __typename: "ModelOrderConnection",
          items:  Array< {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        stripeCustomerId?: string | null,
        owner?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      title?: string | null,
      inputImage?: string | null,
      s3Image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      prompt?: string | null,
      revisedPrompt?: string | null,
      subject?: string | null,
      subjectText?: string | null,
      subOption?: string | null,
      styles?: string | null,
      stylesText?: string | null,
      color?: string | null,
      colorText?: string | null,
      medium?: string | null,
      mediumText?: string | null,
      model?: string | null,
      feeling?: string | null,
      feelingText?: string | null,
      like?: boolean | null,
      approve?: boolean | null,
      deleted?: boolean | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ArtsByUserIdAndCreatedAtQueryVariables = {
  userId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelArtFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ArtsByUserIdAndCreatedAtQuery = {
  artsByUserIdAndCreatedAt?:  {
    __typename: "ModelArtConnection",
    items:  Array< {
      __typename: "Art",
      id: string,
      userId: string,
      createdAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        username?: string | null,
        emailVerified?: boolean | null,
        identityId?: string | null,
        credits?: number | null,
        boughtCredits?: number | null,
        creditPurchases?:  {
          __typename: "ModelCreditPurchaseConnection",
          items:  Array< {
            __typename: "CreditPurchase",
            id: string,
            createdAt: string,
            creditAmount?: number | null,
            checkoutSessionId: string,
            paymentIntentId?: string | null,
            owner?: string | null,
            updatedAt: string,
            userCreditPurchasesId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        orders?:  {
          __typename: "ModelOrderConnection",
          items:  Array< {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        stripeCustomerId?: string | null,
        owner?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      title?: string | null,
      inputImage?: string | null,
      s3Image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      prompt?: string | null,
      revisedPrompt?: string | null,
      subject?: string | null,
      subjectText?: string | null,
      subOption?: string | null,
      styles?: string | null,
      stylesText?: string | null,
      color?: string | null,
      colorText?: string | null,
      medium?: string | null,
      mediumText?: string | null,
      model?: string | null,
      feeling?: string | null,
      feelingText?: string | null,
      like?: boolean | null,
      approve?: boolean | null,
      deleted?: boolean | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserQueryVariables = {
  id: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename: "User",
    id: string,
    email: string,
    username?: string | null,
    emailVerified?: boolean | null,
    identityId?: string | null,
    credits?: number | null,
    boughtCredits?: number | null,
    creditPurchases?:  {
      __typename: "ModelCreditPurchaseConnection",
      items:  Array< {
        __typename: "CreditPurchase",
        id: string,
        createdAt: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          username?: string | null,
          emailVerified?: boolean | null,
          identityId?: string | null,
          credits?: number | null,
          boughtCredits?: number | null,
          creditPurchases?:  {
            __typename: "ModelCreditPurchaseConnection",
            nextToken?: string | null,
          } | null,
          orders?:  {
            __typename: "ModelOrderConnection",
            nextToken?: string | null,
          } | null,
          stripeCustomerId?: string | null,
          owner?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        creditAmount?: number | null,
        checkoutSessionId: string,
        paymentIntentId?: string | null,
        owner?: string | null,
        updatedAt: string,
        userCreditPurchasesId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    orders?:  {
      __typename: "ModelOrderConnection",
      items:  Array< {
        __typename: "Order",
        id: string,
        createdAt: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          username?: string | null,
          emailVerified?: boolean | null,
          identityId?: string | null,
          credits?: number | null,
          boughtCredits?: number | null,
          creditPurchases?:  {
            __typename: "ModelCreditPurchaseConnection",
            nextToken?: string | null,
          } | null,
          orders?:  {
            __typename: "ModelOrderConnection",
            nextToken?: string | null,
          } | null,
          stripeCustomerId?: string | null,
          owner?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        stripeCustomerId?: string | null,
        invoiceNumber?: string | null,
        invoiceId?: string | null,
        receiptNumber?: string | null,
        cart?:  {
          __typename: "Cart",
          id: string,
          createdAt: string,
          order?:  {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null,
          artOrders?:  {
            __typename: "ModelartOrderConnection",
            nextToken?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          updatedAt: string,
          cartOrderId?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        cost_taxes?: number | null,
        cost_shipping?: number | null,
        couponId?: string | null,
        coupon_amount_off?: number | null,
        coupon_name?: string | null,
        discountId?: string | null,
        discount_amount?: number | null,
        promotionID?: string | null,
        promotion_code?: string | null,
        fulfillment_tracking_id?: string | null,
        fulfillment_method?: string | null,
        fulfillment_status?: string | null,
        fulfillment_createdAt?: string | null,
        fulfillment_updatedAt?: string | null,
        fulfillment_completedAt?: string | null,
        billing_name?: string | null,
        billing_address?: string | null,
        billing_address2?: string | null,
        billing_city?: string | null,
        billing_state?: string | null,
        billing_zip?: string | null,
        billing_country?: string | null,
        shipping_name?: string | null,
        shipping_address?: string | null,
        shipping_address2?: string | null,
        shipping_city?: string | null,
        shipping_state?: string | null,
        shipping_zip?: string | null,
        shipping_country?: string | null,
        shipping_phone?: string | null,
        notes?: string | null,
        vendor?: string | null,
        order_source?: string | null,
        currency?: string | null,
        cancel?: boolean | null,
        updatedAt: string,
        userOrdersId?: string | null,
        orderCartId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    stripeCustomerId?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUsersQueryVariables = {
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUsersQuery = {
  listUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      email: string,
      username?: string | null,
      emailVerified?: boolean | null,
      identityId?: string | null,
      credits?: number | null,
      boughtCredits?: number | null,
      creditPurchases?:  {
        __typename: "ModelCreditPurchaseConnection",
        items:  Array< {
          __typename: "CreditPurchase",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          creditAmount?: number | null,
          checkoutSessionId: string,
          paymentIntentId?: string | null,
          owner?: string | null,
          updatedAt: string,
          userCreditPurchasesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      orders?:  {
        __typename: "ModelOrderConnection",
        items:  Array< {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UsersByEmailQueryVariables = {
  email: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UsersByEmailQuery = {
  usersByEmail?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      email: string,
      username?: string | null,
      emailVerified?: boolean | null,
      identityId?: string | null,
      credits?: number | null,
      boughtCredits?: number | null,
      creditPurchases?:  {
        __typename: "ModelCreditPurchaseConnection",
        items:  Array< {
          __typename: "CreditPurchase",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          creditAmount?: number | null,
          checkoutSessionId: string,
          paymentIntentId?: string | null,
          owner?: string | null,
          updatedAt: string,
          userCreditPurchasesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      orders?:  {
        __typename: "ModelOrderConnection",
        items:  Array< {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetSessionQueryVariables = {
  id: string,
};

export type GetSessionQuery = {
  getSession?:  {
    __typename: "Session",
    id: string,
    createdAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      username?: string | null,
      emailVerified?: boolean | null,
      identityId?: string | null,
      credits?: number | null,
      boughtCredits?: number | null,
      creditPurchases?:  {
        __typename: "ModelCreditPurchaseConnection",
        items:  Array< {
          __typename: "CreditPurchase",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          creditAmount?: number | null,
          checkoutSessionId: string,
          paymentIntentId?: string | null,
          owner?: string | null,
          updatedAt: string,
          userCreditPurchasesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      orders?:  {
        __typename: "ModelOrderConnection",
        items:  Array< {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    credentials?:  {
      __typename: "CognitoCredentials",
      AccessKeyId?: string | null,
      Expiration?: string | null,
      SecretKey?: string | null,
    } | null,
    owner?: string | null,
    updatedAt: string,
    sessionUserId?: string | null,
  } | null,
};

export type ListSessionsQueryVariables = {
  filter?: ModelSessionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSessionsQuery = {
  listSessions?:  {
    __typename: "ModelSessionConnection",
    items:  Array< {
      __typename: "Session",
      id: string,
      createdAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        username?: string | null,
        emailVerified?: boolean | null,
        identityId?: string | null,
        credits?: number | null,
        boughtCredits?: number | null,
        creditPurchases?:  {
          __typename: "ModelCreditPurchaseConnection",
          items:  Array< {
            __typename: "CreditPurchase",
            id: string,
            createdAt: string,
            creditAmount?: number | null,
            checkoutSessionId: string,
            paymentIntentId?: string | null,
            owner?: string | null,
            updatedAt: string,
            userCreditPurchasesId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        orders?:  {
          __typename: "ModelOrderConnection",
          items:  Array< {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        stripeCustomerId?: string | null,
        owner?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      credentials?:  {
        __typename: "CognitoCredentials",
        AccessKeyId?: string | null,
        Expiration?: string | null,
        SecretKey?: string | null,
      } | null,
      owner?: string | null,
      updatedAt: string,
      sessionUserId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCreditPurchaseQueryVariables = {
  id: string,
};

export type GetCreditPurchaseQuery = {
  getCreditPurchase?:  {
    __typename: "CreditPurchase",
    id: string,
    createdAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      username?: string | null,
      emailVerified?: boolean | null,
      identityId?: string | null,
      credits?: number | null,
      boughtCredits?: number | null,
      creditPurchases?:  {
        __typename: "ModelCreditPurchaseConnection",
        items:  Array< {
          __typename: "CreditPurchase",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          creditAmount?: number | null,
          checkoutSessionId: string,
          paymentIntentId?: string | null,
          owner?: string | null,
          updatedAt: string,
          userCreditPurchasesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      orders?:  {
        __typename: "ModelOrderConnection",
        items:  Array< {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    creditAmount?: number | null,
    checkoutSessionId: string,
    paymentIntentId?: string | null,
    owner?: string | null,
    updatedAt: string,
    userCreditPurchasesId?: string | null,
  } | null,
};

export type ListCreditPurchasesQueryVariables = {
  filter?: ModelCreditPurchaseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCreditPurchasesQuery = {
  listCreditPurchases?:  {
    __typename: "ModelCreditPurchaseConnection",
    items:  Array< {
      __typename: "CreditPurchase",
      id: string,
      createdAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        username?: string | null,
        emailVerified?: boolean | null,
        identityId?: string | null,
        credits?: number | null,
        boughtCredits?: number | null,
        creditPurchases?:  {
          __typename: "ModelCreditPurchaseConnection",
          items:  Array< {
            __typename: "CreditPurchase",
            id: string,
            createdAt: string,
            creditAmount?: number | null,
            checkoutSessionId: string,
            paymentIntentId?: string | null,
            owner?: string | null,
            updatedAt: string,
            userCreditPurchasesId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        orders?:  {
          __typename: "ModelOrderConnection",
          items:  Array< {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        stripeCustomerId?: string | null,
        owner?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      creditAmount?: number | null,
      checkoutSessionId: string,
      paymentIntentId?: string | null,
      owner?: string | null,
      updatedAt: string,
      userCreditPurchasesId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CreditPurchasesByCheckoutSessionIdQueryVariables = {
  checkoutSessionId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCreditPurchaseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CreditPurchasesByCheckoutSessionIdQuery = {
  creditPurchasesByCheckoutSessionId?:  {
    __typename: "ModelCreditPurchaseConnection",
    items:  Array< {
      __typename: "CreditPurchase",
      id: string,
      createdAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        username?: string | null,
        emailVerified?: boolean | null,
        identityId?: string | null,
        credits?: number | null,
        boughtCredits?: number | null,
        creditPurchases?:  {
          __typename: "ModelCreditPurchaseConnection",
          items:  Array< {
            __typename: "CreditPurchase",
            id: string,
            createdAt: string,
            creditAmount?: number | null,
            checkoutSessionId: string,
            paymentIntentId?: string | null,
            owner?: string | null,
            updatedAt: string,
            userCreditPurchasesId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        orders?:  {
          __typename: "ModelOrderConnection",
          items:  Array< {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        stripeCustomerId?: string | null,
        owner?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      creditAmount?: number | null,
      checkoutSessionId: string,
      paymentIntentId?: string | null,
      owner?: string | null,
      updatedAt: string,
      userCreditPurchasesId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetGiftCardPurchaseQueryVariables = {
  id: string,
};

export type GetGiftCardPurchaseQuery = {
  getGiftCardPurchase?:  {
    __typename: "GiftCardPurchase",
    id: string,
    createdAt: string,
    originalBalance?: number | null,
    couponId?: string | null,
    couponAmountOff?: number | null,
    couponCurrency?: string | null,
    couponName?: string | null,
    couponDuration?: string | null,
    couponMaxRedemptions?: number | null,
    promotionCode?: string | null,
    promotionID?: string | null,
    checkoutSessionId: string,
    paymentIntentId?: string | null,
    recipientEmail: string,
    customMessage?: string | null,
    updatedAt: string,
  } | null,
};

export type ListGiftCardPurchasesQueryVariables = {
  filter?: ModelGiftCardPurchaseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListGiftCardPurchasesQuery = {
  listGiftCardPurchases?:  {
    __typename: "ModelGiftCardPurchaseConnection",
    items:  Array< {
      __typename: "GiftCardPurchase",
      id: string,
      createdAt: string,
      originalBalance?: number | null,
      couponId?: string | null,
      couponAmountOff?: number | null,
      couponCurrency?: string | null,
      couponName?: string | null,
      couponDuration?: string | null,
      couponMaxRedemptions?: number | null,
      promotionCode?: string | null,
      promotionID?: string | null,
      checkoutSessionId: string,
      paymentIntentId?: string | null,
      recipientEmail: string,
      customMessage?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GiftCardPurchasesByCheckoutSessionIdQueryVariables = {
  checkoutSessionId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelGiftCardPurchaseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GiftCardPurchasesByCheckoutSessionIdQuery = {
  giftCardPurchasesByCheckoutSessionId?:  {
    __typename: "ModelGiftCardPurchaseConnection",
    items:  Array< {
      __typename: "GiftCardPurchase",
      id: string,
      createdAt: string,
      originalBalance?: number | null,
      couponId?: string | null,
      couponAmountOff?: number | null,
      couponCurrency?: string | null,
      couponName?: string | null,
      couponDuration?: string | null,
      couponMaxRedemptions?: number | null,
      promotionCode?: string | null,
      promotionID?: string | null,
      checkoutSessionId: string,
      paymentIntentId?: string | null,
      recipientEmail: string,
      customMessage?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GiftCardPurchasesByRecipientEmailQueryVariables = {
  recipientEmail: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelGiftCardPurchaseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GiftCardPurchasesByRecipientEmailQuery = {
  giftCardPurchasesByRecipientEmail?:  {
    __typename: "ModelGiftCardPurchaseConnection",
    items:  Array< {
      __typename: "GiftCardPurchase",
      id: string,
      createdAt: string,
      originalBalance?: number | null,
      couponId?: string | null,
      couponAmountOff?: number | null,
      couponCurrency?: string | null,
      couponName?: string | null,
      couponDuration?: string | null,
      couponMaxRedemptions?: number | null,
      promotionCode?: string | null,
      promotionID?: string | null,
      checkoutSessionId: string,
      paymentIntentId?: string | null,
      recipientEmail: string,
      customMessage?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OnCreateOrderSubscriptionVariables = {
  filter?: ModelSubscriptionOrderFilterInput | null,
};

export type OnCreateOrderSubscription = {
  onCreateOrder?:  {
    __typename: "Order",
    id: string,
    createdAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      username?: string | null,
      emailVerified?: boolean | null,
      identityId?: string | null,
      credits?: number | null,
      boughtCredits?: number | null,
      creditPurchases?:  {
        __typename: "ModelCreditPurchaseConnection",
        items:  Array< {
          __typename: "CreditPurchase",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          creditAmount?: number | null,
          checkoutSessionId: string,
          paymentIntentId?: string | null,
          owner?: string | null,
          updatedAt: string,
          userCreditPurchasesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      orders?:  {
        __typename: "ModelOrderConnection",
        items:  Array< {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    stripeCustomerId?: string | null,
    invoiceNumber?: string | null,
    invoiceId?: string | null,
    receiptNumber?: string | null,
    cart?:  {
      __typename: "Cart",
      id: string,
      createdAt: string,
      order?:  {
        __typename: "Order",
        id: string,
        createdAt: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          username?: string | null,
          emailVerified?: boolean | null,
          identityId?: string | null,
          credits?: number | null,
          boughtCredits?: number | null,
          creditPurchases?:  {
            __typename: "ModelCreditPurchaseConnection",
            nextToken?: string | null,
          } | null,
          orders?:  {
            __typename: "ModelOrderConnection",
            nextToken?: string | null,
          } | null,
          stripeCustomerId?: string | null,
          owner?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        stripeCustomerId?: string | null,
        invoiceNumber?: string | null,
        invoiceId?: string | null,
        receiptNumber?: string | null,
        cart?:  {
          __typename: "Cart",
          id: string,
          createdAt: string,
          order?:  {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null,
          artOrders?:  {
            __typename: "ModelartOrderConnection",
            nextToken?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          updatedAt: string,
          cartOrderId?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        cost_taxes?: number | null,
        cost_shipping?: number | null,
        couponId?: string | null,
        coupon_amount_off?: number | null,
        coupon_name?: string | null,
        discountId?: string | null,
        discount_amount?: number | null,
        promotionID?: string | null,
        promotion_code?: string | null,
        fulfillment_tracking_id?: string | null,
        fulfillment_method?: string | null,
        fulfillment_status?: string | null,
        fulfillment_createdAt?: string | null,
        fulfillment_updatedAt?: string | null,
        fulfillment_completedAt?: string | null,
        billing_name?: string | null,
        billing_address?: string | null,
        billing_address2?: string | null,
        billing_city?: string | null,
        billing_state?: string | null,
        billing_zip?: string | null,
        billing_country?: string | null,
        shipping_name?: string | null,
        shipping_address?: string | null,
        shipping_address2?: string | null,
        shipping_city?: string | null,
        shipping_state?: string | null,
        shipping_zip?: string | null,
        shipping_country?: string | null,
        shipping_phone?: string | null,
        notes?: string | null,
        vendor?: string | null,
        order_source?: string | null,
        currency?: string | null,
        cancel?: boolean | null,
        updatedAt: string,
        userOrdersId?: string | null,
        orderCartId?: string | null,
      } | null,
      artOrders?:  {
        __typename: "ModelartOrderConnection",
        items:  Array< {
          __typename: "artOrder",
          id: string,
          createdAt: string,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          orderID?: string | null,
          art?:  {
            __typename: "Art",
            id: string,
            userId: string,
            createdAt: string,
            title?: string | null,
            inputImage?: string | null,
            prompt?: string | null,
            revisedPrompt?: string | null,
            subject?: string | null,
            subjectText?: string | null,
            subOption?: string | null,
            styles?: string | null,
            stylesText?: string | null,
            color?: string | null,
            colorText?: string | null,
            medium?: string | null,
            mediumText?: string | null,
            model?: string | null,
            feeling?: string | null,
            feelingText?: string | null,
            like?: boolean | null,
            approve?: boolean | null,
            deleted?: boolean | null,
            updatedAt: string,
          } | null,
          email: string,
          file?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          dpi?: number | null,
          length?: number | null,
          width?: number | null,
          resolution_length?: number | null,
          resolution_width?: number | null,
          paper?: string | null,
          frame?: boolean | null,
          moulding?: string | null,
          moulding_finish?: string | null,
          mount?: string | null,
          total?: number | null,
          tax?: number | null,
          updatedAt: string,
          cartArtOrdersId?: string | null,
          artOrderArtId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      email: string,
      status?: string | null,
      cost_total?: number | null,
      updatedAt: string,
      cartOrderId?: string | null,
    } | null,
    email: string,
    status?: string | null,
    cost_total?: number | null,
    cost_taxes?: number | null,
    cost_shipping?: number | null,
    couponId?: string | null,
    coupon_amount_off?: number | null,
    coupon_name?: string | null,
    discountId?: string | null,
    discount_amount?: number | null,
    promotionID?: string | null,
    promotion_code?: string | null,
    fulfillment_tracking_id?: string | null,
    fulfillment_method?: string | null,
    fulfillment_status?: string | null,
    fulfillment_createdAt?: string | null,
    fulfillment_updatedAt?: string | null,
    fulfillment_completedAt?: string | null,
    billing_name?: string | null,
    billing_address?: string | null,
    billing_address2?: string | null,
    billing_city?: string | null,
    billing_state?: string | null,
    billing_zip?: string | null,
    billing_country?: string | null,
    shipping_name?: string | null,
    shipping_address?: string | null,
    shipping_address2?: string | null,
    shipping_city?: string | null,
    shipping_state?: string | null,
    shipping_zip?: string | null,
    shipping_country?: string | null,
    shipping_phone?: string | null,
    notes?: string | null,
    vendor?: string | null,
    order_source?: string | null,
    currency?: string | null,
    cancel?: boolean | null,
    updatedAt: string,
    userOrdersId?: string | null,
    orderCartId?: string | null,
  } | null,
};

export type OnUpdateOrderSubscriptionVariables = {
  filter?: ModelSubscriptionOrderFilterInput | null,
};

export type OnUpdateOrderSubscription = {
  onUpdateOrder?:  {
    __typename: "Order",
    id: string,
    createdAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      username?: string | null,
      emailVerified?: boolean | null,
      identityId?: string | null,
      credits?: number | null,
      boughtCredits?: number | null,
      creditPurchases?:  {
        __typename: "ModelCreditPurchaseConnection",
        items:  Array< {
          __typename: "CreditPurchase",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          creditAmount?: number | null,
          checkoutSessionId: string,
          paymentIntentId?: string | null,
          owner?: string | null,
          updatedAt: string,
          userCreditPurchasesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      orders?:  {
        __typename: "ModelOrderConnection",
        items:  Array< {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    stripeCustomerId?: string | null,
    invoiceNumber?: string | null,
    invoiceId?: string | null,
    receiptNumber?: string | null,
    cart?:  {
      __typename: "Cart",
      id: string,
      createdAt: string,
      order?:  {
        __typename: "Order",
        id: string,
        createdAt: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          username?: string | null,
          emailVerified?: boolean | null,
          identityId?: string | null,
          credits?: number | null,
          boughtCredits?: number | null,
          creditPurchases?:  {
            __typename: "ModelCreditPurchaseConnection",
            nextToken?: string | null,
          } | null,
          orders?:  {
            __typename: "ModelOrderConnection",
            nextToken?: string | null,
          } | null,
          stripeCustomerId?: string | null,
          owner?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        stripeCustomerId?: string | null,
        invoiceNumber?: string | null,
        invoiceId?: string | null,
        receiptNumber?: string | null,
        cart?:  {
          __typename: "Cart",
          id: string,
          createdAt: string,
          order?:  {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null,
          artOrders?:  {
            __typename: "ModelartOrderConnection",
            nextToken?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          updatedAt: string,
          cartOrderId?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        cost_taxes?: number | null,
        cost_shipping?: number | null,
        couponId?: string | null,
        coupon_amount_off?: number | null,
        coupon_name?: string | null,
        discountId?: string | null,
        discount_amount?: number | null,
        promotionID?: string | null,
        promotion_code?: string | null,
        fulfillment_tracking_id?: string | null,
        fulfillment_method?: string | null,
        fulfillment_status?: string | null,
        fulfillment_createdAt?: string | null,
        fulfillment_updatedAt?: string | null,
        fulfillment_completedAt?: string | null,
        billing_name?: string | null,
        billing_address?: string | null,
        billing_address2?: string | null,
        billing_city?: string | null,
        billing_state?: string | null,
        billing_zip?: string | null,
        billing_country?: string | null,
        shipping_name?: string | null,
        shipping_address?: string | null,
        shipping_address2?: string | null,
        shipping_city?: string | null,
        shipping_state?: string | null,
        shipping_zip?: string | null,
        shipping_country?: string | null,
        shipping_phone?: string | null,
        notes?: string | null,
        vendor?: string | null,
        order_source?: string | null,
        currency?: string | null,
        cancel?: boolean | null,
        updatedAt: string,
        userOrdersId?: string | null,
        orderCartId?: string | null,
      } | null,
      artOrders?:  {
        __typename: "ModelartOrderConnection",
        items:  Array< {
          __typename: "artOrder",
          id: string,
          createdAt: string,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          orderID?: string | null,
          art?:  {
            __typename: "Art",
            id: string,
            userId: string,
            createdAt: string,
            title?: string | null,
            inputImage?: string | null,
            prompt?: string | null,
            revisedPrompt?: string | null,
            subject?: string | null,
            subjectText?: string | null,
            subOption?: string | null,
            styles?: string | null,
            stylesText?: string | null,
            color?: string | null,
            colorText?: string | null,
            medium?: string | null,
            mediumText?: string | null,
            model?: string | null,
            feeling?: string | null,
            feelingText?: string | null,
            like?: boolean | null,
            approve?: boolean | null,
            deleted?: boolean | null,
            updatedAt: string,
          } | null,
          email: string,
          file?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          dpi?: number | null,
          length?: number | null,
          width?: number | null,
          resolution_length?: number | null,
          resolution_width?: number | null,
          paper?: string | null,
          frame?: boolean | null,
          moulding?: string | null,
          moulding_finish?: string | null,
          mount?: string | null,
          total?: number | null,
          tax?: number | null,
          updatedAt: string,
          cartArtOrdersId?: string | null,
          artOrderArtId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      email: string,
      status?: string | null,
      cost_total?: number | null,
      updatedAt: string,
      cartOrderId?: string | null,
    } | null,
    email: string,
    status?: string | null,
    cost_total?: number | null,
    cost_taxes?: number | null,
    cost_shipping?: number | null,
    couponId?: string | null,
    coupon_amount_off?: number | null,
    coupon_name?: string | null,
    discountId?: string | null,
    discount_amount?: number | null,
    promotionID?: string | null,
    promotion_code?: string | null,
    fulfillment_tracking_id?: string | null,
    fulfillment_method?: string | null,
    fulfillment_status?: string | null,
    fulfillment_createdAt?: string | null,
    fulfillment_updatedAt?: string | null,
    fulfillment_completedAt?: string | null,
    billing_name?: string | null,
    billing_address?: string | null,
    billing_address2?: string | null,
    billing_city?: string | null,
    billing_state?: string | null,
    billing_zip?: string | null,
    billing_country?: string | null,
    shipping_name?: string | null,
    shipping_address?: string | null,
    shipping_address2?: string | null,
    shipping_city?: string | null,
    shipping_state?: string | null,
    shipping_zip?: string | null,
    shipping_country?: string | null,
    shipping_phone?: string | null,
    notes?: string | null,
    vendor?: string | null,
    order_source?: string | null,
    currency?: string | null,
    cancel?: boolean | null,
    updatedAt: string,
    userOrdersId?: string | null,
    orderCartId?: string | null,
  } | null,
};

export type OnDeleteOrderSubscriptionVariables = {
  filter?: ModelSubscriptionOrderFilterInput | null,
};

export type OnDeleteOrderSubscription = {
  onDeleteOrder?:  {
    __typename: "Order",
    id: string,
    createdAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      username?: string | null,
      emailVerified?: boolean | null,
      identityId?: string | null,
      credits?: number | null,
      boughtCredits?: number | null,
      creditPurchases?:  {
        __typename: "ModelCreditPurchaseConnection",
        items:  Array< {
          __typename: "CreditPurchase",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          creditAmount?: number | null,
          checkoutSessionId: string,
          paymentIntentId?: string | null,
          owner?: string | null,
          updatedAt: string,
          userCreditPurchasesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      orders?:  {
        __typename: "ModelOrderConnection",
        items:  Array< {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    stripeCustomerId?: string | null,
    invoiceNumber?: string | null,
    invoiceId?: string | null,
    receiptNumber?: string | null,
    cart?:  {
      __typename: "Cart",
      id: string,
      createdAt: string,
      order?:  {
        __typename: "Order",
        id: string,
        createdAt: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          username?: string | null,
          emailVerified?: boolean | null,
          identityId?: string | null,
          credits?: number | null,
          boughtCredits?: number | null,
          creditPurchases?:  {
            __typename: "ModelCreditPurchaseConnection",
            nextToken?: string | null,
          } | null,
          orders?:  {
            __typename: "ModelOrderConnection",
            nextToken?: string | null,
          } | null,
          stripeCustomerId?: string | null,
          owner?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        stripeCustomerId?: string | null,
        invoiceNumber?: string | null,
        invoiceId?: string | null,
        receiptNumber?: string | null,
        cart?:  {
          __typename: "Cart",
          id: string,
          createdAt: string,
          order?:  {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null,
          artOrders?:  {
            __typename: "ModelartOrderConnection",
            nextToken?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          updatedAt: string,
          cartOrderId?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        cost_taxes?: number | null,
        cost_shipping?: number | null,
        couponId?: string | null,
        coupon_amount_off?: number | null,
        coupon_name?: string | null,
        discountId?: string | null,
        discount_amount?: number | null,
        promotionID?: string | null,
        promotion_code?: string | null,
        fulfillment_tracking_id?: string | null,
        fulfillment_method?: string | null,
        fulfillment_status?: string | null,
        fulfillment_createdAt?: string | null,
        fulfillment_updatedAt?: string | null,
        fulfillment_completedAt?: string | null,
        billing_name?: string | null,
        billing_address?: string | null,
        billing_address2?: string | null,
        billing_city?: string | null,
        billing_state?: string | null,
        billing_zip?: string | null,
        billing_country?: string | null,
        shipping_name?: string | null,
        shipping_address?: string | null,
        shipping_address2?: string | null,
        shipping_city?: string | null,
        shipping_state?: string | null,
        shipping_zip?: string | null,
        shipping_country?: string | null,
        shipping_phone?: string | null,
        notes?: string | null,
        vendor?: string | null,
        order_source?: string | null,
        currency?: string | null,
        cancel?: boolean | null,
        updatedAt: string,
        userOrdersId?: string | null,
        orderCartId?: string | null,
      } | null,
      artOrders?:  {
        __typename: "ModelartOrderConnection",
        items:  Array< {
          __typename: "artOrder",
          id: string,
          createdAt: string,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          orderID?: string | null,
          art?:  {
            __typename: "Art",
            id: string,
            userId: string,
            createdAt: string,
            title?: string | null,
            inputImage?: string | null,
            prompt?: string | null,
            revisedPrompt?: string | null,
            subject?: string | null,
            subjectText?: string | null,
            subOption?: string | null,
            styles?: string | null,
            stylesText?: string | null,
            color?: string | null,
            colorText?: string | null,
            medium?: string | null,
            mediumText?: string | null,
            model?: string | null,
            feeling?: string | null,
            feelingText?: string | null,
            like?: boolean | null,
            approve?: boolean | null,
            deleted?: boolean | null,
            updatedAt: string,
          } | null,
          email: string,
          file?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          dpi?: number | null,
          length?: number | null,
          width?: number | null,
          resolution_length?: number | null,
          resolution_width?: number | null,
          paper?: string | null,
          frame?: boolean | null,
          moulding?: string | null,
          moulding_finish?: string | null,
          mount?: string | null,
          total?: number | null,
          tax?: number | null,
          updatedAt: string,
          cartArtOrdersId?: string | null,
          artOrderArtId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      email: string,
      status?: string | null,
      cost_total?: number | null,
      updatedAt: string,
      cartOrderId?: string | null,
    } | null,
    email: string,
    status?: string | null,
    cost_total?: number | null,
    cost_taxes?: number | null,
    cost_shipping?: number | null,
    couponId?: string | null,
    coupon_amount_off?: number | null,
    coupon_name?: string | null,
    discountId?: string | null,
    discount_amount?: number | null,
    promotionID?: string | null,
    promotion_code?: string | null,
    fulfillment_tracking_id?: string | null,
    fulfillment_method?: string | null,
    fulfillment_status?: string | null,
    fulfillment_createdAt?: string | null,
    fulfillment_updatedAt?: string | null,
    fulfillment_completedAt?: string | null,
    billing_name?: string | null,
    billing_address?: string | null,
    billing_address2?: string | null,
    billing_city?: string | null,
    billing_state?: string | null,
    billing_zip?: string | null,
    billing_country?: string | null,
    shipping_name?: string | null,
    shipping_address?: string | null,
    shipping_address2?: string | null,
    shipping_city?: string | null,
    shipping_state?: string | null,
    shipping_zip?: string | null,
    shipping_country?: string | null,
    shipping_phone?: string | null,
    notes?: string | null,
    vendor?: string | null,
    order_source?: string | null,
    currency?: string | null,
    cancel?: boolean | null,
    updatedAt: string,
    userOrdersId?: string | null,
    orderCartId?: string | null,
  } | null,
};

export type OnCreateCartSubscriptionVariables = {
  filter?: ModelSubscriptionCartFilterInput | null,
};

export type OnCreateCartSubscription = {
  onCreateCart?:  {
    __typename: "Cart",
    id: string,
    createdAt: string,
    order?:  {
      __typename: "Order",
      id: string,
      createdAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        username?: string | null,
        emailVerified?: boolean | null,
        identityId?: string | null,
        credits?: number | null,
        boughtCredits?: number | null,
        creditPurchases?:  {
          __typename: "ModelCreditPurchaseConnection",
          items:  Array< {
            __typename: "CreditPurchase",
            id: string,
            createdAt: string,
            creditAmount?: number | null,
            checkoutSessionId: string,
            paymentIntentId?: string | null,
            owner?: string | null,
            updatedAt: string,
            userCreditPurchasesId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        orders?:  {
          __typename: "ModelOrderConnection",
          items:  Array< {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        stripeCustomerId?: string | null,
        owner?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      stripeCustomerId?: string | null,
      invoiceNumber?: string | null,
      invoiceId?: string | null,
      receiptNumber?: string | null,
      cart?:  {
        __typename: "Cart",
        id: string,
        createdAt: string,
        order?:  {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null,
        artOrders?:  {
          __typename: "ModelartOrderConnection",
          items:  Array< {
            __typename: "artOrder",
            id: string,
            createdAt: string,
            orderID?: string | null,
            email: string,
            dpi?: number | null,
            length?: number | null,
            width?: number | null,
            resolution_length?: number | null,
            resolution_width?: number | null,
            paper?: string | null,
            frame?: boolean | null,
            moulding?: string | null,
            moulding_finish?: string | null,
            mount?: string | null,
            total?: number | null,
            tax?: number | null,
            updatedAt: string,
            cartArtOrdersId?: string | null,
            artOrderArtId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        updatedAt: string,
        cartOrderId?: string | null,
      } | null,
      email: string,
      status?: string | null,
      cost_total?: number | null,
      cost_taxes?: number | null,
      cost_shipping?: number | null,
      couponId?: string | null,
      coupon_amount_off?: number | null,
      coupon_name?: string | null,
      discountId?: string | null,
      discount_amount?: number | null,
      promotionID?: string | null,
      promotion_code?: string | null,
      fulfillment_tracking_id?: string | null,
      fulfillment_method?: string | null,
      fulfillment_status?: string | null,
      fulfillment_createdAt?: string | null,
      fulfillment_updatedAt?: string | null,
      fulfillment_completedAt?: string | null,
      billing_name?: string | null,
      billing_address?: string | null,
      billing_address2?: string | null,
      billing_city?: string | null,
      billing_state?: string | null,
      billing_zip?: string | null,
      billing_country?: string | null,
      shipping_name?: string | null,
      shipping_address?: string | null,
      shipping_address2?: string | null,
      shipping_city?: string | null,
      shipping_state?: string | null,
      shipping_zip?: string | null,
      shipping_country?: string | null,
      shipping_phone?: string | null,
      notes?: string | null,
      vendor?: string | null,
      order_source?: string | null,
      currency?: string | null,
      cancel?: boolean | null,
      updatedAt: string,
      userOrdersId?: string | null,
      orderCartId?: string | null,
    } | null,
    artOrders?:  {
      __typename: "ModelartOrderConnection",
      items:  Array< {
        __typename: "artOrder",
        id: string,
        createdAt: string,
        cart?:  {
          __typename: "Cart",
          id: string,
          createdAt: string,
          order?:  {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null,
          artOrders?:  {
            __typename: "ModelartOrderConnection",
            nextToken?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          updatedAt: string,
          cartOrderId?: string | null,
        } | null,
        orderID?: string | null,
        art?:  {
          __typename: "Art",
          id: string,
          userId: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          title?: string | null,
          inputImage?: string | null,
          s3Image?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          prompt?: string | null,
          revisedPrompt?: string | null,
          subject?: string | null,
          subjectText?: string | null,
          subOption?: string | null,
          styles?: string | null,
          stylesText?: string | null,
          color?: string | null,
          colorText?: string | null,
          medium?: string | null,
          mediumText?: string | null,
          model?: string | null,
          feeling?: string | null,
          feelingText?: string | null,
          like?: boolean | null,
          approve?: boolean | null,
          deleted?: boolean | null,
          updatedAt: string,
        } | null,
        email: string,
        file?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        dpi?: number | null,
        length?: number | null,
        width?: number | null,
        resolution_length?: number | null,
        resolution_width?: number | null,
        paper?: string | null,
        frame?: boolean | null,
        moulding?: string | null,
        moulding_finish?: string | null,
        mount?: string | null,
        total?: number | null,
        tax?: number | null,
        updatedAt: string,
        cartArtOrdersId?: string | null,
        artOrderArtId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    email: string,
    status?: string | null,
    cost_total?: number | null,
    updatedAt: string,
    cartOrderId?: string | null,
  } | null,
};

export type OnUpdateCartSubscriptionVariables = {
  filter?: ModelSubscriptionCartFilterInput | null,
};

export type OnUpdateCartSubscription = {
  onUpdateCart?:  {
    __typename: "Cart",
    id: string,
    createdAt: string,
    order?:  {
      __typename: "Order",
      id: string,
      createdAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        username?: string | null,
        emailVerified?: boolean | null,
        identityId?: string | null,
        credits?: number | null,
        boughtCredits?: number | null,
        creditPurchases?:  {
          __typename: "ModelCreditPurchaseConnection",
          items:  Array< {
            __typename: "CreditPurchase",
            id: string,
            createdAt: string,
            creditAmount?: number | null,
            checkoutSessionId: string,
            paymentIntentId?: string | null,
            owner?: string | null,
            updatedAt: string,
            userCreditPurchasesId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        orders?:  {
          __typename: "ModelOrderConnection",
          items:  Array< {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        stripeCustomerId?: string | null,
        owner?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      stripeCustomerId?: string | null,
      invoiceNumber?: string | null,
      invoiceId?: string | null,
      receiptNumber?: string | null,
      cart?:  {
        __typename: "Cart",
        id: string,
        createdAt: string,
        order?:  {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null,
        artOrders?:  {
          __typename: "ModelartOrderConnection",
          items:  Array< {
            __typename: "artOrder",
            id: string,
            createdAt: string,
            orderID?: string | null,
            email: string,
            dpi?: number | null,
            length?: number | null,
            width?: number | null,
            resolution_length?: number | null,
            resolution_width?: number | null,
            paper?: string | null,
            frame?: boolean | null,
            moulding?: string | null,
            moulding_finish?: string | null,
            mount?: string | null,
            total?: number | null,
            tax?: number | null,
            updatedAt: string,
            cartArtOrdersId?: string | null,
            artOrderArtId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        updatedAt: string,
        cartOrderId?: string | null,
      } | null,
      email: string,
      status?: string | null,
      cost_total?: number | null,
      cost_taxes?: number | null,
      cost_shipping?: number | null,
      couponId?: string | null,
      coupon_amount_off?: number | null,
      coupon_name?: string | null,
      discountId?: string | null,
      discount_amount?: number | null,
      promotionID?: string | null,
      promotion_code?: string | null,
      fulfillment_tracking_id?: string | null,
      fulfillment_method?: string | null,
      fulfillment_status?: string | null,
      fulfillment_createdAt?: string | null,
      fulfillment_updatedAt?: string | null,
      fulfillment_completedAt?: string | null,
      billing_name?: string | null,
      billing_address?: string | null,
      billing_address2?: string | null,
      billing_city?: string | null,
      billing_state?: string | null,
      billing_zip?: string | null,
      billing_country?: string | null,
      shipping_name?: string | null,
      shipping_address?: string | null,
      shipping_address2?: string | null,
      shipping_city?: string | null,
      shipping_state?: string | null,
      shipping_zip?: string | null,
      shipping_country?: string | null,
      shipping_phone?: string | null,
      notes?: string | null,
      vendor?: string | null,
      order_source?: string | null,
      currency?: string | null,
      cancel?: boolean | null,
      updatedAt: string,
      userOrdersId?: string | null,
      orderCartId?: string | null,
    } | null,
    artOrders?:  {
      __typename: "ModelartOrderConnection",
      items:  Array< {
        __typename: "artOrder",
        id: string,
        createdAt: string,
        cart?:  {
          __typename: "Cart",
          id: string,
          createdAt: string,
          order?:  {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null,
          artOrders?:  {
            __typename: "ModelartOrderConnection",
            nextToken?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          updatedAt: string,
          cartOrderId?: string | null,
        } | null,
        orderID?: string | null,
        art?:  {
          __typename: "Art",
          id: string,
          userId: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          title?: string | null,
          inputImage?: string | null,
          s3Image?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          prompt?: string | null,
          revisedPrompt?: string | null,
          subject?: string | null,
          subjectText?: string | null,
          subOption?: string | null,
          styles?: string | null,
          stylesText?: string | null,
          color?: string | null,
          colorText?: string | null,
          medium?: string | null,
          mediumText?: string | null,
          model?: string | null,
          feeling?: string | null,
          feelingText?: string | null,
          like?: boolean | null,
          approve?: boolean | null,
          deleted?: boolean | null,
          updatedAt: string,
        } | null,
        email: string,
        file?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        dpi?: number | null,
        length?: number | null,
        width?: number | null,
        resolution_length?: number | null,
        resolution_width?: number | null,
        paper?: string | null,
        frame?: boolean | null,
        moulding?: string | null,
        moulding_finish?: string | null,
        mount?: string | null,
        total?: number | null,
        tax?: number | null,
        updatedAt: string,
        cartArtOrdersId?: string | null,
        artOrderArtId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    email: string,
    status?: string | null,
    cost_total?: number | null,
    updatedAt: string,
    cartOrderId?: string | null,
  } | null,
};

export type OnDeleteCartSubscriptionVariables = {
  filter?: ModelSubscriptionCartFilterInput | null,
};

export type OnDeleteCartSubscription = {
  onDeleteCart?:  {
    __typename: "Cart",
    id: string,
    createdAt: string,
    order?:  {
      __typename: "Order",
      id: string,
      createdAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        username?: string | null,
        emailVerified?: boolean | null,
        identityId?: string | null,
        credits?: number | null,
        boughtCredits?: number | null,
        creditPurchases?:  {
          __typename: "ModelCreditPurchaseConnection",
          items:  Array< {
            __typename: "CreditPurchase",
            id: string,
            createdAt: string,
            creditAmount?: number | null,
            checkoutSessionId: string,
            paymentIntentId?: string | null,
            owner?: string | null,
            updatedAt: string,
            userCreditPurchasesId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        orders?:  {
          __typename: "ModelOrderConnection",
          items:  Array< {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        stripeCustomerId?: string | null,
        owner?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      stripeCustomerId?: string | null,
      invoiceNumber?: string | null,
      invoiceId?: string | null,
      receiptNumber?: string | null,
      cart?:  {
        __typename: "Cart",
        id: string,
        createdAt: string,
        order?:  {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null,
        artOrders?:  {
          __typename: "ModelartOrderConnection",
          items:  Array< {
            __typename: "artOrder",
            id: string,
            createdAt: string,
            orderID?: string | null,
            email: string,
            dpi?: number | null,
            length?: number | null,
            width?: number | null,
            resolution_length?: number | null,
            resolution_width?: number | null,
            paper?: string | null,
            frame?: boolean | null,
            moulding?: string | null,
            moulding_finish?: string | null,
            mount?: string | null,
            total?: number | null,
            tax?: number | null,
            updatedAt: string,
            cartArtOrdersId?: string | null,
            artOrderArtId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        updatedAt: string,
        cartOrderId?: string | null,
      } | null,
      email: string,
      status?: string | null,
      cost_total?: number | null,
      cost_taxes?: number | null,
      cost_shipping?: number | null,
      couponId?: string | null,
      coupon_amount_off?: number | null,
      coupon_name?: string | null,
      discountId?: string | null,
      discount_amount?: number | null,
      promotionID?: string | null,
      promotion_code?: string | null,
      fulfillment_tracking_id?: string | null,
      fulfillment_method?: string | null,
      fulfillment_status?: string | null,
      fulfillment_createdAt?: string | null,
      fulfillment_updatedAt?: string | null,
      fulfillment_completedAt?: string | null,
      billing_name?: string | null,
      billing_address?: string | null,
      billing_address2?: string | null,
      billing_city?: string | null,
      billing_state?: string | null,
      billing_zip?: string | null,
      billing_country?: string | null,
      shipping_name?: string | null,
      shipping_address?: string | null,
      shipping_address2?: string | null,
      shipping_city?: string | null,
      shipping_state?: string | null,
      shipping_zip?: string | null,
      shipping_country?: string | null,
      shipping_phone?: string | null,
      notes?: string | null,
      vendor?: string | null,
      order_source?: string | null,
      currency?: string | null,
      cancel?: boolean | null,
      updatedAt: string,
      userOrdersId?: string | null,
      orderCartId?: string | null,
    } | null,
    artOrders?:  {
      __typename: "ModelartOrderConnection",
      items:  Array< {
        __typename: "artOrder",
        id: string,
        createdAt: string,
        cart?:  {
          __typename: "Cart",
          id: string,
          createdAt: string,
          order?:  {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null,
          artOrders?:  {
            __typename: "ModelartOrderConnection",
            nextToken?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          updatedAt: string,
          cartOrderId?: string | null,
        } | null,
        orderID?: string | null,
        art?:  {
          __typename: "Art",
          id: string,
          userId: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          title?: string | null,
          inputImage?: string | null,
          s3Image?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          prompt?: string | null,
          revisedPrompt?: string | null,
          subject?: string | null,
          subjectText?: string | null,
          subOption?: string | null,
          styles?: string | null,
          stylesText?: string | null,
          color?: string | null,
          colorText?: string | null,
          medium?: string | null,
          mediumText?: string | null,
          model?: string | null,
          feeling?: string | null,
          feelingText?: string | null,
          like?: boolean | null,
          approve?: boolean | null,
          deleted?: boolean | null,
          updatedAt: string,
        } | null,
        email: string,
        file?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        dpi?: number | null,
        length?: number | null,
        width?: number | null,
        resolution_length?: number | null,
        resolution_width?: number | null,
        paper?: string | null,
        frame?: boolean | null,
        moulding?: string | null,
        moulding_finish?: string | null,
        mount?: string | null,
        total?: number | null,
        tax?: number | null,
        updatedAt: string,
        cartArtOrdersId?: string | null,
        artOrderArtId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    email: string,
    status?: string | null,
    cost_total?: number | null,
    updatedAt: string,
    cartOrderId?: string | null,
  } | null,
};

export type OnCreateArtOrderSubscriptionVariables = {
  filter?: ModelSubscriptionArtOrderFilterInput | null,
};

export type OnCreateArtOrderSubscription = {
  onCreateArtOrder?:  {
    __typename: "artOrder",
    id: string,
    createdAt: string,
    cart?:  {
      __typename: "Cart",
      id: string,
      createdAt: string,
      order?:  {
        __typename: "Order",
        id: string,
        createdAt: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          username?: string | null,
          emailVerified?: boolean | null,
          identityId?: string | null,
          credits?: number | null,
          boughtCredits?: number | null,
          creditPurchases?:  {
            __typename: "ModelCreditPurchaseConnection",
            nextToken?: string | null,
          } | null,
          orders?:  {
            __typename: "ModelOrderConnection",
            nextToken?: string | null,
          } | null,
          stripeCustomerId?: string | null,
          owner?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        stripeCustomerId?: string | null,
        invoiceNumber?: string | null,
        invoiceId?: string | null,
        receiptNumber?: string | null,
        cart?:  {
          __typename: "Cart",
          id: string,
          createdAt: string,
          order?:  {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null,
          artOrders?:  {
            __typename: "ModelartOrderConnection",
            nextToken?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          updatedAt: string,
          cartOrderId?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        cost_taxes?: number | null,
        cost_shipping?: number | null,
        couponId?: string | null,
        coupon_amount_off?: number | null,
        coupon_name?: string | null,
        discountId?: string | null,
        discount_amount?: number | null,
        promotionID?: string | null,
        promotion_code?: string | null,
        fulfillment_tracking_id?: string | null,
        fulfillment_method?: string | null,
        fulfillment_status?: string | null,
        fulfillment_createdAt?: string | null,
        fulfillment_updatedAt?: string | null,
        fulfillment_completedAt?: string | null,
        billing_name?: string | null,
        billing_address?: string | null,
        billing_address2?: string | null,
        billing_city?: string | null,
        billing_state?: string | null,
        billing_zip?: string | null,
        billing_country?: string | null,
        shipping_name?: string | null,
        shipping_address?: string | null,
        shipping_address2?: string | null,
        shipping_city?: string | null,
        shipping_state?: string | null,
        shipping_zip?: string | null,
        shipping_country?: string | null,
        shipping_phone?: string | null,
        notes?: string | null,
        vendor?: string | null,
        order_source?: string | null,
        currency?: string | null,
        cancel?: boolean | null,
        updatedAt: string,
        userOrdersId?: string | null,
        orderCartId?: string | null,
      } | null,
      artOrders?:  {
        __typename: "ModelartOrderConnection",
        items:  Array< {
          __typename: "artOrder",
          id: string,
          createdAt: string,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          orderID?: string | null,
          art?:  {
            __typename: "Art",
            id: string,
            userId: string,
            createdAt: string,
            title?: string | null,
            inputImage?: string | null,
            prompt?: string | null,
            revisedPrompt?: string | null,
            subject?: string | null,
            subjectText?: string | null,
            subOption?: string | null,
            styles?: string | null,
            stylesText?: string | null,
            color?: string | null,
            colorText?: string | null,
            medium?: string | null,
            mediumText?: string | null,
            model?: string | null,
            feeling?: string | null,
            feelingText?: string | null,
            like?: boolean | null,
            approve?: boolean | null,
            deleted?: boolean | null,
            updatedAt: string,
          } | null,
          email: string,
          file?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          dpi?: number | null,
          length?: number | null,
          width?: number | null,
          resolution_length?: number | null,
          resolution_width?: number | null,
          paper?: string | null,
          frame?: boolean | null,
          moulding?: string | null,
          moulding_finish?: string | null,
          mount?: string | null,
          total?: number | null,
          tax?: number | null,
          updatedAt: string,
          cartArtOrdersId?: string | null,
          artOrderArtId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      email: string,
      status?: string | null,
      cost_total?: number | null,
      updatedAt: string,
      cartOrderId?: string | null,
    } | null,
    orderID?: string | null,
    art?:  {
      __typename: "Art",
      id: string,
      userId: string,
      createdAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        username?: string | null,
        emailVerified?: boolean | null,
        identityId?: string | null,
        credits?: number | null,
        boughtCredits?: number | null,
        creditPurchases?:  {
          __typename: "ModelCreditPurchaseConnection",
          items:  Array< {
            __typename: "CreditPurchase",
            id: string,
            createdAt: string,
            creditAmount?: number | null,
            checkoutSessionId: string,
            paymentIntentId?: string | null,
            owner?: string | null,
            updatedAt: string,
            userCreditPurchasesId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        orders?:  {
          __typename: "ModelOrderConnection",
          items:  Array< {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        stripeCustomerId?: string | null,
        owner?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      title?: string | null,
      inputImage?: string | null,
      s3Image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      prompt?: string | null,
      revisedPrompt?: string | null,
      subject?: string | null,
      subjectText?: string | null,
      subOption?: string | null,
      styles?: string | null,
      stylesText?: string | null,
      color?: string | null,
      colorText?: string | null,
      medium?: string | null,
      mediumText?: string | null,
      model?: string | null,
      feeling?: string | null,
      feelingText?: string | null,
      like?: boolean | null,
      approve?: boolean | null,
      deleted?: boolean | null,
      updatedAt: string,
    } | null,
    email: string,
    file?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    dpi?: number | null,
    length?: number | null,
    width?: number | null,
    resolution_length?: number | null,
    resolution_width?: number | null,
    paper?: string | null,
    frame?: boolean | null,
    moulding?: string | null,
    moulding_finish?: string | null,
    mount?: string | null,
    total?: number | null,
    tax?: number | null,
    updatedAt: string,
    cartArtOrdersId?: string | null,
    artOrderArtId?: string | null,
  } | null,
};

export type OnUpdateArtOrderSubscriptionVariables = {
  filter?: ModelSubscriptionArtOrderFilterInput | null,
};

export type OnUpdateArtOrderSubscription = {
  onUpdateArtOrder?:  {
    __typename: "artOrder",
    id: string,
    createdAt: string,
    cart?:  {
      __typename: "Cart",
      id: string,
      createdAt: string,
      order?:  {
        __typename: "Order",
        id: string,
        createdAt: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          username?: string | null,
          emailVerified?: boolean | null,
          identityId?: string | null,
          credits?: number | null,
          boughtCredits?: number | null,
          creditPurchases?:  {
            __typename: "ModelCreditPurchaseConnection",
            nextToken?: string | null,
          } | null,
          orders?:  {
            __typename: "ModelOrderConnection",
            nextToken?: string | null,
          } | null,
          stripeCustomerId?: string | null,
          owner?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        stripeCustomerId?: string | null,
        invoiceNumber?: string | null,
        invoiceId?: string | null,
        receiptNumber?: string | null,
        cart?:  {
          __typename: "Cart",
          id: string,
          createdAt: string,
          order?:  {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null,
          artOrders?:  {
            __typename: "ModelartOrderConnection",
            nextToken?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          updatedAt: string,
          cartOrderId?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        cost_taxes?: number | null,
        cost_shipping?: number | null,
        couponId?: string | null,
        coupon_amount_off?: number | null,
        coupon_name?: string | null,
        discountId?: string | null,
        discount_amount?: number | null,
        promotionID?: string | null,
        promotion_code?: string | null,
        fulfillment_tracking_id?: string | null,
        fulfillment_method?: string | null,
        fulfillment_status?: string | null,
        fulfillment_createdAt?: string | null,
        fulfillment_updatedAt?: string | null,
        fulfillment_completedAt?: string | null,
        billing_name?: string | null,
        billing_address?: string | null,
        billing_address2?: string | null,
        billing_city?: string | null,
        billing_state?: string | null,
        billing_zip?: string | null,
        billing_country?: string | null,
        shipping_name?: string | null,
        shipping_address?: string | null,
        shipping_address2?: string | null,
        shipping_city?: string | null,
        shipping_state?: string | null,
        shipping_zip?: string | null,
        shipping_country?: string | null,
        shipping_phone?: string | null,
        notes?: string | null,
        vendor?: string | null,
        order_source?: string | null,
        currency?: string | null,
        cancel?: boolean | null,
        updatedAt: string,
        userOrdersId?: string | null,
        orderCartId?: string | null,
      } | null,
      artOrders?:  {
        __typename: "ModelartOrderConnection",
        items:  Array< {
          __typename: "artOrder",
          id: string,
          createdAt: string,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          orderID?: string | null,
          art?:  {
            __typename: "Art",
            id: string,
            userId: string,
            createdAt: string,
            title?: string | null,
            inputImage?: string | null,
            prompt?: string | null,
            revisedPrompt?: string | null,
            subject?: string | null,
            subjectText?: string | null,
            subOption?: string | null,
            styles?: string | null,
            stylesText?: string | null,
            color?: string | null,
            colorText?: string | null,
            medium?: string | null,
            mediumText?: string | null,
            model?: string | null,
            feeling?: string | null,
            feelingText?: string | null,
            like?: boolean | null,
            approve?: boolean | null,
            deleted?: boolean | null,
            updatedAt: string,
          } | null,
          email: string,
          file?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          dpi?: number | null,
          length?: number | null,
          width?: number | null,
          resolution_length?: number | null,
          resolution_width?: number | null,
          paper?: string | null,
          frame?: boolean | null,
          moulding?: string | null,
          moulding_finish?: string | null,
          mount?: string | null,
          total?: number | null,
          tax?: number | null,
          updatedAt: string,
          cartArtOrdersId?: string | null,
          artOrderArtId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      email: string,
      status?: string | null,
      cost_total?: number | null,
      updatedAt: string,
      cartOrderId?: string | null,
    } | null,
    orderID?: string | null,
    art?:  {
      __typename: "Art",
      id: string,
      userId: string,
      createdAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        username?: string | null,
        emailVerified?: boolean | null,
        identityId?: string | null,
        credits?: number | null,
        boughtCredits?: number | null,
        creditPurchases?:  {
          __typename: "ModelCreditPurchaseConnection",
          items:  Array< {
            __typename: "CreditPurchase",
            id: string,
            createdAt: string,
            creditAmount?: number | null,
            checkoutSessionId: string,
            paymentIntentId?: string | null,
            owner?: string | null,
            updatedAt: string,
            userCreditPurchasesId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        orders?:  {
          __typename: "ModelOrderConnection",
          items:  Array< {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        stripeCustomerId?: string | null,
        owner?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      title?: string | null,
      inputImage?: string | null,
      s3Image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      prompt?: string | null,
      revisedPrompt?: string | null,
      subject?: string | null,
      subjectText?: string | null,
      subOption?: string | null,
      styles?: string | null,
      stylesText?: string | null,
      color?: string | null,
      colorText?: string | null,
      medium?: string | null,
      mediumText?: string | null,
      model?: string | null,
      feeling?: string | null,
      feelingText?: string | null,
      like?: boolean | null,
      approve?: boolean | null,
      deleted?: boolean | null,
      updatedAt: string,
    } | null,
    email: string,
    file?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    dpi?: number | null,
    length?: number | null,
    width?: number | null,
    resolution_length?: number | null,
    resolution_width?: number | null,
    paper?: string | null,
    frame?: boolean | null,
    moulding?: string | null,
    moulding_finish?: string | null,
    mount?: string | null,
    total?: number | null,
    tax?: number | null,
    updatedAt: string,
    cartArtOrdersId?: string | null,
    artOrderArtId?: string | null,
  } | null,
};

export type OnDeleteArtOrderSubscriptionVariables = {
  filter?: ModelSubscriptionArtOrderFilterInput | null,
};

export type OnDeleteArtOrderSubscription = {
  onDeleteArtOrder?:  {
    __typename: "artOrder",
    id: string,
    createdAt: string,
    cart?:  {
      __typename: "Cart",
      id: string,
      createdAt: string,
      order?:  {
        __typename: "Order",
        id: string,
        createdAt: string,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          username?: string | null,
          emailVerified?: boolean | null,
          identityId?: string | null,
          credits?: number | null,
          boughtCredits?: number | null,
          creditPurchases?:  {
            __typename: "ModelCreditPurchaseConnection",
            nextToken?: string | null,
          } | null,
          orders?:  {
            __typename: "ModelOrderConnection",
            nextToken?: string | null,
          } | null,
          stripeCustomerId?: string | null,
          owner?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        stripeCustomerId?: string | null,
        invoiceNumber?: string | null,
        invoiceId?: string | null,
        receiptNumber?: string | null,
        cart?:  {
          __typename: "Cart",
          id: string,
          createdAt: string,
          order?:  {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null,
          artOrders?:  {
            __typename: "ModelartOrderConnection",
            nextToken?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          updatedAt: string,
          cartOrderId?: string | null,
        } | null,
        email: string,
        status?: string | null,
        cost_total?: number | null,
        cost_taxes?: number | null,
        cost_shipping?: number | null,
        couponId?: string | null,
        coupon_amount_off?: number | null,
        coupon_name?: string | null,
        discountId?: string | null,
        discount_amount?: number | null,
        promotionID?: string | null,
        promotion_code?: string | null,
        fulfillment_tracking_id?: string | null,
        fulfillment_method?: string | null,
        fulfillment_status?: string | null,
        fulfillment_createdAt?: string | null,
        fulfillment_updatedAt?: string | null,
        fulfillment_completedAt?: string | null,
        billing_name?: string | null,
        billing_address?: string | null,
        billing_address2?: string | null,
        billing_city?: string | null,
        billing_state?: string | null,
        billing_zip?: string | null,
        billing_country?: string | null,
        shipping_name?: string | null,
        shipping_address?: string | null,
        shipping_address2?: string | null,
        shipping_city?: string | null,
        shipping_state?: string | null,
        shipping_zip?: string | null,
        shipping_country?: string | null,
        shipping_phone?: string | null,
        notes?: string | null,
        vendor?: string | null,
        order_source?: string | null,
        currency?: string | null,
        cancel?: boolean | null,
        updatedAt: string,
        userOrdersId?: string | null,
        orderCartId?: string | null,
      } | null,
      artOrders?:  {
        __typename: "ModelartOrderConnection",
        items:  Array< {
          __typename: "artOrder",
          id: string,
          createdAt: string,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          orderID?: string | null,
          art?:  {
            __typename: "Art",
            id: string,
            userId: string,
            createdAt: string,
            title?: string | null,
            inputImage?: string | null,
            prompt?: string | null,
            revisedPrompt?: string | null,
            subject?: string | null,
            subjectText?: string | null,
            subOption?: string | null,
            styles?: string | null,
            stylesText?: string | null,
            color?: string | null,
            colorText?: string | null,
            medium?: string | null,
            mediumText?: string | null,
            model?: string | null,
            feeling?: string | null,
            feelingText?: string | null,
            like?: boolean | null,
            approve?: boolean | null,
            deleted?: boolean | null,
            updatedAt: string,
          } | null,
          email: string,
          file?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          dpi?: number | null,
          length?: number | null,
          width?: number | null,
          resolution_length?: number | null,
          resolution_width?: number | null,
          paper?: string | null,
          frame?: boolean | null,
          moulding?: string | null,
          moulding_finish?: string | null,
          mount?: string | null,
          total?: number | null,
          tax?: number | null,
          updatedAt: string,
          cartArtOrdersId?: string | null,
          artOrderArtId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      email: string,
      status?: string | null,
      cost_total?: number | null,
      updatedAt: string,
      cartOrderId?: string | null,
    } | null,
    orderID?: string | null,
    art?:  {
      __typename: "Art",
      id: string,
      userId: string,
      createdAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        username?: string | null,
        emailVerified?: boolean | null,
        identityId?: string | null,
        credits?: number | null,
        boughtCredits?: number | null,
        creditPurchases?:  {
          __typename: "ModelCreditPurchaseConnection",
          items:  Array< {
            __typename: "CreditPurchase",
            id: string,
            createdAt: string,
            creditAmount?: number | null,
            checkoutSessionId: string,
            paymentIntentId?: string | null,
            owner?: string | null,
            updatedAt: string,
            userCreditPurchasesId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        orders?:  {
          __typename: "ModelOrderConnection",
          items:  Array< {
            __typename: "Order",
            id: string,
            createdAt: string,
            stripeCustomerId?: string | null,
            invoiceNumber?: string | null,
            invoiceId?: string | null,
            receiptNumber?: string | null,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            cost_taxes?: number | null,
            cost_shipping?: number | null,
            couponId?: string | null,
            coupon_amount_off?: number | null,
            coupon_name?: string | null,
            discountId?: string | null,
            discount_amount?: number | null,
            promotionID?: string | null,
            promotion_code?: string | null,
            fulfillment_tracking_id?: string | null,
            fulfillment_method?: string | null,
            fulfillment_status?: string | null,
            fulfillment_createdAt?: string | null,
            fulfillment_updatedAt?: string | null,
            fulfillment_completedAt?: string | null,
            billing_name?: string | null,
            billing_address?: string | null,
            billing_address2?: string | null,
            billing_city?: string | null,
            billing_state?: string | null,
            billing_zip?: string | null,
            billing_country?: string | null,
            shipping_name?: string | null,
            shipping_address?: string | null,
            shipping_address2?: string | null,
            shipping_city?: string | null,
            shipping_state?: string | null,
            shipping_zip?: string | null,
            shipping_country?: string | null,
            shipping_phone?: string | null,
            notes?: string | null,
            vendor?: string | null,
            order_source?: string | null,
            currency?: string | null,
            cancel?: boolean | null,
            updatedAt: string,
            userOrdersId?: string | null,
            orderCartId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        stripeCustomerId?: string | null,
        owner?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      title?: string | null,
      inputImage?: string | null,
      s3Image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      prompt?: string | null,
      revisedPrompt?: string | null,
      subject?: string | null,
      subjectText?: string | null,
      subOption?: string | null,
      styles?: string | null,
      stylesText?: string | null,
      color?: string | null,
      colorText?: string | null,
      medium?: string | null,
      mediumText?: string | null,
      model?: string | null,
      feeling?: string | null,
      feelingText?: string | null,
      like?: boolean | null,
      approve?: boolean | null,
      deleted?: boolean | null,
      updatedAt: string,
    } | null,
    email: string,
    file?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    dpi?: number | null,
    length?: number | null,
    width?: number | null,
    resolution_length?: number | null,
    resolution_width?: number | null,
    paper?: string | null,
    frame?: boolean | null,
    moulding?: string | null,
    moulding_finish?: string | null,
    mount?: string | null,
    total?: number | null,
    tax?: number | null,
    updatedAt: string,
    cartArtOrdersId?: string | null,
    artOrderArtId?: string | null,
  } | null,
};

export type OnCreateArtSubscriptionVariables = {
  filter?: ModelSubscriptionArtFilterInput | null,
};

export type OnCreateArtSubscription = {
  onCreateArt?:  {
    __typename: "Art",
    id: string,
    userId: string,
    createdAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      username?: string | null,
      emailVerified?: boolean | null,
      identityId?: string | null,
      credits?: number | null,
      boughtCredits?: number | null,
      creditPurchases?:  {
        __typename: "ModelCreditPurchaseConnection",
        items:  Array< {
          __typename: "CreditPurchase",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          creditAmount?: number | null,
          checkoutSessionId: string,
          paymentIntentId?: string | null,
          owner?: string | null,
          updatedAt: string,
          userCreditPurchasesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      orders?:  {
        __typename: "ModelOrderConnection",
        items:  Array< {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    title?: string | null,
    inputImage?: string | null,
    s3Image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    prompt?: string | null,
    revisedPrompt?: string | null,
    subject?: string | null,
    subjectText?: string | null,
    subOption?: string | null,
    styles?: string | null,
    stylesText?: string | null,
    color?: string | null,
    colorText?: string | null,
    medium?: string | null,
    mediumText?: string | null,
    model?: string | null,
    feeling?: string | null,
    feelingText?: string | null,
    like?: boolean | null,
    approve?: boolean | null,
    deleted?: boolean | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateArtSubscriptionVariables = {
  filter?: ModelSubscriptionArtFilterInput | null,
};

export type OnUpdateArtSubscription = {
  onUpdateArt?:  {
    __typename: "Art",
    id: string,
    userId: string,
    createdAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      username?: string | null,
      emailVerified?: boolean | null,
      identityId?: string | null,
      credits?: number | null,
      boughtCredits?: number | null,
      creditPurchases?:  {
        __typename: "ModelCreditPurchaseConnection",
        items:  Array< {
          __typename: "CreditPurchase",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          creditAmount?: number | null,
          checkoutSessionId: string,
          paymentIntentId?: string | null,
          owner?: string | null,
          updatedAt: string,
          userCreditPurchasesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      orders?:  {
        __typename: "ModelOrderConnection",
        items:  Array< {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    title?: string | null,
    inputImage?: string | null,
    s3Image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    prompt?: string | null,
    revisedPrompt?: string | null,
    subject?: string | null,
    subjectText?: string | null,
    subOption?: string | null,
    styles?: string | null,
    stylesText?: string | null,
    color?: string | null,
    colorText?: string | null,
    medium?: string | null,
    mediumText?: string | null,
    model?: string | null,
    feeling?: string | null,
    feelingText?: string | null,
    like?: boolean | null,
    approve?: boolean | null,
    deleted?: boolean | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteArtSubscriptionVariables = {
  filter?: ModelSubscriptionArtFilterInput | null,
};

export type OnDeleteArtSubscription = {
  onDeleteArt?:  {
    __typename: "Art",
    id: string,
    userId: string,
    createdAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      username?: string | null,
      emailVerified?: boolean | null,
      identityId?: string | null,
      credits?: number | null,
      boughtCredits?: number | null,
      creditPurchases?:  {
        __typename: "ModelCreditPurchaseConnection",
        items:  Array< {
          __typename: "CreditPurchase",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          creditAmount?: number | null,
          checkoutSessionId: string,
          paymentIntentId?: string | null,
          owner?: string | null,
          updatedAt: string,
          userCreditPurchasesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      orders?:  {
        __typename: "ModelOrderConnection",
        items:  Array< {
          __typename: "Order",
          id: string,
          createdAt: string,
          user?:  {
            __typename: "User",
            id: string,
            email: string,
            username?: string | null,
            emailVerified?: boolean | null,
            identityId?: string | null,
            credits?: number | null,
            boughtCredits?: number | null,
            stripeCustomerId?: string | null,
            owner?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          stripeCustomerId?: string | null,
          invoiceNumber?: string | null,
          invoiceId?: string | null,
          receiptNumber?: string | null,
          cart?:  {
            __typename: "Cart",
            id: string,
            createdAt: string,
            email: string,
            status?: string | null,
            cost_total?: number | null,
            updatedAt: string,
            cartOrderId?: string | null,
          } | null,
          email: string,
          status?: string | null,
          cost_total?: number | null,
          cost_taxes?: number | null,
          cost_shipping?: number | null,
          couponId?: string | null,
          coupon_amount_off?: number | null,
          coupon_name?: string | null,
          discountId?: string | null,
          discount_amount?: number | null,
          promotionID?: string | null,
          promotion_code?: string | null,
          fulfillment_tracking_id?: string | null,
          fulfillment_method?: string | null,
          fulfillment_status?: string | null,
          fulfillment_createdAt?: string | null,
          fulfillment_updatedAt?: string | null,
          fulfillment_completedAt?: string | null,
          billing_name?: string | null,
          billing_address?: string | null,
          billing_address2?: string | null,
          billing_city?: string | null,
          billing_state?: string | null,
          billing_zip?: string | null,
          billing_country?: string | null,
          shipping_name?: string | null,
          shipping_address?: string | null,
          shipping_address2?: string | null,
          shipping_city?: string | null,
          shipping_state?: string | null,
          shipping_zip?: string | null,
          shipping_country?: string | null,
          shipping_phone?: string | null,
          notes?: string | null,
          vendor?: string | null,
          order_source?: string | null,
          currency?: string | null,
          cancel?: boolean | null,
          updatedAt: string,
          userOrdersId?: string | null,
          orderCartId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    title?: string | null,
    inputImage?: string | null,
    s3Image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    prompt?: string | null,
    revisedPrompt?: string | null,
    subject?: string | null,
    subjectText?: string | null,
    subOption?: string | null,
    styles?: string | null,
    stylesText?: string | null,
    color?: string | null,
    colorText?: string | null,
    medium?: string | null,
    mediumText?: string | null,
    model?: string | null,
    feeling?: string | null,
    feelingText?: string | null,
    like?: boolean | null,
    approve?: boolean | null,
    deleted?: boolean | null,
    updatedAt: string,
  } | null,
};

export type OnCreateGiftCardPurchaseSubscriptionVariables = {
  filter?: ModelSubscriptionGiftCardPurchaseFilterInput | null,
};

export type OnCreateGiftCardPurchaseSubscription = {
  onCreateGiftCardPurchase?:  {
    __typename: "GiftCardPurchase",
    id: string,
    createdAt: string,
    originalBalance?: number | null,
    couponId?: string | null,
    couponAmountOff?: number | null,
    couponCurrency?: string | null,
    couponName?: string | null,
    couponDuration?: string | null,
    couponMaxRedemptions?: number | null,
    promotionCode?: string | null,
    promotionID?: string | null,
    checkoutSessionId: string,
    paymentIntentId?: string | null,
    recipientEmail: string,
    customMessage?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateGiftCardPurchaseSubscriptionVariables = {
  filter?: ModelSubscriptionGiftCardPurchaseFilterInput | null,
};

export type OnUpdateGiftCardPurchaseSubscription = {
  onUpdateGiftCardPurchase?:  {
    __typename: "GiftCardPurchase",
    id: string,
    createdAt: string,
    originalBalance?: number | null,
    couponId?: string | null,
    couponAmountOff?: number | null,
    couponCurrency?: string | null,
    couponName?: string | null,
    couponDuration?: string | null,
    couponMaxRedemptions?: number | null,
    promotionCode?: string | null,
    promotionID?: string | null,
    checkoutSessionId: string,
    paymentIntentId?: string | null,
    recipientEmail: string,
    customMessage?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteGiftCardPurchaseSubscriptionVariables = {
  filter?: ModelSubscriptionGiftCardPurchaseFilterInput | null,
};

export type OnDeleteGiftCardPurchaseSubscription = {
  onDeleteGiftCardPurchase?:  {
    __typename: "GiftCardPurchase",
    id: string,
    createdAt: string,
    originalBalance?: number | null,
    couponId?: string | null,
    couponAmountOff?: number | null,
    couponCurrency?: string | null,
    couponName?: string | null,
    couponDuration?: string | null,
    couponMaxRedemptions?: number | null,
    promotionCode?: string | null,
    promotionID?: string | null,
    checkoutSessionId: string,
    paymentIntentId?: string | null,
    recipientEmail: string,
    customMessage?: string | null,
    updatedAt: string,
  } | null,
};
